function defineName$__$m(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
function extend$__(target, ext) {
  const descriptors2 = Object.getOwnPropertyDescriptors(ext);
  delete descriptors2.constructor;
  Object.defineProperties(target, descriptors2);
  return target;
}
class \u03A9BigInt {
  format(n) {
    if (!Number.isSafeInteger(n)) {
      throw "only integer";
    }
    let regex = new RegExp("^(\\d*?)(\\d{0," + n + "})$");
    let m = this.toString().match(regex);
    return "" + m.at(1).padStart(1, "0") + "." + m.at(2).padStart(n, "0");
  }
  static {
    defineName$__$m(this, "BigInt");
  }
}
extend$__(BigInt.prototype, \u03A9BigInt.prototype);
let encoder = new TextEncoder();
class \u03A9String {
  encode_hex(prefix = false) {
    let bytes2 = Array.from(encoder.encode(this.toString()));
    let hex = bytes2.map(function(c) {
      return c.toString(16).padStart(2, "0");
    }).join("");
    if (prefix) {
      return "0x" + hex;
    } else {
      return hex;
    }
  }
  decode_hex() {
    let g;
    let s = this.toString();
    if (g = s.match(/^(0x)?(?<digits>([0-9a-f]{2})*)$/i)?.groups) {
      return g.digits.match(/../g).map(function(e) {
        return String.fromCharCode(parseInt(e, 16));
      }).join("");
    } else {
      throw "bad hex string format";
    }
  }
  encode_key() {
    return this.toString();
  }
  static {
    defineName$__$m(this, "String");
  }
}
extend$__(String.prototype, \u03A9String.prototype);
function decimal_base(n) {
  switch (n) {
    case 9: {
      return 1000000000n;
    }
    case 8: {
      return 100000000n;
    }
    case 7: {
      return 10000000n;
    }
    case 6: {
      return 1000000n;
    }
    case 5: {
      return 100000n;
    }
    case 4: {
      return 10000n;
    }
    case 3: {
      return 1000n;
    }
    case 2: {
      return 100n;
    }
    case 1: {
      return 10n;
    }
    case 0: {
      return 1n;
    }
    default:
      throw "bad decimals";
  }
}
const ONE = decimal_base(9);
function mult(a, b, base = 9) {
  return a * b / decimal_base(base);
}
function div(a, b, base = 9) {
  return a * decimal_base(base) / b;
}
function min(a, b) {
  if (a < b) {
    return a;
  } else {
    return b;
  }
}
function max(a, b) {
  if (a > b) {
    return a;
  } else {
    return b;
  }
}
function apr_to_apy(apr) {
  return BigInt(((Math.exp(Number(apr) / 1e9) - 1) * 1e9).toFixed());
}
function defineName$__$l(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$k = Symbol.for("#__init__"), $__patch__$$k = Symbol.for("#__patch__");
const ENV = {
  LOCAL: "LOCAL",
  DEV: "DEV",
  TEST: "TEST",
  MAIN: "MAIN"
};
const presets = {
  [ENV.LOCAL]: {},
  [ENV.DEV]: {},
  [ENV.TEST]: {},
  [ENV.MAIN]: {}
};
const COMMON = {
  BORROW_SCALE: 100000000000n
};
for (let $12 = 0, $22 = Object.keys(presets), $32 = $22.length, _e, c; $12 < $32; $12++) {
  _e = $22[$12];
  c = presets[_e];
  Object.assign(c, COMMON);
}
Object.assign(presets[ENV.LOCAL], {
  NODE_URL: "http://127.0.0.1:8080/v1",
  BANK: "0xe10ac51e1e5ad00be995754d2bccfe9dfed8f06acc30b59a5f42d33fc2c73aa",
  ORACLE: "0xe10ac51e1e5ad00be995754d2bccfe9dfed8f06acc30b59a5f42d33fc2c73aa",
  WCOIN: "0xdcda47581b3a95e754b89d8c766a13eed1386e31c6922e4dd6a64102105b3654",
  LENDING: "0x8e9911bcfe433515b59d30fca071f9564559c56c1356d77a4b76a0381627604f",
  SWITCHBOARD: "0xacc047ae28960867c1a3e46dc6f01dfa405d8146e2329f153af2e07e11baad80"
});
Object.assign(presets[ENV.DEV], {
  NODE_URL: "https://fullnode.devnet.aptoslabs.com/v1/"
});
Object.assign(presets[ENV.TEST], {
  NODE_URL: "https://fullnode.testnet.aptoslabs.com/v1/",
  BANK: "0xb2401f338fab14770699d69a4f9c71a9835996829d5bdf6dc671cd42c40595ae",
  ORACLE: "0xb2401f338fab14770699d69a4f9c71a9835996829d5bdf6dc671cd42c40595ae",
  WCOIN: "0xcd7f4950f905ab357695a42a5fd221d60dfa098e1c0c128a6e33dd7b21be7e10",
  LENDING: "0xa588398d395153b656d8a3e0563323c84284568a27526fc2933e17e60f4e3537",
  SWITCHBOARD: "0xb91d3fef0eeb4e685dc85e739c7d3e2968784945be4424e92e2f86e2418bf271"
});
Object.assign(presets[ENV.MAIN], {
  NODE_URL: "https://fullnode.mainnet.aptoslabs.com/v1/",
  BANK: "0x4fd9964bbcfc08b430e28295d0316b1ef29aa9e0b313ab72c994a4c26ab5fc8f",
  ORACLE: "0x7b5089e2632ef06d90c6d3d6e243599dfc43fd226b65eb271263b8759bb3d2d",
  WCOIN: "0x9ba6f682515888681ed8cc1236383658fa54e63c45e5bae69e9086e6fe1dabf9",
  LENDING: "0x8b0dfdaeacddb7cab57747ce6b5f29d334e1c57bd5a4d41491493303b2d4d361",
  SWITCHBOARD: "0x7d7e436f0b2aafde60774efb26ccc432cf881b677aca7faaf2a01879bd19fb8"
});
class Config {
  [$__patch__$$k]($$ = {}) {
    var $4;
    ($4 = $$.env) !== void 0 && (this.env = $4);
    ($4 = $$.NODE_URL) !== void 0 && (this.NODE_URL = $4);
    ($4 = $$.BANK) !== void 0 && (this.BANK = $4);
    ($4 = $$.ORACLE) !== void 0 && (this.ORACLE = $4);
    ($4 = $$.WCOIN) !== void 0 && (this.WCOIN = $4);
    ($4 = $$.LENDING) !== void 0 && (this.LENDING = $4);
    ($4 = $$.SWITCHBOARD) !== void 0 && (this.SWITCHBOARD = $4);
    ($4 = $$.BORROW_SCALE) !== void 0 && (this.BORROW_SCALE = $4);
  }
  constructor($$ = null) {
    this[$__init__$$k]($$);
  }
  [$__init__$$k]($$ = null, deep = true) {
    this.env = $$ ? $$.env : void 0;
    this.NODE_URL = $$ ? $$.NODE_URL : void 0;
    this.BANK = $$ ? $$.BANK : void 0;
    this.ORACLE = $$ ? $$.ORACLE : void 0;
    this.WCOIN = $$ ? $$.WCOIN : void 0;
    this.LENDING = $$ ? $$.LENDING : void 0;
    this.SWITCHBOARD = $$ ? $$.SWITCHBOARD : void 0;
    this.BORROW_SCALE = $$ ? $$.BORROW_SCALE : void 0;
  }
  use(e) {
    var cfg2;
    if (cfg2 = presets[e]) {
      for (let $7 = this, $5 = 0, $6 = Object.keys($7), $9 = $6.length, k, v; $5 < $9; $5++) {
        k = $6[$5];
        v = $7[k];
        this[k], delete this[k];
      }
      Object.assign(this, cfg2);
      this.env = e;
      return console.debug("Use env", this.env);
    } else {
      return console.error("Not found env", e);
    }
  }
  static {
    defineName$__$l(this, "Config");
  }
}
const cfg = new Config();
function defineName$__$k(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$j = Symbol.for("#__init__"), $__patch__$$j = Symbol.for("#__patch__");
class CoinStore {
  [$__patch__$$j]($$ = {}) {
    var $12;
    ($12 = $$.coin_type) !== void 0 && (this.coin_type = $12);
    ($12 = $$.frozen) !== void 0 && (this.frozen = $12);
    ($12 = $$.value) !== void 0 && (this.value = $12);
    ($12 = $$.coin_info) !== void 0 && (this.coin_info = $12);
  }
  [$__init__$$j]($$ = null, deep = true) {
    this.coin_type = $$ ? $$.coin_type : void 0;
    this.frozen = $$ ? $$.frozen : void 0;
    this.value = $$ ? $$.value : void 0;
    this.coin_info = $$ ? $$.coin_info : void 0;
  }
  static type_name(coin_type) {
    return "0x1::coin::CoinStore<" + coin_type + ">";
  }
  static from_resource(res) {
    let g;
    if (g = res.type.match(this.resource_regex)?.groups) {
      let coin_store = new CoinStore(g.coin_type, res.data);
      return coin_store;
    }
  }
  constructor(coin_type, { coin, frozen }) {
    this[$__init__$$j]();
    this.coin_type = coin_type;
    this.value = BigInt(coin.value);
    this.frozen = frozen;
  }
  get formatted_value() {
    return this.value.format(this.coin_info?.info.decimals);
  }
  static {
    defineName$__$k(this, "CoinStore");
    this.resource_regex = /^0x1::coin::CoinStore<(?<coin_type>.*)>$/;
  }
}
function defineName$__$j(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$i = Symbol.for("#__init__"), $__patch__$$i = Symbol.for("#__patch__");
class TypeInfo {
  [$__patch__$$i]($$ = {}) {
    var $12;
    ($12 = $$.account_address) !== void 0 && (this.account_address = $12);
    ($12 = $$.module_name) !== void 0 && (this.module_name = $12);
    ($12 = $$.struct_name) !== void 0 && (this.struct_name = $12);
    ($12 = $$.type_args) !== void 0 && (this.type_args = $12);
  }
  constructor($$ = null) {
    this[$__init__$$i]($$);
  }
  [$__init__$$i]($$ = null, deep = true) {
    this.account_address = $$ ? $$.account_address : void 0;
    this.module_name = $$ ? $$.module_name : void 0;
    this.struct_name = $$ ? $$.struct_name : void 0;
    this.type_args = $$ ? $$.type_args : void 0;
  }
  static parse(type_str) {
    let g;
    if (g = type_str.match(this.type_regex)?.groups) {
      let type_info = new TypeInfo();
      type_info.account_address = g.address;
      type_info.module_name = g.module_name;
      type_info.struct_name = g.struct_name;
      type_info.type_args = g.type_args;
      return type_info;
    }
  }
  static from_resource({ account_address, module_name, struct_name, type_args }) {
    let type_info = new TypeInfo();
    type_info.account_address = account_address;
    type_info.module_name = module_name.decode_hex();
    type_info.struct_name = struct_name.decode_hex();
    type_info.type_args = type_args?.decode_hex?.();
    return type_info;
  }
  toString() {
    if (this.type_args) {
      return "" + this.account_address + "::" + this.module_name + "::" + this.struct_name + "<" + this.type_args + ">";
    } else {
      return "" + this.account_address + "::" + this.module_name + "::" + this.struct_name;
    }
  }
  encode_key() {
    let struct_name = this.type_args ? "" + this.struct_name + "<" + this.type_args + ">" : this.struct_name;
    return {
      account_address: this.account_address,
      module_name: this.module_name.encode_hex(),
      struct_name: struct_name.encode_hex()
    };
  }
  static {
    defineName$__$j(this, "TypeInfo");
    this.type_regex = /^(?<address>0x[1-9a-f][0-9a-f]*)::(?<module_name>\w+)::(?<struct_name>\w+)(?:<(?<type_args>.*)>)?$/;
  }
}
function defineName$__$i(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$h = Symbol.for("#__init__"), $__patch__$$h = Symbol.for("#__patch__");
class CoinInfo {
  [$__patch__$$h]($$ = {}) {
    var $12;
    ($12 = $$.info) !== void 0 && (this.info = $12);
    ($12 = $$.address) !== void 0 && (this.address = $12);
    ($12 = $$.coin_type) !== void 0 && (this.coin_type = $12);
    ($12 = $$.is_wcoin) !== void 0 && (this.is_wcoin = $12);
    ($12 = $$.underlying_type) !== void 0 && (this.underlying_type = $12);
    ($12 = $$.wrapped_type) !== void 0 && (this.wrapped_type = $12);
    ($12 = $$.oracle) !== void 0 && (this.oracle = $12);
  }
  [$__init__$$h]($$ = null, deep = true) {
    this.info = $$ ? $$.info : void 0;
    this.address = $$ ? $$.address : void 0;
    this.coin_type = $$ ? $$.coin_type : void 0;
    this.is_wcoin = $$ ? $$.is_wcoin : void 0;
    this.underlying_type = $$ ? $$.underlying_type : void 0;
    this.wrapped_type = $$ ? $$.wrapped_type : void 0;
    this.oracle = $$ ? $$.oracle : void 0;
  }
  static wcoin_regex() {
    return new RegExp("^" + cfg.BANK + "::vault::W<(?<coin_type>.*)>$");
  }
  static from_resource(res) {
    let g;
    if (g = res.type.match(this.resource_regex)?.groups) {
      let t = TypeInfo.parse(g.coin_type);
      let coin_info = new CoinInfo(t.account_address, g.coin_type, res.data);
      return coin_info;
    }
  }
  constructor(address, coin_type, info) {
    let g;
    this[$__init__$$h]();
    this.address = address;
    this.coin_type = coin_type;
    this.info = info;
    if (g = coin_type.match(CoinInfo.wcoin_regex())?.groups) {
      this.is_wcoin = true;
      this.underlying_type = g.coin_type;
    } else {
      this.is_wcoin = false;
      this.wrapped_type = "" + cfg.BANK + "::vault::W<" + coin_type + ">";
    }
  }
  get price() {
    return this.oracle?.price || 0n;
  }
  coin_value(amount) {
    let price;
    if (this.is_wcoin) {
      throw "Must be underlying coin type";
    }
    if (price = this.oracle?.price) {
      return mult(price, amount, this.info.decimals);
    } else {
      return 0n;
    }
  }
  coin_amount(value) {
    let price;
    if (this.is_wcoin) {
      throw "Must be underlying coin type";
    }
    if (price = this.oracle?.price) {
      return div(value, price, this.info.decimals);
    } else {
      return 0n;
    }
  }
  to_user_amount(amount) {
    return Number(amount?.format?.(this.info.decimals));
  }
  from_user_amount(user_amount) {
    return BigInt(Number(user_amount).toFixed(this.info.decimals).replace(".", ""));
  }
  static {
    defineName$__$i(this, "CoinInfo");
    this.resource_regex = /^0x1::coin::CoinInfo<(?<coin_type>.*)>$/;
  }
}
function defineName$__$h(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$g = Symbol.for("#__init__"), $__patch__$$g = Symbol.for("#__patch__");
class LedgerInfo {
  [$__patch__$$g]($$ = {}) {
    var $12;
    ($12 = $$.chain_id) !== void 0 && (this.chain_id = $12);
    ($12 = $$.epoch) !== void 0 && (this.epoch = $12);
    ($12 = $$.ledger_version) !== void 0 && (this.ledger_version = $12);
    ($12 = $$.oldest_ledger_version) !== void 0 && (this.oldest_ledger_version = $12);
    ($12 = $$.ledger_timestamp) !== void 0 && (this.ledger_timestamp = $12);
    ($12 = $$.node_role) !== void 0 && (this.node_role = $12);
    ($12 = $$.oldest_block_height) !== void 0 && (this.oldest_block_height = $12);
    ($12 = $$.block_height) !== void 0 && (this.block_height = $12);
  }
  [$__init__$$g]($$ = null, deep = true) {
    this.chain_id = $$ ? $$.chain_id : void 0;
    this.epoch = $$ ? $$.epoch : void 0;
    this.ledger_version = $$ ? $$.ledger_version : void 0;
    this.oldest_ledger_version = $$ ? $$.oldest_ledger_version : void 0;
    this.ledger_timestamp = $$ ? $$.ledger_timestamp : void 0;
    this.node_role = $$ ? $$.node_role : void 0;
    this.oldest_block_height = $$ ? $$.oldest_block_height : void 0;
    this.block_height = $$ ? $$.block_height : void 0;
  }
  constructor(info) {
    this[$__init__$$g]();
    this.chain_id = info.chain_id;
    this.epoch = BigInt(info.epoch);
    this.ledger_version = BigInt(info.ledger_version);
    this.oldest_ledger_version = BigInt(info.oldest_ledger_version);
    this.ledger_timestamp = BigInt(info.ledger_timestamp);
    this.node_role = info.node_role;
    this.oldest_block_height = BigInt(info.oldest_block_height);
    this.block_height = BigInt(info.block_height);
  }
  static {
    defineName$__$h(this, "LedgerInfo");
  }
}
function defineName$__$g(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$f = Symbol.for("#__init__"), $__patch__$$f = Symbol.for("#__patch__");
class Vault {
  [$__patch__$$f]($$ = {}) {
    var $12;
    ($12 = $$.coin_type) !== void 0 && (this.coin_type = $12);
    ($12 = $$.coins) !== void 0 && (this.coins = $12);
    ($12 = $$.coin_info) !== void 0 && (this.coin_info = $12);
    ($12 = $$.vault_state) !== void 0 && (this.vault_state = $12);
    ($12 = $$.oracle) !== void 0 && (this.oracle = $12);
  }
  [$__init__$$f]($$ = null, deep = true) {
    this.coin_type = $$ ? $$.coin_type : void 0;
    this.coins = $$ ? $$.coins : void 0;
    this.coin_info = $$ ? $$.coin_info : void 0;
    this.vault_state = $$ ? $$.vault_state : void 0;
    this.oracle = $$ ? $$.oracle : void 0;
  }
  static resource_regex() {
    return new RegExp("^" + cfg.BANK + "::vault::Vault<(?<coin_type>.*)>$");
  }
  static from_resource(res) {
    let g;
    if (g = res.type.match(this.resource_regex())?.groups) {
      return new Vault(g.coin_type, res.data);
    }
  }
  constructor(coin_type, data2) {
    this[$__init__$$f]();
    this.coin_type = coin_type;
    this.coins = BigInt(data2.coins.value);
  }
  wrapped_to_underlying(wamount) {
    if (typeof wamount == "bigint" && wamount > 0n) {
      if (this.vault_state.total_wcoins > 0n) {
        return wamount * this.unreserved_coins / this.vault_state.total_wcoins;
      } else {
        return wamount;
      }
    } else {
      return 0n;
    }
  }
  underlying_to_wrapped(amount) {
    if (typeof amount == "bigint" && amount > 0n) {
      let unreserved = this.unreserved_coins;
      if (unreserved > 0n) {
        return amount * this.vault_state.total_wcoins / unreserved;
      } else {
        return amount;
      }
    } else {
      return 0n;
    }
  }
  borrowed_to_underlying(scaled_borrowed_amount) {
    return scaled_borrowed_amount * this.current_interest_index / cfg.BORROW_SCALE;
  }
  underlying_to_borrowed(amount) {
    return amount * cfg.BORROW_SCALE / this.current_interest_index;
  }
  wcoin_value(wamount) {
    let amount = this.wrapped_to_underlying(wamount);
    return this.coin_info?.coin_value?.(amount);
  }
  debt_value(scaled_borrowed) {
    let amount = scaled_borrowed * this.current_interest_index / cfg.BORROW_SCALE;
    return this.coin_info?.coin_value?.(amount);
  }
  calc_apr(utilization) {
    return this.vault_state?.config.calc_apr(utilization) || 0n;
  }
  get price() {
    return this.oracle?.price || 0n;
  }
  get unreserved_coins() {
    let interest_index = this.current_interest_index;
    let borrowed = this.vault_state.scaled_borrowed * interest_index / cfg.BORROW_SCALE;
    return this.vault_state.coins + borrowed - this.vault_state.reserved_coins;
  }
  get current_utilization() {
    return this.calc_utilization(this.current_interest_index);
  }
  calc_utilization(interest_index) {
    let borrowed = this.vault_state.scaled_borrowed * interest_index / cfg.BORROW_SCALE;
    let total_coins = this.vault_state.coins + borrowed;
    if (total_coins > 0n) {
      return div(borrowed, total_coins);
    } else {
      return 0n;
    }
  }
  get current_borrow_apr() {
    return this.calc_apr(this.current_utilization);
  }
  get current_borrow_apy() {
    return apr_to_apy(this.current_borrow_apr);
  }
  with_system_fee(value) {
    let system_fee = this.vault_state?.config?.system_fee || 0n;
    return mult(value, ONE - system_fee);
  }
  get current_supply_apr() {
    let utilization = this.current_utilization;
    return this.with_system_fee(mult(utilization, this.calc_apr(utilization)));
  }
  get current_supply_apy() {
    let utilization = this.current_utilization;
    let apr = mult(utilization, this.calc_apr(utilization));
    return this.with_system_fee(apr_to_apy(apr));
  }
  get current_interest_index() {
    return this.interest_index_after(this.since_last_accrued_at);
  }
  get since_last_accrued_at() {
    let accrued_at;
    if (accrued_at = this.vault_state?.accrued_at) {
      return BigInt(Date.now()) / 1000n - accrued_at;
    } else {
      return 0n;
    }
  }
  interest_index_after(duration) {
    let last_interest_index = this.vault_state?.interest_index;
    if (!duration) {
      return last_interest_index;
    }
    let utilization = this.calc_utilization(last_interest_index);
    let apr = this.calc_apr(utilization);
    let apy_delta = Math.expm1(Number(apr) / 1e9) * 1e9;
    let years = div(duration, 31536000n);
    let interest_growth = mult(BigInt(apy_delta.toFixed()), years);
    let interest_index = mult(last_interest_index, ONE + interest_growth);
    return interest_index;
  }
  get available_coins() {
    return this.vault_state?.coins || 0n;
  }
  get liquidity() {
    if (this.vault_state) {
      return this.vault_state?.coins + this.vault_state?.reserved_coins;
    } else {
      return 0n;
    }
  }
  get total_underlying() {
    let wamount;
    if (wamount = this.vault_state?.total_wcoins) {
      return this.wrapped_to_underlying(wamount);
    } else {
      return 0n;
    }
  }
  get deposited_value() {
    if (this.vault_state?.total_wcoins && this.coin_info) {
      let underlying = this.wrapped_to_underlying(this.vault_state.total_wcoins);
      return this.coin_info.coin_value(underlying);
    } else {
      return 0n;
    }
  }
  get locked_value() {
    if (this.coin_info && this.liquidity) {
      return this.coin_info.coin_value(this.liquidity);
    } else {
      return 0n;
    }
  }
  get total_borrowed() {
    if (this.vault_state?.scaled_borrowed) {
      return this.borrowed_to_underlying(this.vault_state.scaled_borrowed);
    } else {
      return 0n;
    }
  }
  get borrowed_value() {
    if (this.vault_state?.scaled_borrowed && this.coin_info) {
      let borrowed = this.borrowed_to_underlying(this.vault_state.scaled_borrowed);
      return this.coin_info.coin_value(borrowed);
    } else {
      return 0n;
    }
  }
  static {
    defineName$__$g(this, "Vault");
  }
}
function defineName$__$f(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$e = Symbol.for("#__init__"), $__patch__$$e = Symbol.for("#__patch__");
class BorrowCap {
  [$__patch__$$e]($$ = {}) {
    var $12;
    ($12 = $$.coin_type) !== void 0 && (this.coin_type = $12);
    ($12 = $$.borrower) !== void 0 && (this.borrower = $12);
    ($12 = $$.borrow_fee) !== void 0 && (this.borrow_fee = $12);
    ($12 = $$.borrow_limit) !== void 0 && (this.borrow_limit = $12);
    ($12 = $$.scaled_borrowed) !== void 0 && (this.scaled_borrowed = $12);
    ($12 = $$.temporary) !== void 0 && (this.temporary = $12);
  }
  [$__init__$$e]($$ = null, deep = true) {
    this.coin_type = $$ ? $$.coin_type : void 0;
    this.borrower = $$ ? $$.borrower : void 0;
    this.borrow_fee = $$ ? $$.borrow_fee : void 0;
    this.borrow_limit = $$ ? $$.borrow_limit : void 0;
    this.scaled_borrowed = $$ ? $$.scaled_borrowed : void 0;
    this.temporary = $$ ? $$.temporary : void 0;
  }
  constructor(coin_type, data2) {
    this[$__init__$$e]();
    this.coin_type = coin_type;
    this.borrower = data2.borrower;
    this.borrow_fee = BigInt(data2.borrow_fee);
    this.borrow_limit = BigInt(data2.borrow_limit);
    this.scaled_borrowed = BigInt(data2.scaled_borrowed);
    this.temporary = data2.temporary;
  }
  static {
    defineName$__$f(this, "BorrowCap");
  }
}
function defineName$__$e(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$d = Symbol.for("#__init__"), $__patch__$$d = Symbol.for("#__patch__");
class LendingConfig {
  [$__patch__$$d]($$ = {}) {
    var $12;
    ($12 = $$.decimals) !== void 0 && (this.decimals = $12);
    ($12 = $$.asset_factor) !== void 0 && (this.asset_factor = $12);
    ($12 = $$.debt_factor) !== void 0 && (this.debt_factor = $12);
    ($12 = $$.liquidation_threshold) !== void 0 && (this.liquidation_threshold = $12);
    ($12 = $$.liquidation_factor) !== void 0 && (this.liquidation_factor = $12);
    ($12 = $$.user_borrow_limit) !== void 0 && (this.user_borrow_limit = $12);
    ($12 = $$.pledge_limit) !== void 0 && (this.pledge_limit = $12);
    ($12 = $$.user_pledge_limit) !== void 0 && (this.user_pledge_limit = $12);
  }
  [$__init__$$d]($$ = null, deep = true) {
    this.decimals = $$ ? $$.decimals : void 0;
    this.asset_factor = $$ ? $$.asset_factor : void 0;
    this.debt_factor = $$ ? $$.debt_factor : void 0;
    this.liquidation_threshold = $$ ? $$.liquidation_threshold : void 0;
    this.liquidation_factor = $$ ? $$.liquidation_factor : void 0;
    this.user_borrow_limit = $$ ? $$.user_borrow_limit : void 0;
    this.pledge_limit = $$ ? $$.pledge_limit : void 0;
    this.user_pledge_limit = $$ ? $$.user_pledge_limit : void 0;
  }
  constructor(res_data) {
    this[$__init__$$d]();
    this.decimals = Number(res_data.decimals);
    this.asset_factor = BigInt(res_data.asset_factor);
    this.debt_factor = BigInt(res_data.debt_factor);
    this.liquidation_threshold = BigInt(res_data.liquidation_threshold);
    this.liquidation_factor = BigInt(res_data.liquidation_factor);
    this.user_borrow_limit = BigInt(res_data.user_borrow_limit);
    this.pledge_limit = BigInt(res_data.pledge_limit);
    this.user_pledge_limit = BigInt(res_data.user_pledge_limit);
  }
  static {
    defineName$__$e(this, "LendingConfig");
  }
}
function defineName$__$d(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$c = Symbol.for("#__init__"), $__patch__$$c = Symbol.for("#__patch__");
class LendingPool {
  [$__patch__$$c]($$ = {}) {
    var $12;
    ($12 = $$.coin_type) !== void 0 && (this.coin_type = $12);
    ($12 = $$.borrow_cap) !== void 0 && (this.borrow_cap = $12);
    ($12 = $$.locked_coins) !== void 0 && (this.locked_coins = $12);
    ($12 = $$.total_borrowed) !== void 0 && (this.total_borrowed = $12);
    ($12 = $$.vault) !== void 0 && (this.vault = $12);
    ($12 = $$.coin_info) !== void 0 && (this.coin_info = $12);
    ($12 = $$.config) !== void 0 && (this.config = $12);
  }
  [$__init__$$c]($$ = null, deep = true) {
    this.coin_type = $$ ? $$.coin_type : void 0;
    this.borrow_cap = $$ ? $$.borrow_cap : void 0;
    this.locked_coins = $$ ? $$.locked_coins : void 0;
    this.total_borrowed = $$ ? $$.total_borrowed : void 0;
    this.vault = $$ ? $$.vault : void 0;
    this.coin_info = $$ ? $$.coin_info : void 0;
    this.config = $$ ? $$.config : void 0;
  }
  static get address() {
    return cfg.LENDING;
  }
  static type_name(coin_type) {
    return "" + cfg.LENDING + "::lending::Pool<" + coin_type + ">";
  }
  static resource_regex() {
    return new RegExp("^" + cfg.LENDING + "::lending::Pool<(?<coin_type>.*)>$");
  }
  static from_resource(res) {
    let g;
    if (g = res.type.match(this.resource_regex())?.groups) {
      let pool = new LendingPool(g.coin_type, res.data);
      return pool;
    }
  }
  constructor(coin_type, { borrow_cap, total_borrowed, locked_assets: { value } }) {
    this[$__init__$$c]();
    this.coin_type = coin_type;
    this.locked_coins = BigInt(value);
    this.borrow_cap = new BorrowCap(coin_type, borrow_cap);
    this.total_borrowed = BigInt(total_borrowed);
  }
  get locked_value() {
    return this.vault?.wcoin_value?.(this.locked_coins) || 0n;
  }
  real_asset_value(vasset_value) {
    if (this.config) {
      return div(vasset_value, this.config.asset_factor);
    } else {
      return 0n;
    }
  }
  real_debt_value(vdebt_value) {
    if (this.config) {
      return div(vdebt_value, this.config.debt_factor);
    } else {
      return 0n;
    }
  }
  virtual_asset_value(asset_value) {
    if (this.config) {
      return mult(asset_value, this.config.asset_factor);
    } else {
      return 0n;
    }
  }
  max_virtual_debt_value(asset_value) {
    if (this.config) {
      return mult(asset_value, this.config.liquidation_threshold);
    } else {
      return 0n;
    }
  }
  virtual_debt_value(debt_value) {
    if (this.config) {
      return mult(debt_value, this.config.debt_factor);
    } else {
      return 0n;
    }
  }
  amount_without_fee(value) {
    if (this.borrow_cap) {
      return div(value, this.borrow_cap.borrow_fee + 1000000000n);
    } else {
      return value;
    }
  }
  static {
    defineName$__$d(this, "LendingPool");
  }
}
function defineName$__$c(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
function iter$__$1(a) {
  let v;
  return a ? (v = a.toIterable) ? v.call(a) : a : a;
}
function inheritClass$__(cls) {
  Object.getPrototypeOf(cls.prototype).constructor?.inherited?.(cls);
}
const $__init__$$b = Symbol.for("#__init__"), $__patch__$$b = Symbol.for("#__patch__"), $__initor__$ = Symbol.for("#__initor__"), $__inited__$ = Symbol.for("#__inited__"), $__hooks__$ = Symbol.for("#__hooks__");
var $1 = Symbol(), $2 = Symbol(), $3 = Symbol();
class Asset {
  [$__patch__$$b]($$ = {}) {
    var $4;
    ($4 = $$.coin_type) !== void 0 && (this.coin_type = $4);
    ($4 = $$.amount) !== void 0 && (this.amount = $4);
    ($4 = $$.vault) !== void 0 && (this.vault = $4);
    ($4 = $$.pool) !== void 0 && (this.pool = $4);
  }
  [$__init__$$b]($$ = null, deep = true) {
    this.coin_type = $$ ? $$.coin_type : void 0;
    this.amount = $$ ? $$.amount : void 0;
    this.vault = $$ ? $$.vault : void 0;
    this.pool = $$ ? $$.pool : void 0;
  }
  constructor(coin_type, amount) {
    this[$__init__$$b]();
    this.coin_type = coin_type;
    this.amount = amount;
  }
  get underlying_amount() {
    return this.vault?.wrapped_to_underlying?.(this.amount) || 0n;
  }
  get value() {
    return this.vault?.wcoin_value?.(this.amount) || 0n;
  }
  get virtual_value() {
    return this.pool?.virtual_asset_value?.(this.value) || 0n;
  }
  get max_virtual_debt_value() {
    return this.pool?.max_virtual_debt_value?.(this.value) || 0n;
  }
  static {
    defineName$__$c(this, "Asset");
  }
}
class Debt {
  [$__patch__$$b]($$ = {}) {
    var $5;
    ($5 = $$.coin_type) !== void 0 && (this.coin_type = $5);
    ($5 = $$.amount) !== void 0 && (this.amount = $5);
    ($5 = $$.vault) !== void 0 && (this.vault = $5);
    ($5 = $$.pool) !== void 0 && (this.pool = $5);
  }
  [$__init__$$b]($$ = null, deep = true) {
    this.coin_type = $$ ? $$.coin_type : void 0;
    this.amount = $$ ? $$.amount : void 0;
    this.vault = $$ ? $$.vault : void 0;
    this.pool = $$ ? $$.pool : void 0;
  }
  constructor(coin_type, amount) {
    this[$__init__$$b]();
    this.coin_type = coin_type;
    this.amount = amount;
  }
  get underlying_amount() {
    return this.vault?.borrowed_to_underlying?.(this.amount) || 0n;
  }
  get value() {
    return this.vault?.debt_value?.(this.amount) || 0n;
  }
  get virtual_value() {
    return this.pool?.virtual_debt_value?.(this.value) || 0n;
  }
  static {
    defineName$__$c(this, "Debt");
  }
}
class Balance {
  [$__patch__$$b]($$ = {}) {
    var $6;
    ($6 = $$.assets) !== void 0 && (this.assets = $6);
    ($6 = $$.debts) !== void 0 && (this.debts = $6);
  }
  [$__init__$$b]($$ = null, deep = true) {
    var $7;
    this.assets = $$ && ($7 = $$.assets) !== void 0 ? $7 : [];
    this.debts = $$ && ($7 = $$.debts) !== void 0 ? $7 : [];
  }
  static type_name() {
    return "" + cfg.LENDING + "::lending::Balance";
  }
  static resource_regex() {
    return new RegExp("^" + this.type_name() + "$");
  }
  static from_resource(res) {
    if (res.type.match(this.resource_regex())) {
      return new Balance(res.data);
    }
  }
  constructor(data2) {
    this[$__init__$$b]();
    for (let $8 = 0, $9 = iter$__$1(data2.assets), $10 = $9.length; $8 < $10; $8++) {
      let { coin_type, wcoin_amount } = $9[$8];
      let type_info = TypeInfo.from_resource(coin_type);
      let asset = new Asset(type_info.toString(), BigInt(wcoin_amount));
      this.assets.push(asset);
    }
    for (let $11 = 0, $12 = iter$__$1(data2.debts), $13 = $12.length; $11 < $13; $11++) {
      let { coin_type, borrow_amount } = $12[$11];
      let type_info = TypeInfo.from_resource(coin_type);
      let debt = new Debt(type_info.toString(), BigInt(borrow_amount));
      this.debts.push(debt);
    }
  }
  delta_clone() {
    return new BalanceDelta(this);
  }
  get total_assets_value() {
    return this.assets.map(function(a) {
      return a.value;
    }).reduce(function(x, y) {
      return x + y;
    }, 0n);
  }
  get total_debts_value() {
    return this.debts.map(function(d) {
      return d.value;
    }).reduce(function(x, y) {
      return x + y;
    }, 0n);
  }
  get total_vassets_value() {
    return this.assets.map(function(a) {
      return a.virtual_value;
    }).reduce(function(x, y) {
      return x + y;
    }, 0n);
  }
  get max_vdebts_value() {
    return this.assets.map(function(a) {
      return a.max_virtual_debt_value;
    }).reduce(function(x, y) {
      return x + y;
    }, 0n);
  }
  get total_vdebts_value() {
    return this.debts.map(function(d) {
      return d.virtual_value;
    }).reduce(function(x, y) {
      return x + y;
    }, 0n);
  }
  get risk_index() {
    let max_vdebts;
    if (max_vdebts = this.max_vdebts_value) {
      return div(this.total_vdebts_value, max_vdebts);
    } else {
      return 0n;
    }
  }
  get_asset(asset_coin_type) {
    return this.assets.find(function({ coin_type }) {
      return coin_type == asset_coin_type;
    });
  }
  get_debt(debt_coin_type) {
    return this.debts.find(function({ coin_type }) {
      return coin_type == debt_coin_type;
    });
  }
  static {
    defineName$__$c(this, "Balance");
  }
}
class AssetDelta extends Asset {
  [$__patch__$$b]($$ = {}) {
    var $14;
    super[$__patch__$$b] && super[$__patch__$$b]($$);
    ($14 = $$.delta_amount) !== void 0 && (this.delta_amount = $14);
  }
  [$__init__$$b]($$ = null, deep = true) {
    var $15;
    deep && super[$__init__$$b] && super[$__init__$$b](...arguments);
    this.delta_amount = $$ && ($15 = $$.delta_amount) !== void 0 ? $15 : 0n;
  }
  constructor(asset) {
    super(asset.coin_type, asset.amount);
    this.vault = asset.vault;
    this.pool = asset.pool;
    this[$__initor__$] === $1 && (this[$__hooks__$] && this[$__hooks__$].inited(this), this[$__inited__$] && this[$__inited__$]());
  }
  get underlying_amount() {
    return max(this.vault?.wrapped_to_underlying?.(this.amount) + this.delta_amount, 0n) || 0n;
  }
  get value() {
    return this.vault?.coin_info?.coin_value?.(this.underlying_amount) || 0n;
  }
  static {
    this.prototype[$__initor__$] = $1;
    defineName$__$c(this, "AssetDelta");
    inheritClass$__(this);
  }
}
class DebtDelta extends Debt {
  [$__patch__$$b]($$ = {}) {
    var $16;
    super[$__patch__$$b] && super[$__patch__$$b]($$);
    ($16 = $$.delta_amount) !== void 0 && (this.delta_amount = $16);
  }
  [$__init__$$b]($$ = null, deep = true) {
    var $17;
    deep && super[$__init__$$b] && super[$__init__$$b](...arguments);
    this.delta_amount = $$ && ($17 = $$.delta_amount) !== void 0 ? $17 : 0n;
  }
  constructor(debt) {
    super(debt.coin_type, debt.amount);
    this.vault = debt.vault;
    this.pool = debt.pool;
    this[$__initor__$] === $2 && (this[$__hooks__$] && this[$__hooks__$].inited(this), this[$__inited__$] && this[$__inited__$]());
  }
  get underlying_amount() {
    return max(this.vault?.borrowed_to_underlying?.(this.amount) + this.delta_amount, 0n) || 0n;
  }
  get value() {
    return this.vault?.coin_info?.coin_value?.(this.underlying_amount) || 0n;
  }
  static {
    this.prototype[$__initor__$] = $2;
    defineName$__$c(this, "DebtDelta");
    inheritClass$__(this);
  }
}
class BalanceDelta extends Balance {
  constructor(balance) {
    super({ assets: [], debts: [] });
    for (let $18 = 0, $19 = iter$__$1(balance.assets), $20 = $19.length; $18 < $20; $18++) {
      let asset = $19[$18];
      this.assets.push(new AssetDelta(asset));
    }
    for (let $21 = 0, $22 = iter$__$1(balance.debts), $23 = $22.length; $21 < $23; $21++) {
      let debt = $22[$21];
      this.debts.push(new DebtDelta(debt));
    }
    this[$__initor__$] === $3 && (this[$__hooks__$] && this[$__hooks__$].inited(this), this[$__inited__$] && this[$__inited__$]());
  }
  static init_zero(pools) {
    let balance = new Balance({ assets: [], debts: [] });
    for (let $24 = 0, $25 = Object.keys(pools), $26 = $25.length, coin_type, pool; $24 < $26; $24++) {
      coin_type = $25[$24];
      pool = pools[coin_type];
      let asset = new Asset(coin_type, 0n);
      asset.vault = pool.vault;
      asset.pool = pool;
      balance.assets.push(asset);
      let debt = new Debt(coin_type, 0n);
      debt.vault = pool.vault;
      debt.pool = pool;
      balance.debts.push(debt);
    }
    return new BalanceDelta(balance);
  }
  copy_from_balance(balance) {
    var $30;
    if (balance) {
      for (let $27 = 0, $28 = iter$__$1(this.assets), $29 = $28.length, asset; $27 < $29; $27++) {
        let a = $28[$27];
        if (asset = balance.get_asset(a.coin_type)) {
          a.amount = asset.amount;
        }
      }
      $30 = [];
      for (let $31 = 0, $32 = iter$__$1(this.debts), $33 = $32.length, debt; $31 < $33; $31++) {
        let d = $32[$31];
        $30.push((debt = balance.get_debt(d.coin_type)) && (d.amount = debt.amount));
      }
      return $30;
    }
  }
  set_asset_delta(coin_type, delta) {
    let asset;
    if (asset = this.get_asset(coin_type)) {
      return asset.delta_amount = BigInt(delta);
    }
  }
  set_debt_delta(coin_type, delta) {
    let debt;
    if (debt = this.get_debt(coin_type)) {
      return debt.delta_amount = BigInt(delta);
    }
  }
  static {
    this.prototype[$__initor__$] = $3;
    defineName$__$c(this, "BalanceDelta");
    inheritClass$__(this);
  }
}
function defineName$__$b(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$a = Symbol.for("#__init__"), $__patch__$$a = Symbol.for("#__patch__");
class Table {
  [$__patch__$$a]($$ = {}) {
    var $12;
    ($12 = $$.handle) !== void 0 && (this.handle = $12);
    ($12 = $$.key_type) !== void 0 && (this.key_type = $12);
    ($12 = $$.value_type) !== void 0 && (this.value_type = $12);
    ($12 = $$.data) !== void 0 && (this.data = $12);
  }
  [$__init__$$a]($$ = null, deep = true) {
    this.handle = $$ ? $$.handle : void 0;
    this.key_type = $$ ? $$.key_type : void 0;
    this.value_type = $$ ? $$.value_type : void 0;
    this.data = $$ ? $$.data : void 0;
  }
  constructor(handle, key_type, value_type) {
    this[$__init__$$a]();
    this.handle = handle;
    this.key_type = key_type;
    this.value_type = value_type;
    this.data = {};
  }
  get_item(key) {
    return this.data[key.toString()];
  }
  static {
    defineName$__$b(this, "Table");
  }
}
function defineName$__$a(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$9 = Symbol.for("#__init__"), $__patch__$$9 = Symbol.for("#__patch__");
class ConfigStore {
  [$__patch__$$9]($$ = {}) {
    var $12;
    ($12 = $$.configs) !== void 0 && (this.configs = $12);
  }
  [$__init__$$9]($$ = null, deep = true) {
    this.configs = $$ ? $$.configs : void 0;
  }
  static resource_regex() {
    return new RegExp("^" + cfg.LENDING + "::lending::ConfigStore");
  }
  static from_resource(res) {
    if (res.type.match(this.resource_regex())) {
      return new ConfigStore(res.data);
    }
  }
  constructor({ configs: { handle } }) {
    this[$__init__$$9]();
    this.configs = new Table(
      handle,
      "0x1::type_info::TypeInfo",
      "" + cfg.LENDING + "::config::Config"
    );
  }
  static {
    defineName$__$a(this, "ConfigStore");
  }
}
function defineName$__$9(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
class LendingStore {
  static resource_regex() {
    return new RegExp("^" + cfg.LENDING + "::lending::LendingStore");
  }
  static from_resource(res) {
    if (res.type.match(this.resource_regex())) {
      return new LendingStore(res.data);
    }
  }
  constructor({}) {
  }
  static {
    defineName$__$9(this, "LendingStore");
  }
}
function defineName$__$8(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$8 = Symbol.for("#__init__"), $__patch__$$8 = Symbol.for("#__patch__");
class SwitchboardAggregatorRound {
  [$__patch__$$8]($$ = {}) {
    var $12;
    ($12 = $$.round_confirmed_timestamp) !== void 0 && (this.round_confirmed_timestamp = $12);
    ($12 = $$.latest_price) !== void 0 && (this.latest_price = $12);
  }
  [$__init__$$8]($$ = null, deep = true) {
    this.round_confirmed_timestamp = $$ ? $$.round_confirmed_timestamp : void 0;
    this.latest_price = $$ ? $$.latest_price : void 0;
  }
  static resource_regex() {
    return new RegExp("^" + cfg.SWITCHBOARD + "::aggregator::AggregatorRound<" + cfg.SWITCHBOARD + "::aggregator::LatestConfirmedRound>$");
  }
  static from_resource(res) {
    if (res.type.match(this.resource_regex())) {
      return new SwitchboardAggregatorRound(res.data);
    }
  }
  constructor(data2) {
    this[$__init__$$8]();
    this.round_confirmed_timestamp = parseInt(data2.round_confirmed_timestamp);
    this.latest_price = BigInt(data2.result.value);
  }
  static {
    defineName$__$8(this, "SwitchboardAggregatorRound");
  }
}
class Oracle {
  [$__patch__$$8]($$ = {}) {
    var $22;
    ($22 = $$.coin_type) !== void 0 && (this.coin_type = $22);
    ($22 = $$.feed) !== void 0 && (this.feed = $22);
    ($22 = $$.adapter) !== void 0 && (this.adapter = $22);
    ($22 = $$.switchboard) !== void 0 && (this.switchboard = $22);
  }
  [$__init__$$8]($$ = null, deep = true) {
    this.coin_type = $$ ? $$.coin_type : void 0;
    this.feed = $$ ? $$.feed : void 0;
    this.adapter = $$ ? $$.adapter : void 0;
    this.switchboard = $$ ? $$.switchboard : void 0;
  }
  constructor(coin_type, res) {
    this[$__init__$$8]();
    this.coin_type = coin_type;
    this.feed = res.feed;
    this.adapter = res.adapter;
  }
  get price() {
    switch (this.adapter) {
      case 1: {
        return this.switchboard?.latest_price || 0n;
      }
      default:
        return 0n;
    }
  }
  get timestamp() {
    switch (this.adapter) {
      case 1: {
        return this.switchboard?.round_confirmed_timestamp;
      }
      default:
        return 0n;
    }
  }
  load_data(res) {
    let round;
    switch (this.adapter) {
      case 1: {
        if (round = SwitchboardAggregatorRound.from_resource(res)) {
          this.switchboard = round;
          return true;
        }
        break;
      }
      default:
        return false;
    }
  }
  static {
    defineName$__$8(this, "Oracle");
  }
}
function defineName$__$7(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$7 = Symbol.for("#__init__"), $__patch__$$7 = Symbol.for("#__patch__");
class OracleStore {
  [$__patch__$$7]($$ = {}) {
    var $12;
    ($12 = $$.oracles) !== void 0 && (this.oracles = $12);
  }
  [$__init__$$7]($$ = null, deep = true) {
    this.oracles = $$ ? $$.oracles : void 0;
  }
  static resource_regex() {
    return new RegExp("^" + cfg.ORACLE + "::oracle::OracleStore");
  }
  static from_resource(res) {
    if (res.type.match(this.resource_regex())) {
      return new OracleStore(res.data);
    }
  }
  constructor({ oracles: { handle } }) {
    this[$__init__$$7]();
    this.oracles = new Table(
      handle,
      "0x1::type_info::TypeInfo",
      "" + cfg.ORACLE + "::oracle::Oracle"
    );
  }
  static {
    defineName$__$7(this, "OracleStore");
  }
}
function defineName$__$6(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$6 = Symbol.for("#__init__"), $__patch__$$6 = Symbol.for("#__patch__");
class StateStore {
  [$__patch__$$6]($$ = {}) {
    var $12;
    ($12 = $$.states) !== void 0 && (this.states = $12);
  }
  [$__init__$$6]($$ = null, deep = true) {
    this.states = $$ ? $$.states : void 0;
  }
  static resource_regex() {
    return new RegExp("^" + cfg.BANK + "::vault::StateStore$");
  }
  static from_resource(res) {
    if (res.type.match(this.resource_regex())) {
      return new StateStore(res.data);
    }
  }
  constructor({ states: { handle } }) {
    this[$__init__$$6]();
    this.states = new Table(
      handle,
      "0x1::type_info::TypeInfo",
      "" + cfg.BANK + "::vault::State"
    );
  }
  static {
    defineName$__$6(this, "StateStore");
  }
}
function defineName$__$5(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$5 = Symbol.for("#__init__"), $__patch__$$5 = Symbol.for("#__patch__");
class AppState {
  [$__patch__$$5]($$ = {}) {
    var $12;
    ($12 = $$.ledger_info) !== void 0 && (this.ledger_info = $12);
    ($12 = $$.oracle_store) !== void 0 && (this.oracle_store = $12);
    ($12 = $$.vault_state_store) !== void 0 && (this.vault_state_store = $12);
    ($12 = $$.lending_store) !== void 0 && (this.lending_store = $12);
    ($12 = $$.lending_config_store) !== void 0 && (this.lending_config_store = $12);
    ($12 = $$.vaults) !== void 0 && (this.vaults = $12);
    ($12 = $$.coins) !== void 0 && (this.coins = $12);
    ($12 = $$.coin_prices) !== void 0 && (this.coin_prices = $12);
    ($12 = $$.lending_pools) !== void 0 && (this.lending_pools = $12);
    ($12 = $$.user) !== void 0 && (this.user = $12);
    ($12 = $$.user_coins) !== void 0 && (this.user_coins = $12);
    ($12 = $$.user_balance) !== void 0 && (this.user_balance = $12);
  }
  constructor($$ = null) {
    this[$__init__$$5]($$);
  }
  [$__init__$$5]($$ = null, deep = true) {
    var $22;
    this.ledger_info = $$ ? $$.ledger_info : void 0;
    this.oracle_store = $$ ? $$.oracle_store : void 0;
    this.vault_state_store = $$ ? $$.vault_state_store : void 0;
    this.lending_store = $$ ? $$.lending_store : void 0;
    this.lending_config_store = $$ ? $$.lending_config_store : void 0;
    this.vaults = $$ && ($22 = $$.vaults) !== void 0 ? $22 : {};
    this.coins = $$ && ($22 = $$.coins) !== void 0 ? $22 : {};
    this.coin_prices = $$ && ($22 = $$.coin_prices) !== void 0 ? $22 : {};
    this.lending_pools = $$ && ($22 = $$.lending_pools) !== void 0 ? $22 : {};
    this.user = $$ ? $$.user : void 0;
    this.user_coins = $$ && ($22 = $$.user_coins) !== void 0 ? $22 : {};
    this.user_balance = $$ ? $$.user_balance : void 0;
  }
  get total_value_locked() {
    let result = 0n;
    for (let $5 = this.vaults, $32 = 0, $4 = Object.keys($5), $6 = $4.length, coin_type, vault; $32 < $6; $32++) {
      coin_type = $4[$32];
      vault = $5[coin_type];
      result += vault.locked_value;
    }
    return result;
  }
  get total_pledged_value() {
    let result = 0n;
    for (let $9 = this.lending_pools, $7 = 0, $8 = Object.keys($9), $10 = $8.length, coin_type, pool; $7 < $10; $7++) {
      coin_type = $8[$7];
      pool = $9[coin_type];
      result += pool.locked_value;
    }
    return result;
  }
  get total_borrowed_value() {
    let result = 0n;
    for (let $13 = this.vaults, $11 = 0, $12 = Object.keys($13), $14 = $12.length, coin_type, vault; $11 < $14; $11++) {
      coin_type = $12[$11];
      vault = $13[coin_type];
      result += vault.borrowed_value;
    }
    return result;
  }
  max_to_redeem(coin_type) {
    let asset, coin_info, pool;
    if (asset = this.user_balance?.get_asset?.(coin_type)) {
      if (this.user_balance.total_vdebts_value == 0n) {
        return asset.underlying_amount;
      }
      let delta = this.user_balance.total_vassets_value - this.user_balance.total_vdebts_value;
      if (delta > 0n) {
        if (coin_info = this.coins[coin_type]) {
          if (pool = asset.pool) {
            let amount = coin_info.coin_amount(pool.real_asset_value(delta));
            return min(min(amount, asset.underlying_amount), pool.vault.available_coins);
          }
        }
      }
    }
    return 0n;
  }
  max_to_borrow(coin_type) {
    let pool, coin_info;
    if (this.user_balance) {
      let delta = this.user_balance.total_vassets_value - this.user_balance.total_vdebts_value;
      if (delta > 0n) {
        if (pool = this.lending_pools[coin_type]) {
          if (coin_info = this.coins[coin_type]) {
            let amount = coin_info.coin_amount(pool.real_debt_value(delta));
            let amount_without_fee = pool.amount_without_fee(amount);
            return min(amount_without_fee, pool.vault.available_coins);
          }
        }
      }
    }
    return 0n;
  }
  static {
    defineName$__$5(this, "AppState");
  }
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  var f = n.default;
  if (typeof f == "function") {
    var a = function() {
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else
    a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var naclFast = { exports: {} };
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
(function(module) {
  (function(nacl) {
    var gf = function(init) {
      var i, r = new Float64Array(16);
      if (init)
        for (i = 0; i < init.length; i++)
          r[i] = init[i];
      return r;
    };
    var randombytes = function() {
      throw new Error("no PRNG");
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf(), gf1 = gf([1]), _121665 = gf([56129, 1]), D = gf([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), D2 = gf([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), X = gf([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), Y = gf([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), I = gf([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function ts64(x, i, h, l) {
      x[i] = h >> 24 & 255;
      x[i + 1] = h >> 16 & 255;
      x[i + 2] = h >> 8 & 255;
      x[i + 3] = h & 255;
      x[i + 4] = l >> 24 & 255;
      x[i + 5] = l >> 16 & 255;
      x[i + 6] = l >> 8 & 255;
      x[i + 7] = l & 255;
    }
    function vn(x, xi, y, yi, n) {
      var i, d = 0;
      for (i = 0; i < n; i++)
        d |= x[xi + i] ^ y[yi + i];
      return (1 & d - 1 >>> 8) - 1;
    }
    function crypto_verify_16(x, xi, y, yi) {
      return vn(x, xi, y, yi, 16);
    }
    function crypto_verify_32(x, xi, y, yi) {
      return vn(x, xi, y, yi, 32);
    }
    function core_salsa20(o, p, k, c) {
      var j0 = c[0] & 255 | (c[1] & 255) << 8 | (c[2] & 255) << 16 | (c[3] & 255) << 24, j1 = k[0] & 255 | (k[1] & 255) << 8 | (k[2] & 255) << 16 | (k[3] & 255) << 24, j2 = k[4] & 255 | (k[5] & 255) << 8 | (k[6] & 255) << 16 | (k[7] & 255) << 24, j3 = k[8] & 255 | (k[9] & 255) << 8 | (k[10] & 255) << 16 | (k[11] & 255) << 24, j4 = k[12] & 255 | (k[13] & 255) << 8 | (k[14] & 255) << 16 | (k[15] & 255) << 24, j5 = c[4] & 255 | (c[5] & 255) << 8 | (c[6] & 255) << 16 | (c[7] & 255) << 24, j6 = p[0] & 255 | (p[1] & 255) << 8 | (p[2] & 255) << 16 | (p[3] & 255) << 24, j7 = p[4] & 255 | (p[5] & 255) << 8 | (p[6] & 255) << 16 | (p[7] & 255) << 24, j8 = p[8] & 255 | (p[9] & 255) << 8 | (p[10] & 255) << 16 | (p[11] & 255) << 24, j9 = p[12] & 255 | (p[13] & 255) << 8 | (p[14] & 255) << 16 | (p[15] & 255) << 24, j10 = c[8] & 255 | (c[9] & 255) << 8 | (c[10] & 255) << 16 | (c[11] & 255) << 24, j11 = k[16] & 255 | (k[17] & 255) << 8 | (k[18] & 255) << 16 | (k[19] & 255) << 24, j12 = k[20] & 255 | (k[21] & 255) << 8 | (k[22] & 255) << 16 | (k[23] & 255) << 24, j13 = k[24] & 255 | (k[25] & 255) << 8 | (k[26] & 255) << 16 | (k[27] & 255) << 24, j14 = k[28] & 255 | (k[29] & 255) << 8 | (k[30] & 255) << 16 | (k[31] & 255) << 24, j15 = c[12] & 255 | (c[13] & 255) << 8 | (c[14] & 255) << 16 | (c[15] & 255) << 24;
      var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
      for (var i = 0; i < 20; i += 2) {
        u = x0 + x12 | 0;
        x4 ^= u << 7 | u >>> 32 - 7;
        u = x4 + x0 | 0;
        x8 ^= u << 9 | u >>> 32 - 9;
        u = x8 + x4 | 0;
        x12 ^= u << 13 | u >>> 32 - 13;
        u = x12 + x8 | 0;
        x0 ^= u << 18 | u >>> 32 - 18;
        u = x5 + x1 | 0;
        x9 ^= u << 7 | u >>> 32 - 7;
        u = x9 + x5 | 0;
        x13 ^= u << 9 | u >>> 32 - 9;
        u = x13 + x9 | 0;
        x1 ^= u << 13 | u >>> 32 - 13;
        u = x1 + x13 | 0;
        x5 ^= u << 18 | u >>> 32 - 18;
        u = x10 + x6 | 0;
        x14 ^= u << 7 | u >>> 32 - 7;
        u = x14 + x10 | 0;
        x2 ^= u << 9 | u >>> 32 - 9;
        u = x2 + x14 | 0;
        x6 ^= u << 13 | u >>> 32 - 13;
        u = x6 + x2 | 0;
        x10 ^= u << 18 | u >>> 32 - 18;
        u = x15 + x11 | 0;
        x3 ^= u << 7 | u >>> 32 - 7;
        u = x3 + x15 | 0;
        x7 ^= u << 9 | u >>> 32 - 9;
        u = x7 + x3 | 0;
        x11 ^= u << 13 | u >>> 32 - 13;
        u = x11 + x7 | 0;
        x15 ^= u << 18 | u >>> 32 - 18;
        u = x0 + x3 | 0;
        x1 ^= u << 7 | u >>> 32 - 7;
        u = x1 + x0 | 0;
        x2 ^= u << 9 | u >>> 32 - 9;
        u = x2 + x1 | 0;
        x3 ^= u << 13 | u >>> 32 - 13;
        u = x3 + x2 | 0;
        x0 ^= u << 18 | u >>> 32 - 18;
        u = x5 + x4 | 0;
        x6 ^= u << 7 | u >>> 32 - 7;
        u = x6 + x5 | 0;
        x7 ^= u << 9 | u >>> 32 - 9;
        u = x7 + x6 | 0;
        x4 ^= u << 13 | u >>> 32 - 13;
        u = x4 + x7 | 0;
        x5 ^= u << 18 | u >>> 32 - 18;
        u = x10 + x9 | 0;
        x11 ^= u << 7 | u >>> 32 - 7;
        u = x11 + x10 | 0;
        x8 ^= u << 9 | u >>> 32 - 9;
        u = x8 + x11 | 0;
        x9 ^= u << 13 | u >>> 32 - 13;
        u = x9 + x8 | 0;
        x10 ^= u << 18 | u >>> 32 - 18;
        u = x15 + x14 | 0;
        x12 ^= u << 7 | u >>> 32 - 7;
        u = x12 + x15 | 0;
        x13 ^= u << 9 | u >>> 32 - 9;
        u = x13 + x12 | 0;
        x14 ^= u << 13 | u >>> 32 - 13;
        u = x14 + x13 | 0;
        x15 ^= u << 18 | u >>> 32 - 18;
      }
      x0 = x0 + j0 | 0;
      x1 = x1 + j1 | 0;
      x2 = x2 + j2 | 0;
      x3 = x3 + j3 | 0;
      x4 = x4 + j4 | 0;
      x5 = x5 + j5 | 0;
      x6 = x6 + j6 | 0;
      x7 = x7 + j7 | 0;
      x8 = x8 + j8 | 0;
      x9 = x9 + j9 | 0;
      x10 = x10 + j10 | 0;
      x11 = x11 + j11 | 0;
      x12 = x12 + j12 | 0;
      x13 = x13 + j13 | 0;
      x14 = x14 + j14 | 0;
      x15 = x15 + j15 | 0;
      o[0] = x0 >>> 0 & 255;
      o[1] = x0 >>> 8 & 255;
      o[2] = x0 >>> 16 & 255;
      o[3] = x0 >>> 24 & 255;
      o[4] = x1 >>> 0 & 255;
      o[5] = x1 >>> 8 & 255;
      o[6] = x1 >>> 16 & 255;
      o[7] = x1 >>> 24 & 255;
      o[8] = x2 >>> 0 & 255;
      o[9] = x2 >>> 8 & 255;
      o[10] = x2 >>> 16 & 255;
      o[11] = x2 >>> 24 & 255;
      o[12] = x3 >>> 0 & 255;
      o[13] = x3 >>> 8 & 255;
      o[14] = x3 >>> 16 & 255;
      o[15] = x3 >>> 24 & 255;
      o[16] = x4 >>> 0 & 255;
      o[17] = x4 >>> 8 & 255;
      o[18] = x4 >>> 16 & 255;
      o[19] = x4 >>> 24 & 255;
      o[20] = x5 >>> 0 & 255;
      o[21] = x5 >>> 8 & 255;
      o[22] = x5 >>> 16 & 255;
      o[23] = x5 >>> 24 & 255;
      o[24] = x6 >>> 0 & 255;
      o[25] = x6 >>> 8 & 255;
      o[26] = x6 >>> 16 & 255;
      o[27] = x6 >>> 24 & 255;
      o[28] = x7 >>> 0 & 255;
      o[29] = x7 >>> 8 & 255;
      o[30] = x7 >>> 16 & 255;
      o[31] = x7 >>> 24 & 255;
      o[32] = x8 >>> 0 & 255;
      o[33] = x8 >>> 8 & 255;
      o[34] = x8 >>> 16 & 255;
      o[35] = x8 >>> 24 & 255;
      o[36] = x9 >>> 0 & 255;
      o[37] = x9 >>> 8 & 255;
      o[38] = x9 >>> 16 & 255;
      o[39] = x9 >>> 24 & 255;
      o[40] = x10 >>> 0 & 255;
      o[41] = x10 >>> 8 & 255;
      o[42] = x10 >>> 16 & 255;
      o[43] = x10 >>> 24 & 255;
      o[44] = x11 >>> 0 & 255;
      o[45] = x11 >>> 8 & 255;
      o[46] = x11 >>> 16 & 255;
      o[47] = x11 >>> 24 & 255;
      o[48] = x12 >>> 0 & 255;
      o[49] = x12 >>> 8 & 255;
      o[50] = x12 >>> 16 & 255;
      o[51] = x12 >>> 24 & 255;
      o[52] = x13 >>> 0 & 255;
      o[53] = x13 >>> 8 & 255;
      o[54] = x13 >>> 16 & 255;
      o[55] = x13 >>> 24 & 255;
      o[56] = x14 >>> 0 & 255;
      o[57] = x14 >>> 8 & 255;
      o[58] = x14 >>> 16 & 255;
      o[59] = x14 >>> 24 & 255;
      o[60] = x15 >>> 0 & 255;
      o[61] = x15 >>> 8 & 255;
      o[62] = x15 >>> 16 & 255;
      o[63] = x15 >>> 24 & 255;
    }
    function core_hsalsa20(o, p, k, c) {
      var j0 = c[0] & 255 | (c[1] & 255) << 8 | (c[2] & 255) << 16 | (c[3] & 255) << 24, j1 = k[0] & 255 | (k[1] & 255) << 8 | (k[2] & 255) << 16 | (k[3] & 255) << 24, j2 = k[4] & 255 | (k[5] & 255) << 8 | (k[6] & 255) << 16 | (k[7] & 255) << 24, j3 = k[8] & 255 | (k[9] & 255) << 8 | (k[10] & 255) << 16 | (k[11] & 255) << 24, j4 = k[12] & 255 | (k[13] & 255) << 8 | (k[14] & 255) << 16 | (k[15] & 255) << 24, j5 = c[4] & 255 | (c[5] & 255) << 8 | (c[6] & 255) << 16 | (c[7] & 255) << 24, j6 = p[0] & 255 | (p[1] & 255) << 8 | (p[2] & 255) << 16 | (p[3] & 255) << 24, j7 = p[4] & 255 | (p[5] & 255) << 8 | (p[6] & 255) << 16 | (p[7] & 255) << 24, j8 = p[8] & 255 | (p[9] & 255) << 8 | (p[10] & 255) << 16 | (p[11] & 255) << 24, j9 = p[12] & 255 | (p[13] & 255) << 8 | (p[14] & 255) << 16 | (p[15] & 255) << 24, j10 = c[8] & 255 | (c[9] & 255) << 8 | (c[10] & 255) << 16 | (c[11] & 255) << 24, j11 = k[16] & 255 | (k[17] & 255) << 8 | (k[18] & 255) << 16 | (k[19] & 255) << 24, j12 = k[20] & 255 | (k[21] & 255) << 8 | (k[22] & 255) << 16 | (k[23] & 255) << 24, j13 = k[24] & 255 | (k[25] & 255) << 8 | (k[26] & 255) << 16 | (k[27] & 255) << 24, j14 = k[28] & 255 | (k[29] & 255) << 8 | (k[30] & 255) << 16 | (k[31] & 255) << 24, j15 = c[12] & 255 | (c[13] & 255) << 8 | (c[14] & 255) << 16 | (c[15] & 255) << 24;
      var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
      for (var i = 0; i < 20; i += 2) {
        u = x0 + x12 | 0;
        x4 ^= u << 7 | u >>> 32 - 7;
        u = x4 + x0 | 0;
        x8 ^= u << 9 | u >>> 32 - 9;
        u = x8 + x4 | 0;
        x12 ^= u << 13 | u >>> 32 - 13;
        u = x12 + x8 | 0;
        x0 ^= u << 18 | u >>> 32 - 18;
        u = x5 + x1 | 0;
        x9 ^= u << 7 | u >>> 32 - 7;
        u = x9 + x5 | 0;
        x13 ^= u << 9 | u >>> 32 - 9;
        u = x13 + x9 | 0;
        x1 ^= u << 13 | u >>> 32 - 13;
        u = x1 + x13 | 0;
        x5 ^= u << 18 | u >>> 32 - 18;
        u = x10 + x6 | 0;
        x14 ^= u << 7 | u >>> 32 - 7;
        u = x14 + x10 | 0;
        x2 ^= u << 9 | u >>> 32 - 9;
        u = x2 + x14 | 0;
        x6 ^= u << 13 | u >>> 32 - 13;
        u = x6 + x2 | 0;
        x10 ^= u << 18 | u >>> 32 - 18;
        u = x15 + x11 | 0;
        x3 ^= u << 7 | u >>> 32 - 7;
        u = x3 + x15 | 0;
        x7 ^= u << 9 | u >>> 32 - 9;
        u = x7 + x3 | 0;
        x11 ^= u << 13 | u >>> 32 - 13;
        u = x11 + x7 | 0;
        x15 ^= u << 18 | u >>> 32 - 18;
        u = x0 + x3 | 0;
        x1 ^= u << 7 | u >>> 32 - 7;
        u = x1 + x0 | 0;
        x2 ^= u << 9 | u >>> 32 - 9;
        u = x2 + x1 | 0;
        x3 ^= u << 13 | u >>> 32 - 13;
        u = x3 + x2 | 0;
        x0 ^= u << 18 | u >>> 32 - 18;
        u = x5 + x4 | 0;
        x6 ^= u << 7 | u >>> 32 - 7;
        u = x6 + x5 | 0;
        x7 ^= u << 9 | u >>> 32 - 9;
        u = x7 + x6 | 0;
        x4 ^= u << 13 | u >>> 32 - 13;
        u = x4 + x7 | 0;
        x5 ^= u << 18 | u >>> 32 - 18;
        u = x10 + x9 | 0;
        x11 ^= u << 7 | u >>> 32 - 7;
        u = x11 + x10 | 0;
        x8 ^= u << 9 | u >>> 32 - 9;
        u = x8 + x11 | 0;
        x9 ^= u << 13 | u >>> 32 - 13;
        u = x9 + x8 | 0;
        x10 ^= u << 18 | u >>> 32 - 18;
        u = x15 + x14 | 0;
        x12 ^= u << 7 | u >>> 32 - 7;
        u = x12 + x15 | 0;
        x13 ^= u << 9 | u >>> 32 - 9;
        u = x13 + x12 | 0;
        x14 ^= u << 13 | u >>> 32 - 13;
        u = x14 + x13 | 0;
        x15 ^= u << 18 | u >>> 32 - 18;
      }
      o[0] = x0 >>> 0 & 255;
      o[1] = x0 >>> 8 & 255;
      o[2] = x0 >>> 16 & 255;
      o[3] = x0 >>> 24 & 255;
      o[4] = x5 >>> 0 & 255;
      o[5] = x5 >>> 8 & 255;
      o[6] = x5 >>> 16 & 255;
      o[7] = x5 >>> 24 & 255;
      o[8] = x10 >>> 0 & 255;
      o[9] = x10 >>> 8 & 255;
      o[10] = x10 >>> 16 & 255;
      o[11] = x10 >>> 24 & 255;
      o[12] = x15 >>> 0 & 255;
      o[13] = x15 >>> 8 & 255;
      o[14] = x15 >>> 16 & 255;
      o[15] = x15 >>> 24 & 255;
      o[16] = x6 >>> 0 & 255;
      o[17] = x6 >>> 8 & 255;
      o[18] = x6 >>> 16 & 255;
      o[19] = x6 >>> 24 & 255;
      o[20] = x7 >>> 0 & 255;
      o[21] = x7 >>> 8 & 255;
      o[22] = x7 >>> 16 & 255;
      o[23] = x7 >>> 24 & 255;
      o[24] = x8 >>> 0 & 255;
      o[25] = x8 >>> 8 & 255;
      o[26] = x8 >>> 16 & 255;
      o[27] = x8 >>> 24 & 255;
      o[28] = x9 >>> 0 & 255;
      o[29] = x9 >>> 8 & 255;
      o[30] = x9 >>> 16 & 255;
      o[31] = x9 >>> 24 & 255;
    }
    function crypto_core_salsa20(out, inp, k, c) {
      core_salsa20(out, inp, k, c);
    }
    function crypto_core_hsalsa20(out, inp, k, c) {
      core_hsalsa20(out, inp, k, c);
    }
    var sigma = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
      var z = new Uint8Array(16), x = new Uint8Array(64);
      var u, i;
      for (i = 0; i < 16; i++)
        z[i] = 0;
      for (i = 0; i < 8; i++)
        z[i] = n[i];
      while (b >= 64) {
        crypto_core_salsa20(x, z, k, sigma);
        for (i = 0; i < 64; i++)
          c[cpos + i] = m[mpos + i] ^ x[i];
        u = 1;
        for (i = 8; i < 16; i++) {
          u = u + (z[i] & 255) | 0;
          z[i] = u & 255;
          u >>>= 8;
        }
        b -= 64;
        cpos += 64;
        mpos += 64;
      }
      if (b > 0) {
        crypto_core_salsa20(x, z, k, sigma);
        for (i = 0; i < b; i++)
          c[cpos + i] = m[mpos + i] ^ x[i];
      }
      return 0;
    }
    function crypto_stream_salsa20(c, cpos, b, n, k) {
      var z = new Uint8Array(16), x = new Uint8Array(64);
      var u, i;
      for (i = 0; i < 16; i++)
        z[i] = 0;
      for (i = 0; i < 8; i++)
        z[i] = n[i];
      while (b >= 64) {
        crypto_core_salsa20(x, z, k, sigma);
        for (i = 0; i < 64; i++)
          c[cpos + i] = x[i];
        u = 1;
        for (i = 8; i < 16; i++) {
          u = u + (z[i] & 255) | 0;
          z[i] = u & 255;
          u >>>= 8;
        }
        b -= 64;
        cpos += 64;
      }
      if (b > 0) {
        crypto_core_salsa20(x, z, k, sigma);
        for (i = 0; i < b; i++)
          c[cpos + i] = x[i];
      }
      return 0;
    }
    function crypto_stream(c, cpos, d, n, k) {
      var s = new Uint8Array(32);
      crypto_core_hsalsa20(s, n, k, sigma);
      var sn = new Uint8Array(8);
      for (var i = 0; i < 8; i++)
        sn[i] = n[i + 16];
      return crypto_stream_salsa20(c, cpos, d, sn, s);
    }
    function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
      var s = new Uint8Array(32);
      crypto_core_hsalsa20(s, n, k, sigma);
      var sn = new Uint8Array(8);
      for (var i = 0; i < 8; i++)
        sn[i] = n[i + 16];
      return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
    }
    var poly1305 = function(key) {
      this.buffer = new Uint8Array(16);
      this.r = new Uint16Array(10);
      this.h = new Uint16Array(10);
      this.pad = new Uint16Array(8);
      this.leftover = 0;
      this.fin = 0;
      var t0, t1, t2, t3, t4, t5, t6, t7;
      t0 = key[0] & 255 | (key[1] & 255) << 8;
      this.r[0] = t0 & 8191;
      t1 = key[2] & 255 | (key[3] & 255) << 8;
      this.r[1] = (t0 >>> 13 | t1 << 3) & 8191;
      t2 = key[4] & 255 | (key[5] & 255) << 8;
      this.r[2] = (t1 >>> 10 | t2 << 6) & 7939;
      t3 = key[6] & 255 | (key[7] & 255) << 8;
      this.r[3] = (t2 >>> 7 | t3 << 9) & 8191;
      t4 = key[8] & 255 | (key[9] & 255) << 8;
      this.r[4] = (t3 >>> 4 | t4 << 12) & 255;
      this.r[5] = t4 >>> 1 & 8190;
      t5 = key[10] & 255 | (key[11] & 255) << 8;
      this.r[6] = (t4 >>> 14 | t5 << 2) & 8191;
      t6 = key[12] & 255 | (key[13] & 255) << 8;
      this.r[7] = (t5 >>> 11 | t6 << 5) & 8065;
      t7 = key[14] & 255 | (key[15] & 255) << 8;
      this.r[8] = (t6 >>> 8 | t7 << 8) & 8191;
      this.r[9] = t7 >>> 5 & 127;
      this.pad[0] = key[16] & 255 | (key[17] & 255) << 8;
      this.pad[1] = key[18] & 255 | (key[19] & 255) << 8;
      this.pad[2] = key[20] & 255 | (key[21] & 255) << 8;
      this.pad[3] = key[22] & 255 | (key[23] & 255) << 8;
      this.pad[4] = key[24] & 255 | (key[25] & 255) << 8;
      this.pad[5] = key[26] & 255 | (key[27] & 255) << 8;
      this.pad[6] = key[28] & 255 | (key[29] & 255) << 8;
      this.pad[7] = key[30] & 255 | (key[31] & 255) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes2) {
      var hibit = this.fin ? 0 : 1 << 11;
      var t0, t1, t2, t3, t4, t5, t6, t7, c;
      var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
      var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
      var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
      while (bytes2 >= 16) {
        t0 = m[mpos + 0] & 255 | (m[mpos + 1] & 255) << 8;
        h0 += t0 & 8191;
        t1 = m[mpos + 2] & 255 | (m[mpos + 3] & 255) << 8;
        h1 += (t0 >>> 13 | t1 << 3) & 8191;
        t2 = m[mpos + 4] & 255 | (m[mpos + 5] & 255) << 8;
        h2 += (t1 >>> 10 | t2 << 6) & 8191;
        t3 = m[mpos + 6] & 255 | (m[mpos + 7] & 255) << 8;
        h3 += (t2 >>> 7 | t3 << 9) & 8191;
        t4 = m[mpos + 8] & 255 | (m[mpos + 9] & 255) << 8;
        h4 += (t3 >>> 4 | t4 << 12) & 8191;
        h5 += t4 >>> 1 & 8191;
        t5 = m[mpos + 10] & 255 | (m[mpos + 11] & 255) << 8;
        h6 += (t4 >>> 14 | t5 << 2) & 8191;
        t6 = m[mpos + 12] & 255 | (m[mpos + 13] & 255) << 8;
        h7 += (t5 >>> 11 | t6 << 5) & 8191;
        t7 = m[mpos + 14] & 255 | (m[mpos + 15] & 255) << 8;
        h8 += (t6 >>> 8 | t7 << 8) & 8191;
        h9 += t7 >>> 5 | hibit;
        c = 0;
        d0 = c;
        d0 += h0 * r0;
        d0 += h1 * (5 * r9);
        d0 += h2 * (5 * r8);
        d0 += h3 * (5 * r7);
        d0 += h4 * (5 * r6);
        c = d0 >>> 13;
        d0 &= 8191;
        d0 += h5 * (5 * r5);
        d0 += h6 * (5 * r4);
        d0 += h7 * (5 * r3);
        d0 += h8 * (5 * r2);
        d0 += h9 * (5 * r1);
        c += d0 >>> 13;
        d0 &= 8191;
        d1 = c;
        d1 += h0 * r1;
        d1 += h1 * r0;
        d1 += h2 * (5 * r9);
        d1 += h3 * (5 * r8);
        d1 += h4 * (5 * r7);
        c = d1 >>> 13;
        d1 &= 8191;
        d1 += h5 * (5 * r6);
        d1 += h6 * (5 * r5);
        d1 += h7 * (5 * r4);
        d1 += h8 * (5 * r3);
        d1 += h9 * (5 * r2);
        c += d1 >>> 13;
        d1 &= 8191;
        d2 = c;
        d2 += h0 * r2;
        d2 += h1 * r1;
        d2 += h2 * r0;
        d2 += h3 * (5 * r9);
        d2 += h4 * (5 * r8);
        c = d2 >>> 13;
        d2 &= 8191;
        d2 += h5 * (5 * r7);
        d2 += h6 * (5 * r6);
        d2 += h7 * (5 * r5);
        d2 += h8 * (5 * r4);
        d2 += h9 * (5 * r3);
        c += d2 >>> 13;
        d2 &= 8191;
        d3 = c;
        d3 += h0 * r3;
        d3 += h1 * r2;
        d3 += h2 * r1;
        d3 += h3 * r0;
        d3 += h4 * (5 * r9);
        c = d3 >>> 13;
        d3 &= 8191;
        d3 += h5 * (5 * r8);
        d3 += h6 * (5 * r7);
        d3 += h7 * (5 * r6);
        d3 += h8 * (5 * r5);
        d3 += h9 * (5 * r4);
        c += d3 >>> 13;
        d3 &= 8191;
        d4 = c;
        d4 += h0 * r4;
        d4 += h1 * r3;
        d4 += h2 * r2;
        d4 += h3 * r1;
        d4 += h4 * r0;
        c = d4 >>> 13;
        d4 &= 8191;
        d4 += h5 * (5 * r9);
        d4 += h6 * (5 * r8);
        d4 += h7 * (5 * r7);
        d4 += h8 * (5 * r6);
        d4 += h9 * (5 * r5);
        c += d4 >>> 13;
        d4 &= 8191;
        d5 = c;
        d5 += h0 * r5;
        d5 += h1 * r4;
        d5 += h2 * r3;
        d5 += h3 * r2;
        d5 += h4 * r1;
        c = d5 >>> 13;
        d5 &= 8191;
        d5 += h5 * r0;
        d5 += h6 * (5 * r9);
        d5 += h7 * (5 * r8);
        d5 += h8 * (5 * r7);
        d5 += h9 * (5 * r6);
        c += d5 >>> 13;
        d5 &= 8191;
        d6 = c;
        d6 += h0 * r6;
        d6 += h1 * r5;
        d6 += h2 * r4;
        d6 += h3 * r3;
        d6 += h4 * r2;
        c = d6 >>> 13;
        d6 &= 8191;
        d6 += h5 * r1;
        d6 += h6 * r0;
        d6 += h7 * (5 * r9);
        d6 += h8 * (5 * r8);
        d6 += h9 * (5 * r7);
        c += d6 >>> 13;
        d6 &= 8191;
        d7 = c;
        d7 += h0 * r7;
        d7 += h1 * r6;
        d7 += h2 * r5;
        d7 += h3 * r4;
        d7 += h4 * r3;
        c = d7 >>> 13;
        d7 &= 8191;
        d7 += h5 * r2;
        d7 += h6 * r1;
        d7 += h7 * r0;
        d7 += h8 * (5 * r9);
        d7 += h9 * (5 * r8);
        c += d7 >>> 13;
        d7 &= 8191;
        d8 = c;
        d8 += h0 * r8;
        d8 += h1 * r7;
        d8 += h2 * r6;
        d8 += h3 * r5;
        d8 += h4 * r4;
        c = d8 >>> 13;
        d8 &= 8191;
        d8 += h5 * r3;
        d8 += h6 * r2;
        d8 += h7 * r1;
        d8 += h8 * r0;
        d8 += h9 * (5 * r9);
        c += d8 >>> 13;
        d8 &= 8191;
        d9 = c;
        d9 += h0 * r9;
        d9 += h1 * r8;
        d9 += h2 * r7;
        d9 += h3 * r6;
        d9 += h4 * r5;
        c = d9 >>> 13;
        d9 &= 8191;
        d9 += h5 * r4;
        d9 += h6 * r3;
        d9 += h7 * r2;
        d9 += h8 * r1;
        d9 += h9 * r0;
        c += d9 >>> 13;
        d9 &= 8191;
        c = (c << 2) + c | 0;
        c = c + d0 | 0;
        d0 = c & 8191;
        c = c >>> 13;
        d1 += c;
        h0 = d0;
        h1 = d1;
        h2 = d2;
        h3 = d3;
        h4 = d4;
        h5 = d5;
        h6 = d6;
        h7 = d7;
        h8 = d8;
        h9 = d9;
        mpos += 16;
        bytes2 -= 16;
      }
      this.h[0] = h0;
      this.h[1] = h1;
      this.h[2] = h2;
      this.h[3] = h3;
      this.h[4] = h4;
      this.h[5] = h5;
      this.h[6] = h6;
      this.h[7] = h7;
      this.h[8] = h8;
      this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
      var g = new Uint16Array(10);
      var c, mask, f, i;
      if (this.leftover) {
        i = this.leftover;
        this.buffer[i++] = 1;
        for (; i < 16; i++)
          this.buffer[i] = 0;
        this.fin = 1;
        this.blocks(this.buffer, 0, 16);
      }
      c = this.h[1] >>> 13;
      this.h[1] &= 8191;
      for (i = 2; i < 10; i++) {
        this.h[i] += c;
        c = this.h[i] >>> 13;
        this.h[i] &= 8191;
      }
      this.h[0] += c * 5;
      c = this.h[0] >>> 13;
      this.h[0] &= 8191;
      this.h[1] += c;
      c = this.h[1] >>> 13;
      this.h[1] &= 8191;
      this.h[2] += c;
      g[0] = this.h[0] + 5;
      c = g[0] >>> 13;
      g[0] &= 8191;
      for (i = 1; i < 10; i++) {
        g[i] = this.h[i] + c;
        c = g[i] >>> 13;
        g[i] &= 8191;
      }
      g[9] -= 1 << 13;
      mask = (c ^ 1) - 1;
      for (i = 0; i < 10; i++)
        g[i] &= mask;
      mask = ~mask;
      for (i = 0; i < 10; i++)
        this.h[i] = this.h[i] & mask | g[i];
      this.h[0] = (this.h[0] | this.h[1] << 13) & 65535;
      this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535;
      this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535;
      this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535;
      this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535;
      this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535;
      this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535;
      this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535;
      f = this.h[0] + this.pad[0];
      this.h[0] = f & 65535;
      for (i = 1; i < 8; i++) {
        f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
        this.h[i] = f & 65535;
      }
      mac[macpos + 0] = this.h[0] >>> 0 & 255;
      mac[macpos + 1] = this.h[0] >>> 8 & 255;
      mac[macpos + 2] = this.h[1] >>> 0 & 255;
      mac[macpos + 3] = this.h[1] >>> 8 & 255;
      mac[macpos + 4] = this.h[2] >>> 0 & 255;
      mac[macpos + 5] = this.h[2] >>> 8 & 255;
      mac[macpos + 6] = this.h[3] >>> 0 & 255;
      mac[macpos + 7] = this.h[3] >>> 8 & 255;
      mac[macpos + 8] = this.h[4] >>> 0 & 255;
      mac[macpos + 9] = this.h[4] >>> 8 & 255;
      mac[macpos + 10] = this.h[5] >>> 0 & 255;
      mac[macpos + 11] = this.h[5] >>> 8 & 255;
      mac[macpos + 12] = this.h[6] >>> 0 & 255;
      mac[macpos + 13] = this.h[6] >>> 8 & 255;
      mac[macpos + 14] = this.h[7] >>> 0 & 255;
      mac[macpos + 15] = this.h[7] >>> 8 & 255;
    };
    poly1305.prototype.update = function(m, mpos, bytes2) {
      var i, want;
      if (this.leftover) {
        want = 16 - this.leftover;
        if (want > bytes2)
          want = bytes2;
        for (i = 0; i < want; i++)
          this.buffer[this.leftover + i] = m[mpos + i];
        bytes2 -= want;
        mpos += want;
        this.leftover += want;
        if (this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16);
        this.leftover = 0;
      }
      if (bytes2 >= 16) {
        want = bytes2 - bytes2 % 16;
        this.blocks(m, mpos, want);
        mpos += want;
        bytes2 -= want;
      }
      if (bytes2) {
        for (i = 0; i < bytes2; i++)
          this.buffer[this.leftover + i] = m[mpos + i];
        this.leftover += bytes2;
      }
    };
    function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
      var s = new poly1305(k);
      s.update(m, mpos, n);
      s.finish(out, outpos);
      return 0;
    }
    function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
      var x = new Uint8Array(16);
      crypto_onetimeauth(x, 0, m, mpos, n, k);
      return crypto_verify_16(h, hpos, x, 0);
    }
    function crypto_secretbox(c, m, d, n, k) {
      var i;
      if (d < 32)
        return -1;
      crypto_stream_xor(c, 0, m, 0, d, n, k);
      crypto_onetimeauth(c, 16, c, 32, d - 32, c);
      for (i = 0; i < 16; i++)
        c[i] = 0;
      return 0;
    }
    function crypto_secretbox_open(m, c, d, n, k) {
      var i;
      var x = new Uint8Array(32);
      if (d < 32)
        return -1;
      crypto_stream(x, 0, 32, n, k);
      if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0)
        return -1;
      crypto_stream_xor(m, 0, c, 0, d, n, k);
      for (i = 0; i < 32; i++)
        m[i] = 0;
      return 0;
    }
    function set25519(r, a) {
      var i;
      for (i = 0; i < 16; i++)
        r[i] = a[i] | 0;
    }
    function car25519(o) {
      var i, v, c = 1;
      for (i = 0; i < 16; i++) {
        v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
      }
      o[0] += c - 1 + 37 * (c - 1);
    }
    function sel25519(p, q, b) {
      var t, c = ~(b - 1);
      for (var i = 0; i < 16; i++) {
        t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
      }
    }
    function pack25519(o, n) {
      var i, j, b;
      var m = gf(), t = gf();
      for (i = 0; i < 16; i++)
        t[i] = n[i];
      car25519(t);
      car25519(t);
      car25519(t);
      for (j = 0; j < 2; j++) {
        m[0] = t[0] - 65517;
        for (i = 1; i < 15; i++) {
          m[i] = t[i] - 65535 - (m[i - 1] >> 16 & 1);
          m[i - 1] &= 65535;
        }
        m[15] = t[15] - 32767 - (m[14] >> 16 & 1);
        b = m[15] >> 16 & 1;
        m[14] &= 65535;
        sel25519(t, m, 1 - b);
      }
      for (i = 0; i < 16; i++) {
        o[2 * i] = t[i] & 255;
        o[2 * i + 1] = t[i] >> 8;
      }
    }
    function neq25519(a, b) {
      var c = new Uint8Array(32), d = new Uint8Array(32);
      pack25519(c, a);
      pack25519(d, b);
      return crypto_verify_32(c, 0, d, 0);
    }
    function par25519(a) {
      var d = new Uint8Array(32);
      pack25519(d, a);
      return d[0] & 1;
    }
    function unpack25519(o, n) {
      var i;
      for (i = 0; i < 16; i++)
        o[i] = n[2 * i] + (n[2 * i + 1] << 8);
      o[15] &= 32767;
    }
    function A(o, a, b) {
      for (var i = 0; i < 16; i++)
        o[i] = a[i] + b[i];
    }
    function Z(o, a, b) {
      for (var i = 0; i < 16; i++)
        o[i] = a[i] - b[i];
    }
    function M(o, a, b) {
      var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
      v = a[0];
      t0 += v * b0;
      t1 += v * b1;
      t2 += v * b2;
      t3 += v * b3;
      t4 += v * b4;
      t5 += v * b5;
      t6 += v * b6;
      t7 += v * b7;
      t8 += v * b8;
      t9 += v * b9;
      t10 += v * b10;
      t11 += v * b11;
      t12 += v * b12;
      t13 += v * b13;
      t14 += v * b14;
      t15 += v * b15;
      v = a[1];
      t1 += v * b0;
      t2 += v * b1;
      t3 += v * b2;
      t4 += v * b3;
      t5 += v * b4;
      t6 += v * b5;
      t7 += v * b6;
      t8 += v * b7;
      t9 += v * b8;
      t10 += v * b9;
      t11 += v * b10;
      t12 += v * b11;
      t13 += v * b12;
      t14 += v * b13;
      t15 += v * b14;
      t16 += v * b15;
      v = a[2];
      t2 += v * b0;
      t3 += v * b1;
      t4 += v * b2;
      t5 += v * b3;
      t6 += v * b4;
      t7 += v * b5;
      t8 += v * b6;
      t9 += v * b7;
      t10 += v * b8;
      t11 += v * b9;
      t12 += v * b10;
      t13 += v * b11;
      t14 += v * b12;
      t15 += v * b13;
      t16 += v * b14;
      t17 += v * b15;
      v = a[3];
      t3 += v * b0;
      t4 += v * b1;
      t5 += v * b2;
      t6 += v * b3;
      t7 += v * b4;
      t8 += v * b5;
      t9 += v * b6;
      t10 += v * b7;
      t11 += v * b8;
      t12 += v * b9;
      t13 += v * b10;
      t14 += v * b11;
      t15 += v * b12;
      t16 += v * b13;
      t17 += v * b14;
      t18 += v * b15;
      v = a[4];
      t4 += v * b0;
      t5 += v * b1;
      t6 += v * b2;
      t7 += v * b3;
      t8 += v * b4;
      t9 += v * b5;
      t10 += v * b6;
      t11 += v * b7;
      t12 += v * b8;
      t13 += v * b9;
      t14 += v * b10;
      t15 += v * b11;
      t16 += v * b12;
      t17 += v * b13;
      t18 += v * b14;
      t19 += v * b15;
      v = a[5];
      t5 += v * b0;
      t6 += v * b1;
      t7 += v * b2;
      t8 += v * b3;
      t9 += v * b4;
      t10 += v * b5;
      t11 += v * b6;
      t12 += v * b7;
      t13 += v * b8;
      t14 += v * b9;
      t15 += v * b10;
      t16 += v * b11;
      t17 += v * b12;
      t18 += v * b13;
      t19 += v * b14;
      t20 += v * b15;
      v = a[6];
      t6 += v * b0;
      t7 += v * b1;
      t8 += v * b2;
      t9 += v * b3;
      t10 += v * b4;
      t11 += v * b5;
      t12 += v * b6;
      t13 += v * b7;
      t14 += v * b8;
      t15 += v * b9;
      t16 += v * b10;
      t17 += v * b11;
      t18 += v * b12;
      t19 += v * b13;
      t20 += v * b14;
      t21 += v * b15;
      v = a[7];
      t7 += v * b0;
      t8 += v * b1;
      t9 += v * b2;
      t10 += v * b3;
      t11 += v * b4;
      t12 += v * b5;
      t13 += v * b6;
      t14 += v * b7;
      t15 += v * b8;
      t16 += v * b9;
      t17 += v * b10;
      t18 += v * b11;
      t19 += v * b12;
      t20 += v * b13;
      t21 += v * b14;
      t22 += v * b15;
      v = a[8];
      t8 += v * b0;
      t9 += v * b1;
      t10 += v * b2;
      t11 += v * b3;
      t12 += v * b4;
      t13 += v * b5;
      t14 += v * b6;
      t15 += v * b7;
      t16 += v * b8;
      t17 += v * b9;
      t18 += v * b10;
      t19 += v * b11;
      t20 += v * b12;
      t21 += v * b13;
      t22 += v * b14;
      t23 += v * b15;
      v = a[9];
      t9 += v * b0;
      t10 += v * b1;
      t11 += v * b2;
      t12 += v * b3;
      t13 += v * b4;
      t14 += v * b5;
      t15 += v * b6;
      t16 += v * b7;
      t17 += v * b8;
      t18 += v * b9;
      t19 += v * b10;
      t20 += v * b11;
      t21 += v * b12;
      t22 += v * b13;
      t23 += v * b14;
      t24 += v * b15;
      v = a[10];
      t10 += v * b0;
      t11 += v * b1;
      t12 += v * b2;
      t13 += v * b3;
      t14 += v * b4;
      t15 += v * b5;
      t16 += v * b6;
      t17 += v * b7;
      t18 += v * b8;
      t19 += v * b9;
      t20 += v * b10;
      t21 += v * b11;
      t22 += v * b12;
      t23 += v * b13;
      t24 += v * b14;
      t25 += v * b15;
      v = a[11];
      t11 += v * b0;
      t12 += v * b1;
      t13 += v * b2;
      t14 += v * b3;
      t15 += v * b4;
      t16 += v * b5;
      t17 += v * b6;
      t18 += v * b7;
      t19 += v * b8;
      t20 += v * b9;
      t21 += v * b10;
      t22 += v * b11;
      t23 += v * b12;
      t24 += v * b13;
      t25 += v * b14;
      t26 += v * b15;
      v = a[12];
      t12 += v * b0;
      t13 += v * b1;
      t14 += v * b2;
      t15 += v * b3;
      t16 += v * b4;
      t17 += v * b5;
      t18 += v * b6;
      t19 += v * b7;
      t20 += v * b8;
      t21 += v * b9;
      t22 += v * b10;
      t23 += v * b11;
      t24 += v * b12;
      t25 += v * b13;
      t26 += v * b14;
      t27 += v * b15;
      v = a[13];
      t13 += v * b0;
      t14 += v * b1;
      t15 += v * b2;
      t16 += v * b3;
      t17 += v * b4;
      t18 += v * b5;
      t19 += v * b6;
      t20 += v * b7;
      t21 += v * b8;
      t22 += v * b9;
      t23 += v * b10;
      t24 += v * b11;
      t25 += v * b12;
      t26 += v * b13;
      t27 += v * b14;
      t28 += v * b15;
      v = a[14];
      t14 += v * b0;
      t15 += v * b1;
      t16 += v * b2;
      t17 += v * b3;
      t18 += v * b4;
      t19 += v * b5;
      t20 += v * b6;
      t21 += v * b7;
      t22 += v * b8;
      t23 += v * b9;
      t24 += v * b10;
      t25 += v * b11;
      t26 += v * b12;
      t27 += v * b13;
      t28 += v * b14;
      t29 += v * b15;
      v = a[15];
      t15 += v * b0;
      t16 += v * b1;
      t17 += v * b2;
      t18 += v * b3;
      t19 += v * b4;
      t20 += v * b5;
      t21 += v * b6;
      t22 += v * b7;
      t23 += v * b8;
      t24 += v * b9;
      t25 += v * b10;
      t26 += v * b11;
      t27 += v * b12;
      t28 += v * b13;
      t29 += v * b14;
      t30 += v * b15;
      t0 += 38 * t16;
      t1 += 38 * t17;
      t2 += 38 * t18;
      t3 += 38 * t19;
      t4 += 38 * t20;
      t5 += 38 * t21;
      t6 += 38 * t22;
      t7 += 38 * t23;
      t8 += 38 * t24;
      t9 += 38 * t25;
      t10 += 38 * t26;
      t11 += 38 * t27;
      t12 += 38 * t28;
      t13 += 38 * t29;
      t14 += 38 * t30;
      c = 1;
      v = t0 + c + 65535;
      c = Math.floor(v / 65536);
      t0 = v - c * 65536;
      v = t1 + c + 65535;
      c = Math.floor(v / 65536);
      t1 = v - c * 65536;
      v = t2 + c + 65535;
      c = Math.floor(v / 65536);
      t2 = v - c * 65536;
      v = t3 + c + 65535;
      c = Math.floor(v / 65536);
      t3 = v - c * 65536;
      v = t4 + c + 65535;
      c = Math.floor(v / 65536);
      t4 = v - c * 65536;
      v = t5 + c + 65535;
      c = Math.floor(v / 65536);
      t5 = v - c * 65536;
      v = t6 + c + 65535;
      c = Math.floor(v / 65536);
      t6 = v - c * 65536;
      v = t7 + c + 65535;
      c = Math.floor(v / 65536);
      t7 = v - c * 65536;
      v = t8 + c + 65535;
      c = Math.floor(v / 65536);
      t8 = v - c * 65536;
      v = t9 + c + 65535;
      c = Math.floor(v / 65536);
      t9 = v - c * 65536;
      v = t10 + c + 65535;
      c = Math.floor(v / 65536);
      t10 = v - c * 65536;
      v = t11 + c + 65535;
      c = Math.floor(v / 65536);
      t11 = v - c * 65536;
      v = t12 + c + 65535;
      c = Math.floor(v / 65536);
      t12 = v - c * 65536;
      v = t13 + c + 65535;
      c = Math.floor(v / 65536);
      t13 = v - c * 65536;
      v = t14 + c + 65535;
      c = Math.floor(v / 65536);
      t14 = v - c * 65536;
      v = t15 + c + 65535;
      c = Math.floor(v / 65536);
      t15 = v - c * 65536;
      t0 += c - 1 + 37 * (c - 1);
      c = 1;
      v = t0 + c + 65535;
      c = Math.floor(v / 65536);
      t0 = v - c * 65536;
      v = t1 + c + 65535;
      c = Math.floor(v / 65536);
      t1 = v - c * 65536;
      v = t2 + c + 65535;
      c = Math.floor(v / 65536);
      t2 = v - c * 65536;
      v = t3 + c + 65535;
      c = Math.floor(v / 65536);
      t3 = v - c * 65536;
      v = t4 + c + 65535;
      c = Math.floor(v / 65536);
      t4 = v - c * 65536;
      v = t5 + c + 65535;
      c = Math.floor(v / 65536);
      t5 = v - c * 65536;
      v = t6 + c + 65535;
      c = Math.floor(v / 65536);
      t6 = v - c * 65536;
      v = t7 + c + 65535;
      c = Math.floor(v / 65536);
      t7 = v - c * 65536;
      v = t8 + c + 65535;
      c = Math.floor(v / 65536);
      t8 = v - c * 65536;
      v = t9 + c + 65535;
      c = Math.floor(v / 65536);
      t9 = v - c * 65536;
      v = t10 + c + 65535;
      c = Math.floor(v / 65536);
      t10 = v - c * 65536;
      v = t11 + c + 65535;
      c = Math.floor(v / 65536);
      t11 = v - c * 65536;
      v = t12 + c + 65535;
      c = Math.floor(v / 65536);
      t12 = v - c * 65536;
      v = t13 + c + 65535;
      c = Math.floor(v / 65536);
      t13 = v - c * 65536;
      v = t14 + c + 65535;
      c = Math.floor(v / 65536);
      t14 = v - c * 65536;
      v = t15 + c + 65535;
      c = Math.floor(v / 65536);
      t15 = v - c * 65536;
      t0 += c - 1 + 37 * (c - 1);
      o[0] = t0;
      o[1] = t1;
      o[2] = t2;
      o[3] = t3;
      o[4] = t4;
      o[5] = t5;
      o[6] = t6;
      o[7] = t7;
      o[8] = t8;
      o[9] = t9;
      o[10] = t10;
      o[11] = t11;
      o[12] = t12;
      o[13] = t13;
      o[14] = t14;
      o[15] = t15;
    }
    function S(o, a) {
      M(o, a, a);
    }
    function inv25519(o, i) {
      var c = gf();
      var a;
      for (a = 0; a < 16; a++)
        c[a] = i[a];
      for (a = 253; a >= 0; a--) {
        S(c, c);
        if (a !== 2 && a !== 4)
          M(c, c, i);
      }
      for (a = 0; a < 16; a++)
        o[a] = c[a];
    }
    function pow2523(o, i) {
      var c = gf();
      var a;
      for (a = 0; a < 16; a++)
        c[a] = i[a];
      for (a = 250; a >= 0; a--) {
        S(c, c);
        if (a !== 1)
          M(c, c, i);
      }
      for (a = 0; a < 16; a++)
        o[a] = c[a];
    }
    function crypto_scalarmult(q, n, p) {
      var z = new Uint8Array(32);
      var x = new Float64Array(80), r, i;
      var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
      for (i = 0; i < 31; i++)
        z[i] = n[i];
      z[31] = n[31] & 127 | 64;
      z[0] &= 248;
      unpack25519(x, p);
      for (i = 0; i < 16; i++) {
        b[i] = x[i];
        d[i] = a[i] = c[i] = 0;
      }
      a[0] = d[0] = 1;
      for (i = 254; i >= 0; --i) {
        r = z[i >>> 3] >>> (i & 7) & 1;
        sel25519(a, b, r);
        sel25519(c, d, r);
        A(e, a, c);
        Z(a, a, c);
        A(c, b, d);
        Z(b, b, d);
        S(d, e);
        S(f, a);
        M(a, c, a);
        M(c, b, e);
        A(e, a, c);
        Z(a, a, c);
        S(b, a);
        Z(c, d, f);
        M(a, c, _121665);
        A(a, a, d);
        M(c, c, a);
        M(a, d, f);
        M(d, b, x);
        S(b, e);
        sel25519(a, b, r);
        sel25519(c, d, r);
      }
      for (i = 0; i < 16; i++) {
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
      }
      var x32 = x.subarray(32);
      var x16 = x.subarray(16);
      inv25519(x32, x32);
      M(x16, x16, x32);
      pack25519(q, x16);
      return 0;
    }
    function crypto_scalarmult_base(q, n) {
      return crypto_scalarmult(q, n, _9);
    }
    function crypto_box_keypair(y, x) {
      randombytes(x, 32);
      return crypto_scalarmult_base(y, x);
    }
    function crypto_box_beforenm(k, y, x) {
      var s = new Uint8Array(32);
      crypto_scalarmult(s, x, y);
      return crypto_core_hsalsa20(k, _0, s, sigma);
    }
    var crypto_box_afternm = crypto_secretbox;
    var crypto_box_open_afternm = crypto_secretbox_open;
    function crypto_box(c, m, d, n, y, x) {
      var k = new Uint8Array(32);
      crypto_box_beforenm(k, y, x);
      return crypto_box_afternm(c, m, d, n, k);
    }
    function crypto_box_open(m, c, d, n, y, x) {
      var k = new Uint8Array(32);
      crypto_box_beforenm(k, y, x);
      return crypto_box_open_afternm(m, c, d, n, k);
    }
    var K = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function crypto_hashblocks_hl(hh, hl, m, n) {
      var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
      var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
      var pos = 0;
      while (n >= 128) {
        for (i = 0; i < 16; i++) {
          j = 8 * i + pos;
          wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
          wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
        }
        for (i = 0; i < 80; i++) {
          bh0 = ah0;
          bh1 = ah1;
          bh2 = ah2;
          bh3 = ah3;
          bh4 = ah4;
          bh5 = ah5;
          bh6 = ah6;
          bh7 = ah7;
          bl0 = al0;
          bl1 = al1;
          bl2 = al2;
          bl3 = al3;
          bl4 = al4;
          bl5 = al5;
          bl6 = al6;
          bl7 = al7;
          h = ah7;
          l = al7;
          a = l & 65535;
          b = l >>> 16;
          c = h & 65535;
          d = h >>> 16;
          h = (ah4 >>> 14 | al4 << 32 - 14) ^ (ah4 >>> 18 | al4 << 32 - 18) ^ (al4 >>> 41 - 32 | ah4 << 32 - (41 - 32));
          l = (al4 >>> 14 | ah4 << 32 - 14) ^ (al4 >>> 18 | ah4 << 32 - 18) ^ (ah4 >>> 41 - 32 | al4 << 32 - (41 - 32));
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          h = ah4 & ah5 ^ ~ah4 & ah6;
          l = al4 & al5 ^ ~al4 & al6;
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          h = K[i * 2];
          l = K[i * 2 + 1];
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          h = wh[i % 16];
          l = wl[i % 16];
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          b += a >>> 16;
          c += b >>> 16;
          d += c >>> 16;
          th = c & 65535 | d << 16;
          tl = a & 65535 | b << 16;
          h = th;
          l = tl;
          a = l & 65535;
          b = l >>> 16;
          c = h & 65535;
          d = h >>> 16;
          h = (ah0 >>> 28 | al0 << 32 - 28) ^ (al0 >>> 34 - 32 | ah0 << 32 - (34 - 32)) ^ (al0 >>> 39 - 32 | ah0 << 32 - (39 - 32));
          l = (al0 >>> 28 | ah0 << 32 - 28) ^ (ah0 >>> 34 - 32 | al0 << 32 - (34 - 32)) ^ (ah0 >>> 39 - 32 | al0 << 32 - (39 - 32));
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
          l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          b += a >>> 16;
          c += b >>> 16;
          d += c >>> 16;
          bh7 = c & 65535 | d << 16;
          bl7 = a & 65535 | b << 16;
          h = bh3;
          l = bl3;
          a = l & 65535;
          b = l >>> 16;
          c = h & 65535;
          d = h >>> 16;
          h = th;
          l = tl;
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          b += a >>> 16;
          c += b >>> 16;
          d += c >>> 16;
          bh3 = c & 65535 | d << 16;
          bl3 = a & 65535 | b << 16;
          ah1 = bh0;
          ah2 = bh1;
          ah3 = bh2;
          ah4 = bh3;
          ah5 = bh4;
          ah6 = bh5;
          ah7 = bh6;
          ah0 = bh7;
          al1 = bl0;
          al2 = bl1;
          al3 = bl2;
          al4 = bl3;
          al5 = bl4;
          al6 = bl5;
          al7 = bl6;
          al0 = bl7;
          if (i % 16 === 15) {
            for (j = 0; j < 16; j++) {
              h = wh[j];
              l = wl[j];
              a = l & 65535;
              b = l >>> 16;
              c = h & 65535;
              d = h >>> 16;
              h = wh[(j + 9) % 16];
              l = wl[(j + 9) % 16];
              a += l & 65535;
              b += l >>> 16;
              c += h & 65535;
              d += h >>> 16;
              th = wh[(j + 1) % 16];
              tl = wl[(j + 1) % 16];
              h = (th >>> 1 | tl << 32 - 1) ^ (th >>> 8 | tl << 32 - 8) ^ th >>> 7;
              l = (tl >>> 1 | th << 32 - 1) ^ (tl >>> 8 | th << 32 - 8) ^ (tl >>> 7 | th << 32 - 7);
              a += l & 65535;
              b += l >>> 16;
              c += h & 65535;
              d += h >>> 16;
              th = wh[(j + 14) % 16];
              tl = wl[(j + 14) % 16];
              h = (th >>> 19 | tl << 32 - 19) ^ (tl >>> 61 - 32 | th << 32 - (61 - 32)) ^ th >>> 6;
              l = (tl >>> 19 | th << 32 - 19) ^ (th >>> 61 - 32 | tl << 32 - (61 - 32)) ^ (tl >>> 6 | th << 32 - 6);
              a += l & 65535;
              b += l >>> 16;
              c += h & 65535;
              d += h >>> 16;
              b += a >>> 16;
              c += b >>> 16;
              d += c >>> 16;
              wh[j] = c & 65535 | d << 16;
              wl[j] = a & 65535 | b << 16;
            }
          }
        }
        h = ah0;
        l = al0;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 65535 | d << 16;
        hl[0] = al0 = a & 65535 | b << 16;
        h = ah1;
        l = al1;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 65535 | d << 16;
        hl[1] = al1 = a & 65535 | b << 16;
        h = ah2;
        l = al2;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 65535 | d << 16;
        hl[2] = al2 = a & 65535 | b << 16;
        h = ah3;
        l = al3;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 65535 | d << 16;
        hl[3] = al3 = a & 65535 | b << 16;
        h = ah4;
        l = al4;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 65535 | d << 16;
        hl[4] = al4 = a & 65535 | b << 16;
        h = ah5;
        l = al5;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 65535 | d << 16;
        hl[5] = al5 = a & 65535 | b << 16;
        h = ah6;
        l = al6;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 65535 | d << 16;
        hl[6] = al6 = a & 65535 | b << 16;
        h = ah7;
        l = al7;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 65535 | d << 16;
        hl[7] = al7 = a & 65535 | b << 16;
        pos += 128;
        n -= 128;
      }
      return n;
    }
    function crypto_hash(out, m, n) {
      var hh = new Int32Array(8), hl = new Int32Array(8), x = new Uint8Array(256), i, b = n;
      hh[0] = 1779033703;
      hh[1] = 3144134277;
      hh[2] = 1013904242;
      hh[3] = 2773480762;
      hh[4] = 1359893119;
      hh[5] = 2600822924;
      hh[6] = 528734635;
      hh[7] = 1541459225;
      hl[0] = 4089235720;
      hl[1] = 2227873595;
      hl[2] = 4271175723;
      hl[3] = 1595750129;
      hl[4] = 2917565137;
      hl[5] = 725511199;
      hl[6] = 4215389547;
      hl[7] = 327033209;
      crypto_hashblocks_hl(hh, hl, m, n);
      n %= 128;
      for (i = 0; i < n; i++)
        x[i] = m[b - n + i];
      x[n] = 128;
      n = 256 - 128 * (n < 112 ? 1 : 0);
      x[n - 9] = 0;
      ts64(x, n - 8, b / 536870912 | 0, b << 3);
      crypto_hashblocks_hl(hh, hl, x, n);
      for (i = 0; i < 8; i++)
        ts64(out, 8 * i, hh[i], hl[i]);
      return 0;
    }
    function add2(p, q) {
      var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
      Z(a, p[1], p[0]);
      Z(t, q[1], q[0]);
      M(a, a, t);
      A(b, p[0], p[1]);
      A(t, q[0], q[1]);
      M(b, b, t);
      M(c, p[3], q[3]);
      M(c, c, D2);
      M(d, p[2], q[2]);
      A(d, d, d);
      Z(e, b, a);
      Z(f, d, c);
      A(g, d, c);
      A(h, b, a);
      M(p[0], e, f);
      M(p[1], h, g);
      M(p[2], g, f);
      M(p[3], e, h);
    }
    function cswap(p, q, b) {
      var i;
      for (i = 0; i < 4; i++) {
        sel25519(p[i], q[i], b);
      }
    }
    function pack(r, p) {
      var tx = gf(), ty = gf(), zi = gf();
      inv25519(zi, p[2]);
      M(tx, p[0], zi);
      M(ty, p[1], zi);
      pack25519(r, ty);
      r[31] ^= par25519(tx) << 7;
    }
    function scalarmult(p, q, s) {
      var b, i;
      set25519(p[0], gf0);
      set25519(p[1], gf1);
      set25519(p[2], gf1);
      set25519(p[3], gf0);
      for (i = 255; i >= 0; --i) {
        b = s[i / 8 | 0] >> (i & 7) & 1;
        cswap(p, q, b);
        add2(q, p);
        add2(p, p);
        cswap(p, q, b);
      }
    }
    function scalarbase(p, s) {
      var q = [gf(), gf(), gf(), gf()];
      set25519(q[0], X);
      set25519(q[1], Y);
      set25519(q[2], gf1);
      M(q[3], X, Y);
      scalarmult(p, q, s);
    }
    function crypto_sign_keypair(pk, sk, seeded) {
      var d = new Uint8Array(64);
      var p = [gf(), gf(), gf(), gf()];
      var i;
      if (!seeded)
        randombytes(sk, 32);
      crypto_hash(d, sk, 32);
      d[0] &= 248;
      d[31] &= 127;
      d[31] |= 64;
      scalarbase(p, d);
      pack(pk, p);
      for (i = 0; i < 32; i++)
        sk[i + 32] = pk[i];
      return 0;
    }
    var L = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function modL(r, x) {
      var carry, i, j, k;
      for (i = 63; i >= 32; --i) {
        carry = 0;
        for (j = i - 32, k = i - 12; j < k; ++j) {
          x[j] += carry - 16 * x[i] * L[j - (i - 32)];
          carry = Math.floor((x[j] + 128) / 256);
          x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
      }
      carry = 0;
      for (j = 0; j < 32; j++) {
        x[j] += carry - (x[31] >> 4) * L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
      }
      for (j = 0; j < 32; j++)
        x[j] -= carry * L[j];
      for (i = 0; i < 32; i++) {
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
      }
    }
    function reduce(r) {
      var x = new Float64Array(64), i;
      for (i = 0; i < 64; i++)
        x[i] = r[i];
      for (i = 0; i < 64; i++)
        r[i] = 0;
      modL(r, x);
    }
    function crypto_sign(sm, m, n, sk) {
      var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
      var i, j, x = new Float64Array(64);
      var p = [gf(), gf(), gf(), gf()];
      crypto_hash(d, sk, 32);
      d[0] &= 248;
      d[31] &= 127;
      d[31] |= 64;
      var smlen = n + 64;
      for (i = 0; i < n; i++)
        sm[64 + i] = m[i];
      for (i = 0; i < 32; i++)
        sm[32 + i] = d[32 + i];
      crypto_hash(r, sm.subarray(32), n + 32);
      reduce(r);
      scalarbase(p, r);
      pack(sm, p);
      for (i = 32; i < 64; i++)
        sm[i] = sk[i];
      crypto_hash(h, sm, n + 64);
      reduce(h);
      for (i = 0; i < 64; i++)
        x[i] = 0;
      for (i = 0; i < 32; i++)
        x[i] = r[i];
      for (i = 0; i < 32; i++) {
        for (j = 0; j < 32; j++) {
          x[i + j] += h[i] * d[j];
        }
      }
      modL(sm.subarray(32), x);
      return smlen;
    }
    function unpackneg(r, p) {
      var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
      set25519(r[2], gf1);
      unpack25519(r[1], p);
      S(num, r[1]);
      M(den, num, D);
      Z(num, num, r[2]);
      A(den, r[2], den);
      S(den2, den);
      S(den4, den2);
      M(den6, den4, den2);
      M(t, den6, num);
      M(t, t, den);
      pow2523(t, t);
      M(t, t, num);
      M(t, t, den);
      M(t, t, den);
      M(r[0], t, den);
      S(chk, r[0]);
      M(chk, chk, den);
      if (neq25519(chk, num))
        M(r[0], r[0], I);
      S(chk, r[0]);
      M(chk, chk, den);
      if (neq25519(chk, num))
        return -1;
      if (par25519(r[0]) === p[31] >> 7)
        Z(r[0], gf0, r[0]);
      M(r[3], r[0], r[1]);
      return 0;
    }
    function crypto_sign_open(m, sm, n, pk) {
      var i;
      var t = new Uint8Array(32), h = new Uint8Array(64);
      var p = [gf(), gf(), gf(), gf()], q = [gf(), gf(), gf(), gf()];
      if (n < 64)
        return -1;
      if (unpackneg(q, pk))
        return -1;
      for (i = 0; i < n; i++)
        m[i] = sm[i];
      for (i = 0; i < 32; i++)
        m[i + 32] = pk[i];
      crypto_hash(h, m, n);
      reduce(h);
      scalarmult(p, q, h);
      scalarbase(q, sm.subarray(32));
      add2(p, q);
      pack(t, p);
      n -= 64;
      if (crypto_verify_32(sm, 0, t, 0)) {
        for (i = 0; i < n; i++)
          m[i] = 0;
        return -1;
      }
      for (i = 0; i < n; i++)
        m[i] = sm[i + 64];
      return n;
    }
    var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
    nacl.lowlevel = {
      crypto_core_hsalsa20,
      crypto_stream_xor,
      crypto_stream,
      crypto_stream_salsa20_xor,
      crypto_stream_salsa20,
      crypto_onetimeauth,
      crypto_onetimeauth_verify,
      crypto_verify_16,
      crypto_verify_32,
      crypto_secretbox,
      crypto_secretbox_open,
      crypto_scalarmult,
      crypto_scalarmult_base,
      crypto_box_beforenm,
      crypto_box_afternm,
      crypto_box,
      crypto_box_open,
      crypto_box_keypair,
      crypto_hash,
      crypto_sign,
      crypto_sign_keypair,
      crypto_sign_open,
      crypto_secretbox_KEYBYTES,
      crypto_secretbox_NONCEBYTES,
      crypto_secretbox_ZEROBYTES,
      crypto_secretbox_BOXZEROBYTES,
      crypto_scalarmult_BYTES,
      crypto_scalarmult_SCALARBYTES,
      crypto_box_PUBLICKEYBYTES,
      crypto_box_SECRETKEYBYTES,
      crypto_box_BEFORENMBYTES,
      crypto_box_NONCEBYTES,
      crypto_box_ZEROBYTES,
      crypto_box_BOXZEROBYTES,
      crypto_sign_BYTES,
      crypto_sign_PUBLICKEYBYTES,
      crypto_sign_SECRETKEYBYTES,
      crypto_sign_SEEDBYTES,
      crypto_hash_BYTES,
      gf,
      D,
      L,
      pack25519,
      unpack25519,
      M,
      A,
      S,
      Z,
      pow2523,
      add: add2,
      set25519,
      modL,
      scalarmult,
      scalarbase
    };
    function checkLengths(k, n) {
      if (k.length !== crypto_secretbox_KEYBYTES)
        throw new Error("bad key size");
      if (n.length !== crypto_secretbox_NONCEBYTES)
        throw new Error("bad nonce size");
    }
    function checkBoxLengths(pk, sk) {
      if (pk.length !== crypto_box_PUBLICKEYBYTES)
        throw new Error("bad public key size");
      if (sk.length !== crypto_box_SECRETKEYBYTES)
        throw new Error("bad secret key size");
    }
    function checkArrayTypes() {
      for (var i = 0; i < arguments.length; i++) {
        if (!(arguments[i] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
      }
    }
    function cleanup(arr) {
      for (var i = 0; i < arr.length; i++)
        arr[i] = 0;
    }
    nacl.randomBytes = function(n) {
      var b = new Uint8Array(n);
      randombytes(b, n);
      return b;
    };
    nacl.secretbox = function(msg, nonce, key) {
      checkArrayTypes(msg, nonce, key);
      checkLengths(key, nonce);
      var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
      var c = new Uint8Array(m.length);
      for (var i = 0; i < msg.length; i++)
        m[i + crypto_secretbox_ZEROBYTES] = msg[i];
      crypto_secretbox(c, m, m.length, nonce, key);
      return c.subarray(crypto_secretbox_BOXZEROBYTES);
    };
    nacl.secretbox.open = function(box, nonce, key) {
      checkArrayTypes(box, nonce, key);
      checkLengths(key, nonce);
      var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
      var m = new Uint8Array(c.length);
      for (var i = 0; i < box.length; i++)
        c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
      if (c.length < 32)
        return null;
      if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0)
        return null;
      return m.subarray(crypto_secretbox_ZEROBYTES);
    };
    nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
    nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
    nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
    nacl.scalarMult = function(n, p) {
      checkArrayTypes(n, p);
      if (n.length !== crypto_scalarmult_SCALARBYTES)
        throw new Error("bad n size");
      if (p.length !== crypto_scalarmult_BYTES)
        throw new Error("bad p size");
      var q = new Uint8Array(crypto_scalarmult_BYTES);
      crypto_scalarmult(q, n, p);
      return q;
    };
    nacl.scalarMult.base = function(n) {
      checkArrayTypes(n);
      if (n.length !== crypto_scalarmult_SCALARBYTES)
        throw new Error("bad n size");
      var q = new Uint8Array(crypto_scalarmult_BYTES);
      crypto_scalarmult_base(q, n);
      return q;
    };
    nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
    nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
    nacl.box = function(msg, nonce, publicKey, secretKey) {
      var k = nacl.box.before(publicKey, secretKey);
      return nacl.secretbox(msg, nonce, k);
    };
    nacl.box.before = function(publicKey, secretKey) {
      checkArrayTypes(publicKey, secretKey);
      checkBoxLengths(publicKey, secretKey);
      var k = new Uint8Array(crypto_box_BEFORENMBYTES);
      crypto_box_beforenm(k, publicKey, secretKey);
      return k;
    };
    nacl.box.after = nacl.secretbox;
    nacl.box.open = function(msg, nonce, publicKey, secretKey) {
      var k = nacl.box.before(publicKey, secretKey);
      return nacl.secretbox.open(msg, nonce, k);
    };
    nacl.box.open.after = nacl.secretbox.open;
    nacl.box.keyPair = function() {
      var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
      var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
      crypto_box_keypair(pk, sk);
      return { publicKey: pk, secretKey: sk };
    };
    nacl.box.keyPair.fromSecretKey = function(secretKey) {
      checkArrayTypes(secretKey);
      if (secretKey.length !== crypto_box_SECRETKEYBYTES)
        throw new Error("bad secret key size");
      var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
      crypto_scalarmult_base(pk, secretKey);
      return { publicKey: pk, secretKey: new Uint8Array(secretKey) };
    };
    nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
    nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
    nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
    nacl.box.nonceLength = crypto_box_NONCEBYTES;
    nacl.box.overheadLength = nacl.secretbox.overheadLength;
    nacl.sign = function(msg, secretKey) {
      checkArrayTypes(msg, secretKey);
      if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
        throw new Error("bad secret key size");
      var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
      crypto_sign(signedMsg, msg, msg.length, secretKey);
      return signedMsg;
    };
    nacl.sign.open = function(signedMsg, publicKey) {
      checkArrayTypes(signedMsg, publicKey);
      if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
        throw new Error("bad public key size");
      var tmp = new Uint8Array(signedMsg.length);
      var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
      if (mlen < 0)
        return null;
      var m = new Uint8Array(mlen);
      for (var i = 0; i < m.length; i++)
        m[i] = tmp[i];
      return m;
    };
    nacl.sign.detached = function(msg, secretKey) {
      var signedMsg = nacl.sign(msg, secretKey);
      var sig = new Uint8Array(crypto_sign_BYTES);
      for (var i = 0; i < sig.length; i++)
        sig[i] = signedMsg[i];
      return sig;
    };
    nacl.sign.detached.verify = function(msg, sig, publicKey) {
      checkArrayTypes(msg, sig, publicKey);
      if (sig.length !== crypto_sign_BYTES)
        throw new Error("bad signature size");
      if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
        throw new Error("bad public key size");
      var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
      var m = new Uint8Array(crypto_sign_BYTES + msg.length);
      var i;
      for (i = 0; i < crypto_sign_BYTES; i++)
        sm[i] = sig[i];
      for (i = 0; i < msg.length; i++)
        sm[i + crypto_sign_BYTES] = msg[i];
      return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
    };
    nacl.sign.keyPair = function() {
      var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
      var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
      crypto_sign_keypair(pk, sk);
      return { publicKey: pk, secretKey: sk };
    };
    nacl.sign.keyPair.fromSecretKey = function(secretKey) {
      checkArrayTypes(secretKey);
      if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
        throw new Error("bad secret key size");
      var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
      for (var i = 0; i < pk.length; i++)
        pk[i] = secretKey[32 + i];
      return { publicKey: pk, secretKey: new Uint8Array(secretKey) };
    };
    nacl.sign.keyPair.fromSeed = function(seed) {
      checkArrayTypes(seed);
      if (seed.length !== crypto_sign_SEEDBYTES)
        throw new Error("bad seed size");
      var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
      var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
      for (var i = 0; i < 32; i++)
        sk[i] = seed[i];
      crypto_sign_keypair(pk, sk, true);
      return { publicKey: pk, secretKey: sk };
    };
    nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
    nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
    nacl.sign.seedLength = crypto_sign_SEEDBYTES;
    nacl.sign.signatureLength = crypto_sign_BYTES;
    nacl.hash = function(msg) {
      checkArrayTypes(msg);
      var h = new Uint8Array(crypto_hash_BYTES);
      crypto_hash(h, msg, msg.length);
      return h;
    };
    nacl.hash.hashLength = crypto_hash_BYTES;
    nacl.verify = function(x, y) {
      checkArrayTypes(x, y);
      if (x.length === 0 || y.length === 0)
        return false;
      if (x.length !== y.length)
        return false;
      return vn(x, 0, y, 0, x.length) === 0 ? true : false;
    };
    nacl.setPRNG = function(fn) {
      randombytes = fn;
    };
    (function() {
      var crypto2 = typeof self !== "undefined" ? self.crypto || self.msCrypto : null;
      if (crypto2 && crypto2.getRandomValues) {
        var QUOTA = 65536;
        nacl.setPRNG(function(x, n) {
          var i, v = new Uint8Array(n);
          for (i = 0; i < n; i += QUOTA) {
            crypto2.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
          }
          for (i = 0; i < n; i++)
            x[i] = v[i];
          cleanup(v);
        });
      } else if (typeof commonjsRequire !== "undefined") {
        crypto2 = require$$0$1;
        if (crypto2 && crypto2.randomBytes) {
          nacl.setPRNG(function(x, n) {
            var i, v = crypto2.randomBytes(n);
            for (i = 0; i < n; i++)
              x[i] = v[i];
            cleanup(v);
          });
        }
      }
    })();
  })(module.exports ? module.exports : self.nacl = self.nacl || {});
})(naclFast);
const nacl2 = naclFast.exports;
var bip39 = {};
var _assert = {};
Object.defineProperty(_assert, "__esModule", { value: true });
_assert.output = _assert.exists = _assert.hash = _assert.bytes = _assert.bool = _assert.number = void 0;
function number$1(n) {
  if (!Number.isSafeInteger(n) || n < 0)
    throw new Error(`Wrong positive integer: ${n}`);
}
_assert.number = number$1;
function bool$1(b) {
  if (typeof b !== "boolean")
    throw new Error(`Expected boolean, not ${b}`);
}
_assert.bool = bool$1;
function bytes$1(b, ...lengths) {
  if (!(b instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (lengths.length > 0 && !lengths.includes(b.length))
    throw new TypeError(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
_assert.bytes = bytes$1;
function hash$1(hash2) {
  if (typeof hash2 !== "function" || typeof hash2.create !== "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$1(hash2.outputLen);
  number$1(hash2.blockLen);
}
_assert.hash = hash$1;
function exists$1(instance, checkFinished = true) {
  if (instance.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (checkFinished && instance.finished)
    throw new Error("Hash#digest() has already been called");
}
_assert.exists = exists$1;
function output$1(out, instance) {
  bytes$1(out);
  const min2 = instance.outputLen;
  if (out.length < min2) {
    throw new Error(`digestInto() expects output buffer of length at least ${min2}`);
  }
}
_assert.output = output$1;
const assert$1 = {
  number: number$1,
  bool: bool$1,
  bytes: bytes$1,
  hash: hash$1,
  exists: exists$1,
  output: output$1
};
_assert.default = assert$1;
var pbkdf2$1 = {};
var hmac$1 = {};
var utils$d = {};
const crypto = {
  node: void 0,
  web: typeof self === "object" && "crypto" in self ? self.crypto : void 0
};
const cryptoBrowser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  crypto
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(cryptoBrowser);
(function(exports) {
  /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.randomBytes = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.checkOpts = exports.Hash = exports.concatBytes = exports.toBytes = exports.utf8ToBytes = exports.asyncLoop = exports.nextTick = exports.hexToBytes = exports.bytesToHex = exports.isLE = exports.rotr = exports.createView = exports.u32 = exports.u8 = void 0;
  const crypto_1 = require$$0;
  const u82 = (arr) => new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
  exports.u8 = u82;
  const u322 = (arr) => new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
  exports.u32 = u322;
  const createView2 = (arr) => new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
  exports.createView = createView2;
  const rotr2 = (word, shift) => word << 32 - shift | word >>> shift;
  exports.rotr = rotr2;
  exports.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
  if (!exports.isLE)
    throw new Error("Non little-endian hardware is not supported");
  const hexes2 = Array.from({ length: 256 }, (v, i) => i.toString(16).padStart(2, "0"));
  function bytesToHex2(uint8a) {
    if (!(uint8a instanceof Uint8Array))
      throw new Error("Uint8Array expected");
    let hex = "";
    for (let i = 0; i < uint8a.length; i++) {
      hex += hexes2[uint8a[i]];
    }
    return hex;
  }
  exports.bytesToHex = bytesToHex2;
  function hexToBytes2(hex) {
    if (typeof hex !== "string") {
      throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    }
    if (hex.length % 2)
      throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for (let i = 0; i < array.length; i++) {
      const j = i * 2;
      const hexByte = hex.slice(j, j + 2);
      const byte = Number.parseInt(hexByte, 16);
      if (Number.isNaN(byte) || byte < 0)
        throw new Error("Invalid byte sequence");
      array[i] = byte;
    }
    return array;
  }
  exports.hexToBytes = hexToBytes2;
  const nextTick2 = async () => {
  };
  exports.nextTick = nextTick2;
  async function asyncLoop2(iters, tick, cb) {
    let ts = Date.now();
    for (let i = 0; i < iters; i++) {
      cb(i);
      const diff = Date.now() - ts;
      if (diff >= 0 && diff < tick)
        continue;
      await (0, exports.nextTick)();
      ts += diff;
    }
  }
  exports.asyncLoop = asyncLoop2;
  function utf8ToBytes2(str) {
    if (typeof str !== "string") {
      throw new TypeError(`utf8ToBytes expected string, got ${typeof str}`);
    }
    return new TextEncoder().encode(str);
  }
  exports.utf8ToBytes = utf8ToBytes2;
  function toBytes2(data2) {
    if (typeof data2 === "string")
      data2 = utf8ToBytes2(data2);
    if (!(data2 instanceof Uint8Array))
      throw new TypeError(`Expected input type is Uint8Array (got ${typeof data2})`);
    return data2;
  }
  exports.toBytes = toBytes2;
  function concatBytes2(...arrays) {
    if (!arrays.every((a) => a instanceof Uint8Array))
      throw new Error("Uint8Array list expected");
    if (arrays.length === 1)
      return arrays[0];
    const length = arrays.reduce((a, arr) => a + arr.length, 0);
    const result = new Uint8Array(length);
    for (let i = 0, pad = 0; i < arrays.length; i++) {
      const arr = arrays[i];
      result.set(arr, pad);
      pad += arr.length;
    }
    return result;
  }
  exports.concatBytes = concatBytes2;
  class Hash2 {
    clone() {
      return this._cloneInto();
    }
  }
  exports.Hash = Hash2;
  const isPlainObject2 = (obj) => Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
  function checkOpts2(defaults2, opts) {
    if (opts !== void 0 && (typeof opts !== "object" || !isPlainObject2(opts)))
      throw new TypeError("Options should be object or undefined");
    const merged = Object.assign(defaults2, opts);
    return merged;
  }
  exports.checkOpts = checkOpts2;
  function wrapConstructor2(hashConstructor) {
    const hashC = (message) => hashConstructor().update(toBytes2(message)).digest();
    const tmp = hashConstructor();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = () => hashConstructor();
    return hashC;
  }
  exports.wrapConstructor = wrapConstructor2;
  function wrapConstructorWithOpts2(hashCons) {
    const hashC = (msg, opts) => hashCons(opts).update(toBytes2(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts) => hashCons(opts);
    return hashC;
  }
  exports.wrapConstructorWithOpts = wrapConstructorWithOpts2;
  function randomBytes2(bytesLength = 32) {
    if (crypto_1.crypto.web) {
      return crypto_1.crypto.web.getRandomValues(new Uint8Array(bytesLength));
    } else if (crypto_1.crypto.node) {
      return new Uint8Array(crypto_1.crypto.node.randomBytes(bytesLength).buffer);
    } else {
      throw new Error("The environment doesn't have randomBytes function");
    }
  }
  exports.randomBytes = randomBytes2;
})(utils$d);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.hmac = void 0;
  const _assert_js_12 = _assert;
  const utils_js_12 = utils$d;
  class HMAC2 extends utils_js_12.Hash {
    constructor(hash2, _key) {
      super();
      this.finished = false;
      this.destroyed = false;
      _assert_js_12.default.hash(hash2);
      const key = (0, utils_js_12.toBytes)(_key);
      this.iHash = hash2.create();
      if (typeof this.iHash.update !== "function")
        throw new TypeError("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen;
      this.outputLen = this.iHash.outputLen;
      const blockLen = this.blockLen;
      const pad = new Uint8Array(blockLen);
      pad.set(key.length > blockLen ? hash2.create().update(key).digest() : key);
      for (let i = 0; i < pad.length; i++)
        pad[i] ^= 54;
      this.iHash.update(pad);
      this.oHash = hash2.create();
      for (let i = 0; i < pad.length; i++)
        pad[i] ^= 54 ^ 92;
      this.oHash.update(pad);
      pad.fill(0);
    }
    update(buf) {
      _assert_js_12.default.exists(this);
      this.iHash.update(buf);
      return this;
    }
    digestInto(out) {
      _assert_js_12.default.exists(this);
      _assert_js_12.default.bytes(out, this.outputLen);
      this.finished = true;
      this.iHash.digestInto(out);
      this.oHash.update(out);
      this.oHash.digestInto(out);
      this.destroy();
    }
    digest() {
      const out = new Uint8Array(this.oHash.outputLen);
      this.digestInto(out);
      return out;
    }
    _cloneInto(to) {
      to || (to = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
      to = to;
      to.finished = finished;
      to.destroyed = destroyed;
      to.blockLen = blockLen;
      to.outputLen = outputLen;
      to.oHash = oHash._cloneInto(to.oHash);
      to.iHash = iHash._cloneInto(to.iHash);
      return to;
    }
    destroy() {
      this.destroyed = true;
      this.oHash.destroy();
      this.iHash.destroy();
    }
  }
  const hmac2 = (hash2, key, message) => new HMAC2(hash2, key).update(message).digest();
  exports.hmac = hmac2;
  exports.hmac.create = (hash2, key) => new HMAC2(hash2, key);
})(hmac$1);
Object.defineProperty(pbkdf2$1, "__esModule", { value: true });
pbkdf2$1.pbkdf2Async = pbkdf2$1.pbkdf2 = void 0;
const _assert_js_1$1 = _assert;
const hmac_js_1 = hmac$1;
const utils_js_1$2 = utils$d;
function pbkdf2Init(hash2, _password, _salt, _opts) {
  _assert_js_1$1.default.hash(hash2);
  const opts = (0, utils_js_1$2.checkOpts)({ dkLen: 32, asyncTick: 10 }, _opts);
  const { c, dkLen, asyncTick } = opts;
  _assert_js_1$1.default.number(c);
  _assert_js_1$1.default.number(dkLen);
  _assert_js_1$1.default.number(asyncTick);
  if (c < 1)
    throw new Error("PBKDF2: iterations (c) should be >= 1");
  const password = (0, utils_js_1$2.toBytes)(_password);
  const salt2 = (0, utils_js_1$2.toBytes)(_salt);
  const DK = new Uint8Array(dkLen);
  const PRF = hmac_js_1.hmac.create(hash2, password);
  const PRFSalt = PRF._cloneInto().update(salt2);
  return { c, dkLen, asyncTick, DK, PRF, PRFSalt };
}
function pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
  PRF.destroy();
  PRFSalt.destroy();
  if (prfW)
    prfW.destroy();
  u.fill(0);
  return DK;
}
function pbkdf2(hash2, password, salt2, opts) {
  const { c, dkLen, DK, PRF, PRFSalt } = pbkdf2Init(hash2, password, salt2, opts);
  let prfW;
  const arr = new Uint8Array(4);
  const view = (0, utils_js_1$2.createView)(arr);
  const u = new Uint8Array(PRF.outputLen);
  for (let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen) {
    const Ti = DK.subarray(pos, pos + PRF.outputLen);
    view.setInt32(0, ti, false);
    (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
    Ti.set(u.subarray(0, Ti.length));
    for (let ui = 1; ui < c; ui++) {
      PRF._cloneInto(prfW).update(u).digestInto(u);
      for (let i = 0; i < Ti.length; i++)
        Ti[i] ^= u[i];
    }
  }
  return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
pbkdf2$1.pbkdf2 = pbkdf2;
async function pbkdf2Async(hash2, password, salt2, opts) {
  const { c, dkLen, asyncTick, DK, PRF, PRFSalt } = pbkdf2Init(hash2, password, salt2, opts);
  let prfW;
  const arr = new Uint8Array(4);
  const view = (0, utils_js_1$2.createView)(arr);
  const u = new Uint8Array(PRF.outputLen);
  for (let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen) {
    const Ti = DK.subarray(pos, pos + PRF.outputLen);
    view.setInt32(0, ti, false);
    (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
    Ti.set(u.subarray(0, Ti.length));
    await (0, utils_js_1$2.asyncLoop)(c - 1, asyncTick, (i) => {
      PRF._cloneInto(prfW).update(u).digestInto(u);
      for (let i2 = 0; i2 < Ti.length; i2++)
        Ti[i2] ^= u[i2];
    });
  }
  return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
pbkdf2$1.pbkdf2Async = pbkdf2Async;
var sha256 = {};
var _sha2 = {};
Object.defineProperty(_sha2, "__esModule", { value: true });
_sha2.SHA2 = void 0;
const _assert_js_1 = _assert;
const utils_js_1$1 = utils$d;
function setBigUint64$1(view, byteOffset, value, isLE2) {
  if (typeof view.setBigUint64 === "function")
    return view.setBigUint64(byteOffset, value, isLE2);
  const _32n2 = BigInt(32);
  const _u32_max = BigInt(4294967295);
  const wh = Number(value >> _32n2 & _u32_max);
  const wl = Number(value & _u32_max);
  const h = isLE2 ? 4 : 0;
  const l = isLE2 ? 0 : 4;
  view.setUint32(byteOffset + h, wh, isLE2);
  view.setUint32(byteOffset + l, wl, isLE2);
}
class SHA2$1 extends utils_js_1$1.Hash {
  constructor(blockLen, outputLen, padOffset, isLE2) {
    super();
    this.blockLen = blockLen;
    this.outputLen = outputLen;
    this.padOffset = padOffset;
    this.isLE = isLE2;
    this.finished = false;
    this.length = 0;
    this.pos = 0;
    this.destroyed = false;
    this.buffer = new Uint8Array(blockLen);
    this.view = (0, utils_js_1$1.createView)(this.buffer);
  }
  update(data2) {
    _assert_js_1.default.exists(this);
    const { view, buffer, blockLen } = this;
    data2 = (0, utils_js_1$1.toBytes)(data2);
    const len = data2.length;
    for (let pos = 0; pos < len; ) {
      const take = Math.min(blockLen - this.pos, len - pos);
      if (take === blockLen) {
        const dataView = (0, utils_js_1$1.createView)(data2);
        for (; blockLen <= len - pos; pos += blockLen)
          this.process(dataView, pos);
        continue;
      }
      buffer.set(data2.subarray(pos, pos + take), this.pos);
      this.pos += take;
      pos += take;
      if (this.pos === blockLen) {
        this.process(view, 0);
        this.pos = 0;
      }
    }
    this.length += data2.length;
    this.roundClean();
    return this;
  }
  digestInto(out) {
    _assert_js_1.default.exists(this);
    _assert_js_1.default.output(out, this);
    this.finished = true;
    const { buffer, view, blockLen, isLE: isLE2 } = this;
    let { pos } = this;
    buffer[pos++] = 128;
    this.buffer.subarray(pos).fill(0);
    if (this.padOffset > blockLen - pos) {
      this.process(view, 0);
      pos = 0;
    }
    for (let i = pos; i < blockLen; i++)
      buffer[i] = 0;
    setBigUint64$1(view, blockLen - 8, BigInt(this.length * 8), isLE2);
    this.process(view, 0);
    const oview = (0, utils_js_1$1.createView)(out);
    this.get().forEach((v, i) => oview.setUint32(4 * i, v, isLE2));
  }
  digest() {
    const { buffer, outputLen } = this;
    this.digestInto(buffer);
    const res = buffer.slice(0, outputLen);
    this.destroy();
    return res;
  }
  _cloneInto(to) {
    to || (to = new this.constructor());
    to.set(...this.get());
    const { blockLen, buffer, length, finished, destroyed, pos } = this;
    to.length = length;
    to.pos = pos;
    to.finished = finished;
    to.destroyed = destroyed;
    if (length % blockLen)
      to.buffer.set(buffer);
    return to;
  }
}
_sha2.SHA2 = SHA2$1;
Object.defineProperty(sha256, "__esModule", { value: true });
sha256.sha256 = void 0;
const _sha2_js_1 = _sha2;
const utils_js_1 = utils$d;
const Chi = (a, b, c) => a & b ^ ~a & c;
const Maj = (a, b, c) => a & b ^ a & c ^ b & c;
const SHA256_K = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]);
const IV = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]);
const SHA256_W = new Uint32Array(64);
class SHA256 extends _sha2_js_1.SHA2 {
  constructor() {
    super(64, 32, 8, false);
    this.A = IV[0] | 0;
    this.B = IV[1] | 0;
    this.C = IV[2] | 0;
    this.D = IV[3] | 0;
    this.E = IV[4] | 0;
    this.F = IV[5] | 0;
    this.G = IV[6] | 0;
    this.H = IV[7] | 0;
  }
  get() {
    const { A, B, C, D, E, F, G, H } = this;
    return [A, B, C, D, E, F, G, H];
  }
  set(A, B, C, D, E, F, G, H) {
    this.A = A | 0;
    this.B = B | 0;
    this.C = C | 0;
    this.D = D | 0;
    this.E = E | 0;
    this.F = F | 0;
    this.G = G | 0;
    this.H = H | 0;
  }
  process(view, offset) {
    for (let i = 0; i < 16; i++, offset += 4)
      SHA256_W[i] = view.getUint32(offset, false);
    for (let i = 16; i < 64; i++) {
      const W15 = SHA256_W[i - 15];
      const W2 = SHA256_W[i - 2];
      const s0 = (0, utils_js_1.rotr)(W15, 7) ^ (0, utils_js_1.rotr)(W15, 18) ^ W15 >>> 3;
      const s1 = (0, utils_js_1.rotr)(W2, 17) ^ (0, utils_js_1.rotr)(W2, 19) ^ W2 >>> 10;
      SHA256_W[i] = s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16] | 0;
    }
    let { A, B, C, D, E, F, G, H } = this;
    for (let i = 0; i < 64; i++) {
      const sigma1 = (0, utils_js_1.rotr)(E, 6) ^ (0, utils_js_1.rotr)(E, 11) ^ (0, utils_js_1.rotr)(E, 25);
      const T1 = H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i] | 0;
      const sigma0 = (0, utils_js_1.rotr)(A, 2) ^ (0, utils_js_1.rotr)(A, 13) ^ (0, utils_js_1.rotr)(A, 22);
      const T2 = sigma0 + Maj(A, B, C) | 0;
      H = G;
      G = F;
      F = E;
      E = D + T1 | 0;
      D = C;
      C = B;
      B = A;
      A = T1 + T2 | 0;
    }
    A = A + this.A | 0;
    B = B + this.B | 0;
    C = C + this.C | 0;
    D = D + this.D | 0;
    E = E + this.E | 0;
    F = F + this.F | 0;
    G = G + this.G | 0;
    H = H + this.H | 0;
    this.set(A, B, C, D, E, F, G, H);
  }
  roundClean() {
    SHA256_W.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0);
    this.buffer.fill(0);
  }
}
sha256.sha256 = (0, utils_js_1.wrapConstructor)(() => new SHA256());
function number(n) {
  if (!Number.isSafeInteger(n) || n < 0)
    throw new Error(`Wrong positive integer: ${n}`);
}
function bool(b) {
  if (typeof b !== "boolean")
    throw new Error(`Expected boolean, not ${b}`);
}
function bytes(b, ...lengths) {
  if (!(b instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (lengths.length > 0 && !lengths.includes(b.length))
    throw new TypeError(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function hash(hash2) {
  if (typeof hash2 !== "function" || typeof hash2.create !== "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number(hash2.outputLen);
  number(hash2.blockLen);
}
function exists(instance, checkFinished = true) {
  if (instance.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (checkFinished && instance.finished)
    throw new Error("Hash#digest() has already been called");
}
function output(out, instance) {
  bytes(out);
  const min2 = instance.outputLen;
  if (out.length < min2) {
    throw new Error(`digestInto() expects output buffer of length at least ${min2}`);
  }
}
const assert = {
  number,
  bool,
  bytes,
  hash,
  exists,
  output
};
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const u8 = (arr) => new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const u32 = (arr) => new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const createView = (arr) => new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const rotr = (word, shift) => word << 32 - shift | word >>> shift;
const isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!isLE)
  throw new Error("Non little-endian hardware is not supported");
const hexes = Array.from({ length: 256 }, (v, i) => i.toString(16).padStart(2, "0"));
function bytesToHex(uint8a) {
  if (!(uint8a instanceof Uint8Array))
    throw new Error("Uint8Array expected");
  let hex = "";
  for (let i = 0; i < uint8a.length; i++) {
    hex += hexes[uint8a[i]];
  }
  return hex;
}
function hexToBytes(hex) {
  if (typeof hex !== "string") {
    throw new TypeError("hexToBytes: expected string, got " + typeof hex);
  }
  if (hex.length % 2)
    throw new Error("hexToBytes: received invalid unpadded hex");
  const array = new Uint8Array(hex.length / 2);
  for (let i = 0; i < array.length; i++) {
    const j = i * 2;
    const hexByte = hex.slice(j, j + 2);
    const byte = Number.parseInt(hexByte, 16);
    if (Number.isNaN(byte) || byte < 0)
      throw new Error("Invalid byte sequence");
    array[i] = byte;
  }
  return array;
}
const nextTick = async () => {
};
async function asyncLoop(iters, tick, cb) {
  let ts = Date.now();
  for (let i = 0; i < iters; i++) {
    cb(i);
    const diff = Date.now() - ts;
    if (diff >= 0 && diff < tick)
      continue;
    await nextTick();
    ts += diff;
  }
}
function utf8ToBytes(str) {
  if (typeof str !== "string") {
    throw new TypeError(`utf8ToBytes expected string, got ${typeof str}`);
  }
  return new TextEncoder().encode(str);
}
function toBytes(data2) {
  if (typeof data2 === "string")
    data2 = utf8ToBytes(data2);
  if (!(data2 instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof data2})`);
  return data2;
}
function concatBytes(...arrays) {
  if (!arrays.every((a) => a instanceof Uint8Array))
    throw new Error("Uint8Array list expected");
  if (arrays.length === 1)
    return arrays[0];
  const length = arrays.reduce((a, arr) => a + arr.length, 0);
  const result = new Uint8Array(length);
  for (let i = 0, pad = 0; i < arrays.length; i++) {
    const arr = arrays[i];
    result.set(arr, pad);
    pad += arr.length;
  }
  return result;
}
class Hash {
  clone() {
    return this._cloneInto();
  }
}
const isPlainObject$1 = (obj) => Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
function checkOpts(defaults2, opts) {
  if (opts !== void 0 && (typeof opts !== "object" || !isPlainObject$1(opts)))
    throw new TypeError("Options should be object or undefined");
  const merged = Object.assign(defaults2, opts);
  return merged;
}
function wrapConstructor(hashConstructor) {
  const hashC = (message) => hashConstructor().update(toBytes(message)).digest();
  const tmp = hashConstructor();
  hashC.outputLen = tmp.outputLen;
  hashC.blockLen = tmp.blockLen;
  hashC.create = () => hashConstructor();
  return hashC;
}
function wrapConstructorWithOpts(hashCons) {
  const hashC = (msg, opts) => hashCons(opts).update(toBytes(msg)).digest();
  const tmp = hashCons({});
  hashC.outputLen = tmp.outputLen;
  hashC.blockLen = tmp.blockLen;
  hashC.create = (opts) => hashCons(opts);
  return hashC;
}
function randomBytes(bytesLength = 32) {
  if (crypto.web) {
    return crypto.web.getRandomValues(new Uint8Array(bytesLength));
  } else if (crypto.node) {
    return new Uint8Array(crypto.node.randomBytes(bytesLength).buffer);
  } else {
    throw new Error("The environment doesn't have randomBytes function");
  }
}
const utils$c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  u8,
  u32,
  createView,
  rotr,
  isLE,
  bytesToHex,
  hexToBytes,
  nextTick,
  asyncLoop,
  utf8ToBytes,
  toBytes,
  concatBytes,
  Hash,
  checkOpts,
  wrapConstructor,
  wrapConstructorWithOpts,
  randomBytes
}, Symbol.toStringTag, { value: "Module" }));
function setBigUint64(view, byteOffset, value, isLE2) {
  if (typeof view.setBigUint64 === "function")
    return view.setBigUint64(byteOffset, value, isLE2);
  const _32n2 = BigInt(32);
  const _u32_max = BigInt(4294967295);
  const wh = Number(value >> _32n2 & _u32_max);
  const wl = Number(value & _u32_max);
  const h = isLE2 ? 4 : 0;
  const l = isLE2 ? 0 : 4;
  view.setUint32(byteOffset + h, wh, isLE2);
  view.setUint32(byteOffset + l, wl, isLE2);
}
class SHA2 extends Hash {
  constructor(blockLen, outputLen, padOffset, isLE2) {
    super();
    this.blockLen = blockLen;
    this.outputLen = outputLen;
    this.padOffset = padOffset;
    this.isLE = isLE2;
    this.finished = false;
    this.length = 0;
    this.pos = 0;
    this.destroyed = false;
    this.buffer = new Uint8Array(blockLen);
    this.view = createView(this.buffer);
  }
  update(data2) {
    assert.exists(this);
    const { view, buffer, blockLen } = this;
    data2 = toBytes(data2);
    const len = data2.length;
    for (let pos = 0; pos < len; ) {
      const take = Math.min(blockLen - this.pos, len - pos);
      if (take === blockLen) {
        const dataView = createView(data2);
        for (; blockLen <= len - pos; pos += blockLen)
          this.process(dataView, pos);
        continue;
      }
      buffer.set(data2.subarray(pos, pos + take), this.pos);
      this.pos += take;
      pos += take;
      if (this.pos === blockLen) {
        this.process(view, 0);
        this.pos = 0;
      }
    }
    this.length += data2.length;
    this.roundClean();
    return this;
  }
  digestInto(out) {
    assert.exists(this);
    assert.output(out, this);
    this.finished = true;
    const { buffer, view, blockLen, isLE: isLE2 } = this;
    let { pos } = this;
    buffer[pos++] = 128;
    this.buffer.subarray(pos).fill(0);
    if (this.padOffset > blockLen - pos) {
      this.process(view, 0);
      pos = 0;
    }
    for (let i = pos; i < blockLen; i++)
      buffer[i] = 0;
    setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE2);
    this.process(view, 0);
    const oview = createView(out);
    this.get().forEach((v, i) => oview.setUint32(4 * i, v, isLE2));
  }
  digest() {
    const { buffer, outputLen } = this;
    this.digestInto(buffer);
    const res = buffer.slice(0, outputLen);
    this.destroy();
    return res;
  }
  _cloneInto(to) {
    to || (to = new this.constructor());
    to.set(...this.get());
    const { blockLen, buffer, length, finished, destroyed, pos } = this;
    to.length = length;
    to.pos = pos;
    to.finished = finished;
    to.destroyed = destroyed;
    if (length % blockLen)
      to.buffer.set(buffer);
    return to;
  }
}
const U32_MASK64 = BigInt(2 ** 32 - 1);
const _32n = BigInt(32);
function fromBig(n, le = false) {
  if (le)
    return { h: Number(n & U32_MASK64), l: Number(n >> _32n & U32_MASK64) };
  return { h: Number(n >> _32n & U32_MASK64) | 0, l: Number(n & U32_MASK64) | 0 };
}
function split(lst, le = false) {
  let Ah = new Uint32Array(lst.length);
  let Al = new Uint32Array(lst.length);
  for (let i = 0; i < lst.length; i++) {
    const { h, l } = fromBig(lst[i], le);
    [Ah[i], Al[i]] = [h, l];
  }
  return [Ah, Al];
}
const toBig = (h, l) => BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
const shrSH = (h, l, s) => h >>> s;
const shrSL = (h, l, s) => h << 32 - s | l >>> s;
const rotrSH = (h, l, s) => h >>> s | l << 32 - s;
const rotrSL = (h, l, s) => h << 32 - s | l >>> s;
const rotrBH = (h, l, s) => h << 64 - s | l >>> s - 32;
const rotrBL = (h, l, s) => h >>> s - 32 | l << 64 - s;
const rotr32H = (h, l) => l;
const rotr32L = (h, l) => h;
const rotlSH = (h, l, s) => h << s | l >>> 32 - s;
const rotlSL = (h, l, s) => l << s | h >>> 32 - s;
const rotlBH = (h, l, s) => l << s - 32 | h >>> 64 - s;
const rotlBL = (h, l, s) => h << s - 32 | l >>> 64 - s;
function add(Ah, Al, Bh, Bl) {
  const l = (Al >>> 0) + (Bl >>> 0);
  return { h: Ah + Bh + (l / 2 ** 32 | 0) | 0, l: l | 0 };
}
const add3L = (Al, Bl, Cl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const add3H = (low, Ah, Bh, Ch) => Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const add4L = (Al, Bl, Cl, Dl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const add4H = (low, Ah, Bh, Ch, Dh) => Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const add5L = (Al, Bl, Cl, Dl, El) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const add5H = (low, Ah, Bh, Ch, Dh, Eh) => Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
const u64 = {
  fromBig,
  split,
  toBig,
  shrSH,
  shrSL,
  rotrSH,
  rotrSL,
  rotrBH,
  rotrBL,
  rotr32H,
  rotr32L,
  rotlSH,
  rotlSL,
  rotlBH,
  rotlBL,
  add,
  add3L,
  add3H,
  add4L,
  add4H,
  add5H,
  add5L
};
const [SHA512_Kh, SHA512_Kl] = u64.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((n) => BigInt(n)));
const SHA512_W_H = new Uint32Array(80);
const SHA512_W_L = new Uint32Array(80);
class SHA512 extends SHA2 {
  constructor() {
    super(128, 64, 16, false);
    this.Ah = 1779033703 | 0;
    this.Al = 4089235720 | 0;
    this.Bh = 3144134277 | 0;
    this.Bl = 2227873595 | 0;
    this.Ch = 1013904242 | 0;
    this.Cl = 4271175723 | 0;
    this.Dh = 2773480762 | 0;
    this.Dl = 1595750129 | 0;
    this.Eh = 1359893119 | 0;
    this.El = 2917565137 | 0;
    this.Fh = 2600822924 | 0;
    this.Fl = 725511199 | 0;
    this.Gh = 528734635 | 0;
    this.Gl = 4215389547 | 0;
    this.Hh = 1541459225 | 0;
    this.Hl = 327033209 | 0;
  }
  get() {
    const { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
    return [Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl];
  }
  set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
    this.Ah = Ah | 0;
    this.Al = Al | 0;
    this.Bh = Bh | 0;
    this.Bl = Bl | 0;
    this.Ch = Ch | 0;
    this.Cl = Cl | 0;
    this.Dh = Dh | 0;
    this.Dl = Dl | 0;
    this.Eh = Eh | 0;
    this.El = El | 0;
    this.Fh = Fh | 0;
    this.Fl = Fl | 0;
    this.Gh = Gh | 0;
    this.Gl = Gl | 0;
    this.Hh = Hh | 0;
    this.Hl = Hl | 0;
  }
  process(view, offset) {
    for (let i = 0; i < 16; i++, offset += 4) {
      SHA512_W_H[i] = view.getUint32(offset);
      SHA512_W_L[i] = view.getUint32(offset += 4);
    }
    for (let i = 16; i < 80; i++) {
      const W15h = SHA512_W_H[i - 15] | 0;
      const W15l = SHA512_W_L[i - 15] | 0;
      const s0h = u64.rotrSH(W15h, W15l, 1) ^ u64.rotrSH(W15h, W15l, 8) ^ u64.shrSH(W15h, W15l, 7);
      const s0l = u64.rotrSL(W15h, W15l, 1) ^ u64.rotrSL(W15h, W15l, 8) ^ u64.shrSL(W15h, W15l, 7);
      const W2h = SHA512_W_H[i - 2] | 0;
      const W2l = SHA512_W_L[i - 2] | 0;
      const s1h = u64.rotrSH(W2h, W2l, 19) ^ u64.rotrBH(W2h, W2l, 61) ^ u64.shrSH(W2h, W2l, 6);
      const s1l = u64.rotrSL(W2h, W2l, 19) ^ u64.rotrBL(W2h, W2l, 61) ^ u64.shrSL(W2h, W2l, 6);
      const SUMl = u64.add4L(s0l, s1l, SHA512_W_L[i - 7], SHA512_W_L[i - 16]);
      const SUMh = u64.add4H(SUMl, s0h, s1h, SHA512_W_H[i - 7], SHA512_W_H[i - 16]);
      SHA512_W_H[i] = SUMh | 0;
      SHA512_W_L[i] = SUMl | 0;
    }
    let { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
    for (let i = 0; i < 80; i++) {
      const sigma1h = u64.rotrSH(Eh, El, 14) ^ u64.rotrSH(Eh, El, 18) ^ u64.rotrBH(Eh, El, 41);
      const sigma1l = u64.rotrSL(Eh, El, 14) ^ u64.rotrSL(Eh, El, 18) ^ u64.rotrBL(Eh, El, 41);
      const CHIh = Eh & Fh ^ ~Eh & Gh;
      const CHIl = El & Fl ^ ~El & Gl;
      const T1ll = u64.add5L(Hl, sigma1l, CHIl, SHA512_Kl[i], SHA512_W_L[i]);
      const T1h = u64.add5H(T1ll, Hh, sigma1h, CHIh, SHA512_Kh[i], SHA512_W_H[i]);
      const T1l = T1ll | 0;
      const sigma0h = u64.rotrSH(Ah, Al, 28) ^ u64.rotrBH(Ah, Al, 34) ^ u64.rotrBH(Ah, Al, 39);
      const sigma0l = u64.rotrSL(Ah, Al, 28) ^ u64.rotrBL(Ah, Al, 34) ^ u64.rotrBL(Ah, Al, 39);
      const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
      const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
      Hh = Gh | 0;
      Hl = Gl | 0;
      Gh = Fh | 0;
      Gl = Fl | 0;
      Fh = Eh | 0;
      Fl = El | 0;
      ({ h: Eh, l: El } = u64.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
      Dh = Ch | 0;
      Dl = Cl | 0;
      Ch = Bh | 0;
      Cl = Bl | 0;
      Bh = Ah | 0;
      Bl = Al | 0;
      const All = u64.add3L(T1l, sigma0l, MAJl);
      Ah = u64.add3H(All, T1h, sigma0h, MAJh);
      Al = All | 0;
    }
    ({ h: Ah, l: Al } = u64.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
    ({ h: Bh, l: Bl } = u64.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
    ({ h: Ch, l: Cl } = u64.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
    ({ h: Dh, l: Dl } = u64.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
    ({ h: Eh, l: El } = u64.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
    ({ h: Fh, l: Fl } = u64.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
    ({ h: Gh, l: Gl } = u64.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
    ({ h: Hh, l: Hl } = u64.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
    this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
  }
  roundClean() {
    SHA512_W_H.fill(0);
    SHA512_W_L.fill(0);
  }
  destroy() {
    this.buffer.fill(0);
    this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
class SHA512_256 extends SHA512 {
  constructor() {
    super();
    this.Ah = 573645204 | 0;
    this.Al = 4230739756 | 0;
    this.Bh = 2673172387 | 0;
    this.Bl = 3360449730 | 0;
    this.Ch = 596883563 | 0;
    this.Cl = 1867755857 | 0;
    this.Dh = 2520282905 | 0;
    this.Dl = 1497426621 | 0;
    this.Eh = 2519219938 | 0;
    this.El = 2827943907 | 0;
    this.Fh = 3193839141 | 0;
    this.Fl = 1401305490 | 0;
    this.Gh = 721525244 | 0;
    this.Gl = 746961066 | 0;
    this.Hh = 246885852 | 0;
    this.Hl = 2177182882 | 0;
    this.outputLen = 32;
  }
}
class SHA384 extends SHA512 {
  constructor() {
    super();
    this.Ah = 3418070365 | 0;
    this.Al = 3238371032 | 0;
    this.Bh = 1654270250 | 0;
    this.Bl = 914150663 | 0;
    this.Ch = 2438529370 | 0;
    this.Cl = 812702999 | 0;
    this.Dh = 355462360 | 0;
    this.Dl = 4144912697 | 0;
    this.Eh = 1731405415 | 0;
    this.El = 4290775857 | 0;
    this.Fh = 2394180231 | 0;
    this.Fl = 1750603025 | 0;
    this.Gh = 3675008525 | 0;
    this.Gl = 1694076839 | 0;
    this.Hh = 1203062813 | 0;
    this.Hl = 3204075428 | 0;
    this.outputLen = 48;
  }
}
const sha512 = wrapConstructor(() => new SHA512());
const sha512_256 = wrapConstructor(() => new SHA512_256());
const sha384 = wrapConstructor(() => new SHA384());
const sha512$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SHA512,
  sha512,
  sha512_256,
  sha384
}, Symbol.toStringTag, { value: "Module" }));
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(sha512$1);
const require$$4 = /* @__PURE__ */ getAugmentedNamespace(utils$c);
var lib = {};
(function(exports) {
  /*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.bytes = exports.stringToBytes = exports.str = exports.bytesToString = exports.hex = exports.utf8 = exports.bech32m = exports.bech32 = exports.base58check = exports.base58xmr = exports.base58xrp = exports.base58flickr = exports.base58 = exports.base64url = exports.base64 = exports.base32crockford = exports.base32hex = exports.base32 = exports.base16 = exports.utils = exports.assertNumber = void 0;
  function assertNumber(n) {
    if (!Number.isSafeInteger(n))
      throw new Error(`Wrong integer: ${n}`);
  }
  exports.assertNumber = assertNumber;
  function chain(...args) {
    const wrap = (a, b) => (c) => a(b(c));
    const encode2 = Array.from(args).reverse().reduce((acc, i) => acc ? wrap(acc, i.encode) : i.encode, void 0);
    const decode = args.reduce((acc, i) => acc ? wrap(acc, i.decode) : i.decode, void 0);
    return { encode: encode2, decode };
  }
  function alphabet(alphabet2) {
    return {
      encode: (digits) => {
        if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number")
          throw new Error("alphabet.encode input should be an array of numbers");
        return digits.map((i) => {
          assertNumber(i);
          if (i < 0 || i >= alphabet2.length)
            throw new Error(`Digit index outside alphabet: ${i} (alphabet: ${alphabet2.length})`);
          return alphabet2[i];
        });
      },
      decode: (input) => {
        if (!Array.isArray(input) || input.length && typeof input[0] !== "string")
          throw new Error("alphabet.decode input should be array of strings");
        return input.map((letter) => {
          if (typeof letter !== "string")
            throw new Error(`alphabet.decode: not string element=${letter}`);
          const index = alphabet2.indexOf(letter);
          if (index === -1)
            throw new Error(`Unknown letter: "${letter}". Allowed: ${alphabet2}`);
          return index;
        });
      }
    };
  }
  function join(separator = "") {
    if (typeof separator !== "string")
      throw new Error("join separator should be string");
    return {
      encode: (from) => {
        if (!Array.isArray(from) || from.length && typeof from[0] !== "string")
          throw new Error("join.encode input should be array of strings");
        for (let i of from)
          if (typeof i !== "string")
            throw new Error(`join.encode: non-string input=${i}`);
        return from.join(separator);
      },
      decode: (to) => {
        if (typeof to !== "string")
          throw new Error("join.decode input should be string");
        return to.split(separator);
      }
    };
  }
  function padding(bits, chr = "=") {
    assertNumber(bits);
    if (typeof chr !== "string")
      throw new Error("padding chr should be string");
    return {
      encode(data2) {
        if (!Array.isArray(data2) || data2.length && typeof data2[0] !== "string")
          throw new Error("padding.encode input should be array of strings");
        for (let i of data2)
          if (typeof i !== "string")
            throw new Error(`padding.encode: non-string input=${i}`);
        while (data2.length * bits % 8)
          data2.push(chr);
        return data2;
      },
      decode(input) {
        if (!Array.isArray(input) || input.length && typeof input[0] !== "string")
          throw new Error("padding.encode input should be array of strings");
        for (let i of input)
          if (typeof i !== "string")
            throw new Error(`padding.decode: non-string input=${i}`);
        let end = input.length;
        if (end * bits % 8)
          throw new Error("Invalid padding: string should have whole number of bytes");
        for (; end > 0 && input[end - 1] === chr; end--) {
          if (!((end - 1) * bits % 8))
            throw new Error("Invalid padding: string has too much padding");
        }
        return input.slice(0, end);
      }
    };
  }
  function normalize2(fn) {
    if (typeof fn !== "function")
      throw new Error("normalize fn should be function");
    return { encode: (from) => from, decode: (to) => fn(to) };
  }
  function convertRadix(data2, from, to) {
    if (from < 2)
      throw new Error(`convertRadix: wrong from=${from}, base cannot be less than 2`);
    if (to < 2)
      throw new Error(`convertRadix: wrong to=${to}, base cannot be less than 2`);
    if (!Array.isArray(data2))
      throw new Error("convertRadix: data should be array");
    if (!data2.length)
      return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data2);
    digits.forEach((d) => {
      assertNumber(d);
      if (d < 0 || d >= from)
        throw new Error(`Wrong integer: ${d}`);
    });
    while (true) {
      let carry = 0;
      let done = true;
      for (let i = pos; i < digits.length; i++) {
        const digit = digits[i];
        const digitBase = from * carry + digit;
        if (!Number.isSafeInteger(digitBase) || from * carry / from !== carry || digitBase - digit !== from * carry) {
          throw new Error("convertRadix: carry overflow");
        }
        carry = digitBase % to;
        digits[i] = Math.floor(digitBase / to);
        if (!Number.isSafeInteger(digits[i]) || digits[i] * to + carry !== digitBase)
          throw new Error("convertRadix: carry overflow");
        if (!done)
          continue;
        else if (!digits[i])
          pos = i;
        else
          done = false;
      }
      res.push(carry);
      if (done)
        break;
    }
    for (let i = 0; i < data2.length - 1 && data2[i] === 0; i++)
      res.push(0);
    return res.reverse();
  }
  const gcd = (a, b) => !b ? a : gcd(b, a % b);
  const radix2carry = (from, to) => from + (to - gcd(from, to));
  function convertRadix2(data2, from, to, padding2) {
    if (!Array.isArray(data2))
      throw new Error("convertRadix2: data should be array");
    if (from <= 0 || from > 32)
      throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32)
      throw new Error(`convertRadix2: wrong to=${to}`);
    if (radix2carry(from, to) > 32) {
      throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${radix2carry(from, to)}`);
    }
    let carry = 0;
    let pos = 0;
    const mask = 2 ** to - 1;
    const res = [];
    for (const n of data2) {
      assertNumber(n);
      if (n >= 2 ** from)
        throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
      carry = carry << from | n;
      if (pos + from > 32)
        throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
      pos += from;
      for (; pos >= to; pos -= to)
        res.push((carry >> pos - to & mask) >>> 0);
      carry &= 2 ** pos - 1;
    }
    carry = carry << to - pos & mask;
    if (!padding2 && pos >= from)
      throw new Error("Excess padding");
    if (!padding2 && carry)
      throw new Error(`Non-zero padding: ${carry}`);
    if (padding2 && pos > 0)
      res.push(carry >>> 0);
    return res;
  }
  function radix(num) {
    assertNumber(num);
    return {
      encode: (bytes2) => {
        if (!(bytes2 instanceof Uint8Array))
          throw new Error("radix.encode input should be Uint8Array");
        return convertRadix(Array.from(bytes2), 2 ** 8, num);
      },
      decode: (digits) => {
        if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number")
          throw new Error("radix.decode input should be array of strings");
        return Uint8Array.from(convertRadix(digits, num, 2 ** 8));
      }
    };
  }
  function radix2(bits, revPadding = false) {
    assertNumber(bits);
    if (bits <= 0 || bits > 32)
      throw new Error("radix2: bits should be in (0..32]");
    if (radix2carry(8, bits) > 32 || radix2carry(bits, 8) > 32)
      throw new Error("radix2: carry overflow");
    return {
      encode: (bytes2) => {
        if (!(bytes2 instanceof Uint8Array))
          throw new Error("radix2.encode input should be Uint8Array");
        return convertRadix2(Array.from(bytes2), 8, bits, !revPadding);
      },
      decode: (digits) => {
        if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number")
          throw new Error("radix2.decode input should be array of strings");
        return Uint8Array.from(convertRadix2(digits, bits, 8, revPadding));
      }
    };
  }
  function unsafeWrapper(fn) {
    if (typeof fn !== "function")
      throw new Error("unsafeWrapper fn should be function");
    return function(...args) {
      try {
        return fn.apply(null, args);
      } catch (e) {
      }
    };
  }
  function checksum(len, fn) {
    assertNumber(len);
    if (typeof fn !== "function")
      throw new Error("checksum fn should be function");
    return {
      encode(data2) {
        if (!(data2 instanceof Uint8Array))
          throw new Error("checksum.encode: input should be Uint8Array");
        const checksum2 = fn(data2).slice(0, len);
        const res = new Uint8Array(data2.length + len);
        res.set(data2);
        res.set(checksum2, data2.length);
        return res;
      },
      decode(data2) {
        if (!(data2 instanceof Uint8Array))
          throw new Error("checksum.decode: input should be Uint8Array");
        const payload = data2.slice(0, -len);
        const newChecksum = fn(payload).slice(0, len);
        const oldChecksum = data2.slice(-len);
        for (let i = 0; i < len; i++)
          if (newChecksum[i] !== oldChecksum[i])
            throw new Error("Invalid checksum");
        return payload;
      }
    };
  }
  exports.utils = { alphabet, chain, checksum, radix, radix2, join, padding };
  exports.base16 = chain(radix2(4), alphabet("0123456789ABCDEF"), join(""));
  exports.base32 = chain(radix2(5), alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), padding(5), join(""));
  exports.base32hex = chain(radix2(5), alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), padding(5), join(""));
  exports.base32crockford = chain(radix2(5), alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), join(""), normalize2((s) => s.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
  exports.base64 = chain(radix2(6), alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), padding(6), join(""));
  exports.base64url = chain(radix2(6), alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), padding(6), join(""));
  const genBase58 = (abc) => chain(radix(58), alphabet(abc), join(""));
  exports.base58 = genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
  exports.base58flickr = genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
  exports.base58xrp = genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
  const XMR_BLOCK_LEN = [0, 2, 3, 5, 6, 7, 9, 10, 11];
  exports.base58xmr = {
    encode(data2) {
      let res = "";
      for (let i = 0; i < data2.length; i += 8) {
        const block = data2.subarray(i, i + 8);
        res += exports.base58.encode(block).padStart(XMR_BLOCK_LEN[block.length], "1");
      }
      return res;
    },
    decode(str) {
      let res = [];
      for (let i = 0; i < str.length; i += 11) {
        const slice = str.slice(i, i + 11);
        const blockLen = XMR_BLOCK_LEN.indexOf(slice.length);
        const block = exports.base58.decode(slice);
        for (let j = 0; j < block.length - blockLen; j++) {
          if (block[j] !== 0)
            throw new Error("base58xmr: wrong padding");
        }
        res = res.concat(Array.from(block.slice(block.length - blockLen)));
      }
      return Uint8Array.from(res);
    }
  };
  const base58check = (sha2562) => chain(checksum(4, (data2) => sha2562(sha2562(data2))), exports.base58);
  exports.base58check = base58check;
  const BECH_ALPHABET = chain(alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), join(""));
  const POLYMOD_GENERATORS = [996825010, 642813549, 513874426, 1027748829, 705979059];
  function bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 33554431) << 5;
    for (let i = 0; i < POLYMOD_GENERATORS.length; i++) {
      if ((b >> i & 1) === 1)
        chk ^= POLYMOD_GENERATORS[i];
    }
    return chk;
  }
  function bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for (let i = 0; i < len; i++) {
      const c = prefix.charCodeAt(i);
      if (c < 33 || c > 126)
        throw new Error(`Invalid prefix (${prefix})`);
      chk = bech32Polymod(chk) ^ c >> 5;
    }
    chk = bech32Polymod(chk);
    for (let i = 0; i < len; i++)
      chk = bech32Polymod(chk) ^ prefix.charCodeAt(i) & 31;
    for (let v of words)
      chk = bech32Polymod(chk) ^ v;
    for (let i = 0; i < 6; i++)
      chk = bech32Polymod(chk);
    chk ^= encodingConst;
    return BECH_ALPHABET.encode(convertRadix2([chk % 2 ** 30], 30, 5, false));
  }
  function genBech32(encoding) {
    const ENCODING_CONST = encoding === "bech32" ? 1 : 734539939;
    const _words = radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = unsafeWrapper(fromWords);
    function encode2(prefix, words, limit = 90) {
      if (typeof prefix !== "string")
        throw new Error(`bech32.encode prefix should be string, not ${typeof prefix}`);
      if (!Array.isArray(words) || words.length && typeof words[0] !== "number")
        throw new Error(`bech32.encode words should be array of numbers, not ${typeof words}`);
      const actualLength = prefix.length + 7 + words.length;
      if (limit !== false && actualLength > limit)
        throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
      prefix = prefix.toLowerCase();
      return `${prefix}1${BECH_ALPHABET.encode(words)}${bechChecksum(prefix, words, ENCODING_CONST)}`;
    }
    function decode(str, limit = 90) {
      if (typeof str !== "string")
        throw new Error(`bech32.decode input should be string, not ${typeof str}`);
      if (str.length < 8 || limit !== false && str.length > limit)
        throw new TypeError(`Wrong string length: ${str.length} (${str}). Expected (8..${limit})`);
      const lowered = str.toLowerCase();
      if (str !== lowered && str !== str.toUpperCase())
        throw new Error(`String must be lowercase or uppercase`);
      str = lowered;
      const sepIndex = str.lastIndexOf("1");
      if (sepIndex === 0 || sepIndex === -1)
        throw new Error(`Letter "1" must be present between prefix and data only`);
      const prefix = str.slice(0, sepIndex);
      const _words2 = str.slice(sepIndex + 1);
      if (_words2.length < 6)
        throw new Error("Data must be at least 6 characters long");
      const words = BECH_ALPHABET.decode(_words2).slice(0, -6);
      const sum = bechChecksum(prefix, words, ENCODING_CONST);
      if (!_words2.endsWith(sum))
        throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
      return { prefix, words };
    }
    const decodeUnsafe = unsafeWrapper(decode);
    function decodeToBytes(str) {
      const { prefix, words } = decode(str, false);
      return { prefix, words, bytes: fromWords(words) };
    }
    return { encode: encode2, decode, decodeToBytes, decodeUnsafe, fromWords, fromWordsUnsafe, toWords };
  }
  exports.bech32 = genBech32("bech32");
  exports.bech32m = genBech32("bech32m");
  exports.utf8 = {
    encode: (data2) => new TextDecoder().decode(data2),
    decode: (str) => new TextEncoder().encode(str)
  };
  exports.hex = chain(radix2(4), alphabet("0123456789abcdef"), join(""), normalize2((s) => {
    if (typeof s !== "string" || s.length % 2)
      throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
  }));
  const CODERS = {
    utf8: exports.utf8,
    hex: exports.hex,
    base16: exports.base16,
    base32: exports.base32,
    base64: exports.base64,
    base64url: exports.base64url,
    base58: exports.base58,
    base58xmr: exports.base58xmr
  };
  const coderTypeError = `Invalid encoding type. Available types: ${Object.keys(CODERS).join(", ")}`;
  const bytesToString = (type, bytes2) => {
    if (typeof type !== "string" || !CODERS.hasOwnProperty(type))
      throw new TypeError(coderTypeError);
    if (!(bytes2 instanceof Uint8Array))
      throw new TypeError("bytesToString() expects Uint8Array");
    return CODERS[type].encode(bytes2);
  };
  exports.bytesToString = bytesToString;
  exports.str = exports.bytesToString;
  const stringToBytes = (type, str) => {
    if (!CODERS.hasOwnProperty(type))
      throw new TypeError(coderTypeError);
    if (typeof str !== "string")
      throw new TypeError("stringToBytes() expects string");
    return CODERS[type].decode(str);
  };
  exports.stringToBytes = stringToBytes;
  exports.bytes = exports.stringToBytes;
})(lib);
Object.defineProperty(bip39, "__esModule", { value: true });
var mnemonicToSeedSync_1 = bip39.mnemonicToSeedSync = bip39.mnemonicToSeed = bip39.validateMnemonic = bip39.entropyToMnemonic = bip39.mnemonicToEntropy = bip39.generateMnemonic = void 0;
/*! scure-bip39 - MIT License (c) 2022 Patricio Palladino, Paul Miller (paulmillr.com) */
const _assert_1 = _assert;
const pbkdf2_1 = pbkdf2$1;
const sha256_1 = sha256;
const sha512_1 = require$$3;
const utils_1 = require$$4;
const base_1 = lib;
const isJapanese = (wordlist) => wordlist[0] === "\u3042\u3044\u3053\u304F\u3057\u3093";
function nfkd(str) {
  if (typeof str !== "string")
    throw new TypeError(`Invalid mnemonic type: ${typeof str}`);
  return str.normalize("NFKD");
}
function normalize(str) {
  const norm = nfkd(str);
  const words = norm.split(" ");
  if (![12, 15, 18, 21, 24].includes(words.length))
    throw new Error("Invalid mnemonic");
  return { nfkd: norm, words };
}
function assertEntropy(entropy) {
  _assert_1.default.bytes(entropy, 16, 20, 24, 28, 32);
}
function generateMnemonic(wordlist, strength = 128) {
  _assert_1.default.number(strength);
  if (strength % 32 !== 0 || strength > 256)
    throw new TypeError("Invalid entropy");
  return entropyToMnemonic((0, utils_1.randomBytes)(strength / 8), wordlist);
}
bip39.generateMnemonic = generateMnemonic;
const calcChecksum = (entropy) => {
  const bitsLeft = 8 - entropy.length / 4;
  return new Uint8Array([(0, sha256_1.sha256)(entropy)[0] >> bitsLeft << bitsLeft]);
};
function getCoder(wordlist) {
  if (!Array.isArray(wordlist) || wordlist.length !== 2 ** 11 || typeof wordlist[0] !== "string")
    throw new Error("Worlist: expected array of 2048 strings");
  wordlist.forEach((i) => {
    if (typeof i !== "string")
      throw new Error(`Wordlist: non-string element: ${i}`);
  });
  return base_1.utils.chain(base_1.utils.checksum(1, calcChecksum), base_1.utils.radix2(11, true), base_1.utils.alphabet(wordlist));
}
function mnemonicToEntropy(mnemonic, wordlist) {
  const { words } = normalize(mnemonic);
  const entropy = getCoder(wordlist).decode(words);
  assertEntropy(entropy);
  return entropy;
}
bip39.mnemonicToEntropy = mnemonicToEntropy;
function entropyToMnemonic(entropy, wordlist) {
  assertEntropy(entropy);
  const words = getCoder(wordlist).encode(entropy);
  return words.join(isJapanese(wordlist) ? "\u3000" : " ");
}
bip39.entropyToMnemonic = entropyToMnemonic;
function validateMnemonic(mnemonic, wordlist) {
  try {
    mnemonicToEntropy(mnemonic, wordlist);
  } catch (e) {
    return false;
  }
  return true;
}
bip39.validateMnemonic = validateMnemonic;
const salt = (passphrase) => nfkd(`mnemonic${passphrase}`);
function mnemonicToSeed(mnemonic, passphrase = "") {
  return (0, pbkdf2_1.pbkdf2Async)(sha512_1.sha512, normalize(mnemonic).nfkd, salt(passphrase), { c: 2048, dkLen: 64 });
}
bip39.mnemonicToSeed = mnemonicToSeed;
function mnemonicToSeedSync(mnemonic, passphrase = "") {
  return (0, pbkdf2_1.pbkdf2)(sha512_1.sha512, normalize(mnemonic).nfkd, salt(passphrase), { c: 2048, dkLen: 64 });
}
mnemonicToSeedSync_1 = bip39.mnemonicToSeedSync = mnemonicToSeedSync;
class HMAC extends Hash {
  constructor(hash2, _key) {
    super();
    this.finished = false;
    this.destroyed = false;
    assert.hash(hash2);
    const key = toBytes(_key);
    this.iHash = hash2.create();
    if (typeof this.iHash.update !== "function")
      throw new TypeError("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen;
    this.outputLen = this.iHash.outputLen;
    const blockLen = this.blockLen;
    const pad = new Uint8Array(blockLen);
    pad.set(key.length > blockLen ? hash2.create().update(key).digest() : key);
    for (let i = 0; i < pad.length; i++)
      pad[i] ^= 54;
    this.iHash.update(pad);
    this.oHash = hash2.create();
    for (let i = 0; i < pad.length; i++)
      pad[i] ^= 54 ^ 92;
    this.oHash.update(pad);
    pad.fill(0);
  }
  update(buf) {
    assert.exists(this);
    this.iHash.update(buf);
    return this;
  }
  digestInto(out) {
    assert.exists(this);
    assert.bytes(out, this.outputLen);
    this.finished = true;
    this.iHash.digestInto(out);
    this.oHash.update(out);
    this.oHash.digestInto(out);
    this.destroy();
  }
  digest() {
    const out = new Uint8Array(this.oHash.outputLen);
    this.digestInto(out);
    return out;
  }
  _cloneInto(to) {
    to || (to = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
    to = to;
    to.finished = finished;
    to.destroyed = destroyed;
    to.blockLen = blockLen;
    to.outputLen = outputLen;
    to.oHash = oHash._cloneInto(to.oHash);
    to.iHash = iHash._cloneInto(to.iHash);
    return to;
  }
  destroy() {
    this.destroyed = true;
    this.oHash.destroy();
    this.iHash.destroy();
  }
}
const hmac = (hash2, key, message) => new HMAC(hash2, key).update(message).digest();
hmac.create = (hash2, key) => new HMAC(hash2, key);
const [SHA3_PI, SHA3_ROTL, _SHA3_IOTA] = [[], [], []];
const _0n = BigInt(0);
const _1n = BigInt(1);
const _2n = BigInt(2);
const _7n = BigInt(7);
const _256n = BigInt(256);
const _0x71n = BigInt(113);
for (let round = 0, R = _1n, x = 1, y = 0; round < 24; round++) {
  [x, y] = [y, (2 * x + 3 * y) % 5];
  SHA3_PI.push(2 * (5 * y + x));
  SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
  let t = _0n;
  for (let j = 0; j < 7; j++) {
    R = (R << _1n ^ (R >> _7n) * _0x71n) % _256n;
    if (R & _2n)
      t ^= _1n << (_1n << BigInt(j)) - _1n;
  }
  _SHA3_IOTA.push(t);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = u64.split(_SHA3_IOTA, true);
const rotlH = (h, l, s) => s > 32 ? u64.rotlBH(h, l, s) : u64.rotlSH(h, l, s);
const rotlL = (h, l, s) => s > 32 ? u64.rotlBL(h, l, s) : u64.rotlSL(h, l, s);
function keccakP(s, rounds = 24) {
  const B = new Uint32Array(5 * 2);
  for (let round = 24 - rounds; round < 24; round++) {
    for (let x = 0; x < 10; x++)
      B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
    for (let x = 0; x < 10; x += 2) {
      const idx1 = (x + 8) % 10;
      const idx0 = (x + 2) % 10;
      const B0 = B[idx0];
      const B1 = B[idx0 + 1];
      const Th = rotlH(B0, B1, 1) ^ B[idx1];
      const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
      for (let y = 0; y < 50; y += 10) {
        s[x + y] ^= Th;
        s[x + y + 1] ^= Tl;
      }
    }
    let curH = s[2];
    let curL = s[3];
    for (let t = 0; t < 24; t++) {
      const shift = SHA3_ROTL[t];
      const Th = rotlH(curH, curL, shift);
      const Tl = rotlL(curH, curL, shift);
      const PI = SHA3_PI[t];
      curH = s[PI];
      curL = s[PI + 1];
      s[PI] = Th;
      s[PI + 1] = Tl;
    }
    for (let y = 0; y < 50; y += 10) {
      for (let x = 0; x < 10; x++)
        B[x] = s[y + x];
      for (let x = 0; x < 10; x++)
        s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
    }
    s[0] ^= SHA3_IOTA_H[round];
    s[1] ^= SHA3_IOTA_L[round];
  }
  B.fill(0);
}
class Keccak extends Hash {
  constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24) {
    super();
    this.blockLen = blockLen;
    this.suffix = suffix;
    this.outputLen = outputLen;
    this.enableXOF = enableXOF;
    this.rounds = rounds;
    this.pos = 0;
    this.posOut = 0;
    this.finished = false;
    this.destroyed = false;
    assert.number(outputLen);
    if (0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200);
    this.state32 = u32(this.state);
  }
  keccak() {
    keccakP(this.state32, this.rounds);
    this.posOut = 0;
    this.pos = 0;
  }
  update(data2) {
    assert.exists(this);
    const { blockLen, state } = this;
    data2 = toBytes(data2);
    const len = data2.length;
    for (let pos = 0; pos < len; ) {
      const take = Math.min(blockLen - this.pos, len - pos);
      for (let i = 0; i < take; i++)
        state[this.pos++] ^= data2[pos++];
      if (this.pos === blockLen)
        this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = true;
    const { state, suffix, pos, blockLen } = this;
    state[pos] ^= suffix;
    if ((suffix & 128) !== 0 && pos === blockLen - 1)
      this.keccak();
    state[blockLen - 1] ^= 128;
    this.keccak();
  }
  writeInto(out) {
    assert.exists(this, false);
    assert.bytes(out);
    this.finish();
    const bufferOut = this.state;
    const { blockLen } = this;
    for (let pos = 0, len = out.length; pos < len; ) {
      if (this.posOut >= blockLen)
        this.keccak();
      const take = Math.min(blockLen - this.posOut, len - pos);
      out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
      this.posOut += take;
      pos += take;
    }
    return out;
  }
  xofInto(out) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(out);
  }
  xof(bytes2) {
    assert.number(bytes2);
    return this.xofInto(new Uint8Array(bytes2));
  }
  digestInto(out) {
    assert.output(out, this);
    if (this.finished)
      throw new Error("digest() was already called");
    this.writeInto(out);
    this.destroy();
    return out;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = true;
    this.state.fill(0);
  }
  _cloneInto(to) {
    const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
    to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
    to.state32.set(this.state32);
    to.pos = this.pos;
    to.posOut = this.posOut;
    to.finished = this.finished;
    to.rounds = rounds;
    to.suffix = suffix;
    to.outputLen = outputLen;
    to.enableXOF = enableXOF;
    to.destroyed = this.destroyed;
    return to;
  }
}
const gen = (suffix, blockLen, outputLen) => wrapConstructor(() => new Keccak(blockLen, suffix, outputLen));
gen(6, 144, 224 / 8);
const sha3_256 = gen(6, 136, 256 / 8);
gen(6, 104, 384 / 8);
gen(6, 72, 512 / 8);
gen(1, 144, 224 / 8);
gen(1, 136, 256 / 8);
gen(1, 104, 384 / 8);
gen(1, 72, 512 / 8);
const genShake = (suffix, blockLen, outputLen) => wrapConstructorWithOpts((opts = {}) => new Keccak(blockLen, suffix, opts.dkLen === void 0 ? outputLen : opts.dkLen, true));
genShake(31, 168, 128 / 8);
genShake(31, 136, 256 / 8);
var axios$3 = { exports: {} };
var axios$2 = { exports: {} };
var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};
var bind$1 = bind$2;
var toString = Object.prototype.toString;
var kindOf = function(cache) {
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}
function isArray(val) {
  return Array.isArray(val);
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
var isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
function isString$1(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (kindOf(val) !== "object") {
    return false;
  }
  var prototype2 = Object.getPrototypeOf(val);
  return prototype2 === null || prototype2 === Object.prototype;
}
var isDate = kindOfTest("Date");
var isFile = kindOfTest("File");
var isBlob$1 = kindOfTest("Blob");
var isFileList = kindOfTest("FileList");
function isFunction(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isFormData$1(thing) {
  var pattern = "[object FormData]";
  return thing && (typeof FormData === "function" && thing instanceof FormData || toString.call(thing) === pattern || isFunction(thing.toString) && thing.toString() === pattern);
}
var isURLSearchParams = kindOfTest("URLSearchParams");
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
function inherits(constructor, superConstructor, props, descriptors2) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}
function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};
  destObj = destObj || {};
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
}
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === void 0 || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}
function toArray(thing) {
  if (!thing)
    return null;
  var i = thing.length;
  if (isUndefined(i))
    return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}
var isTypedArray = function(TypedArray) {
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
var utils$b = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData: isFormData$1,
  isArrayBufferView,
  isString: isString$1,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob: isBlob$1,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  isTypedArray,
  isFileList
};
var utils$a = utils$b;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$1 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$a.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$a.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$a.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$a.forEach(val, function parseValue(v) {
        if (utils$a.isDate(v)) {
          v = v.toISOString();
        } else if (utils$a.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + "=" + encode(v));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$9 = utils$b;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn) {
  utils$9.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$8 = utils$b;
var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$8.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
var utils$7 = utils$b;
function AxiosError$2(message, code, config, request3, response) {
  Error.call(this);
  this.message = message;
  this.name = "AxiosError";
  code && (this.code = code);
  config && (this.config = config);
  request3 && (this.request = request3);
  response && (this.response = response);
}
utils$7.inherits(AxiosError$2, Error, {
  toJSON: function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var prototype = AxiosError$2.prototype;
var descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
].forEach(function(code) {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError$2, descriptors);
Object.defineProperty(prototype, "isAxiosError", { value: true });
AxiosError$2.from = function(error, code, config, request3, response, customProps) {
  var axiosError = Object.create(prototype);
  utils$7.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });
  AxiosError$2.call(axiosError, error.message, code, config, request3, response);
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
var AxiosError_1 = AxiosError$2;
var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
var utils$6 = utils$b;
function toFormData$1(obj, formData) {
  formData = formData || new FormData();
  var stack = [];
  function convertValue(value) {
    if (value === null)
      return "";
    if (utils$6.isDate(value)) {
      return value.toISOString();
    }
    if (utils$6.isArrayBuffer(value) || utils$6.isTypedArray(value)) {
      return typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function build(data2, parentKey) {
    if (utils$6.isPlainObject(data2) || utils$6.isArray(data2)) {
      if (stack.indexOf(data2) !== -1) {
        throw Error("Circular reference detected in " + parentKey);
      }
      stack.push(data2);
      utils$6.forEach(data2, function each(value, key) {
        if (utils$6.isUndefined(value))
          return;
        var fullKey = parentKey ? parentKey + "." + key : key;
        var arr;
        if (value && !parentKey && typeof value === "object") {
          if (utils$6.endsWith(key, "{}")) {
            value = JSON.stringify(value);
          } else if (utils$6.endsWith(key, "[]") && (arr = utils$6.toArray(value))) {
            arr.forEach(function(el) {
              !utils$6.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }
        build(value, fullKey);
      });
      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data2));
    }
  }
  build(obj);
  return formData;
}
var toFormData_1 = toFormData$1;
var settle;
var hasRequiredSettle;
function requireSettle() {
  if (hasRequiredSettle)
    return settle;
  hasRequiredSettle = 1;
  var AxiosError2 = AxiosError_1;
  settle = function settle2(resolve2, reject, response) {
    var validateStatus2 = response.config.validateStatus;
    if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
      resolve2(response);
    } else {
      reject(new AxiosError2(
        "Request failed with status code " + response.status,
        [AxiosError2.ERR_BAD_REQUEST, AxiosError2.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
        response.config,
        response.request,
        response
      ));
    }
  };
  return settle;
}
var cookies;
var hasRequiredCookies;
function requireCookies() {
  if (hasRequiredCookies)
    return cookies;
  hasRequiredCookies = 1;
  var utils2 = utils$b;
  cookies = utils2.isStandardBrowserEnv() ? function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + "=" + encodeURIComponent(value));
        if (utils2.isNumber(expires)) {
          cookie.push("expires=" + new Date(expires).toGMTString());
        }
        if (utils2.isString(path)) {
          cookie.push("path=" + path);
        }
        if (utils2.isString(domain)) {
          cookie.push("domain=" + domain);
        }
        if (secure === true) {
          cookie.push("secure");
        }
        document.cookie = cookie.join("; ");
      },
      read: function read(name) {
        var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
      },
      remove: function remove(name) {
        this.write(name, "", Date.now() - 864e5);
      }
    };
  }() : function nonStandardBrowserEnv() {
    return {
      write: function write() {
      },
      read: function read() {
        return null;
      },
      remove: function remove() {
      }
    };
  }();
  return cookies;
}
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL2 = isAbsoluteURL$1;
var combineURLs2 = combineURLs$1;
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL2(requestedURL)) {
    return combineURLs2(baseURL, requestedURL);
  }
  return requestedURL;
};
var parseHeaders;
var hasRequiredParseHeaders;
function requireParseHeaders() {
  if (hasRequiredParseHeaders)
    return parseHeaders;
  hasRequiredParseHeaders = 1;
  var utils2 = utils$b;
  var ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  parseHeaders = function parseHeaders2(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) {
      return parsed;
    }
    utils2.forEach(headers.split("\n"), function parser(line) {
      i = line.indexOf(":");
      key = utils2.trim(line.substr(0, i)).toLowerCase();
      val = utils2.trim(line.substr(i + 1));
      if (key) {
        if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
          return;
        }
        if (key === "set-cookie") {
          parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
        } else {
          parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
      }
    });
    return parsed;
  };
  return parseHeaders;
}
var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
  if (hasRequiredIsURLSameOrigin)
    return isURLSameOrigin;
  hasRequiredIsURLSameOrigin = 1;
  var utils2 = utils$b;
  isURLSameOrigin = utils2.isStandardBrowserEnv() ? function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    function resolveURL(url) {
      var href = url;
      if (msie) {
        urlParsingNode.setAttribute("href", href);
        href = urlParsingNode.href;
      }
      urlParsingNode.setAttribute("href", href);
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
      };
    }
    originURL = resolveURL(window.location.href);
    return function isURLSameOrigin2(requestURL) {
      var parsed = utils2.isString(requestURL) ? resolveURL(requestURL) : requestURL;
      return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
  }() : function nonStandardBrowserEnv() {
    return function isURLSameOrigin2() {
      return true;
    };
  }();
  return isURLSameOrigin;
}
var CanceledError_1;
var hasRequiredCanceledError;
function requireCanceledError() {
  if (hasRequiredCanceledError)
    return CanceledError_1;
  hasRequiredCanceledError = 1;
  var AxiosError2 = AxiosError_1;
  var utils2 = utils$b;
  function CanceledError2(message) {
    AxiosError2.call(this, message == null ? "canceled" : message, AxiosError2.ERR_CANCELED);
    this.name = "CanceledError";
  }
  utils2.inherits(CanceledError2, AxiosError2, {
    __CANCEL__: true
  });
  CanceledError_1 = CanceledError2;
  return CanceledError_1;
}
var parseProtocol;
var hasRequiredParseProtocol;
function requireParseProtocol() {
  if (hasRequiredParseProtocol)
    return parseProtocol;
  hasRequiredParseProtocol = 1;
  parseProtocol = function parseProtocol2(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
  };
  return parseProtocol;
}
var xhr;
var hasRequiredXhr;
function requireXhr() {
  if (hasRequiredXhr)
    return xhr;
  hasRequiredXhr = 1;
  var utils2 = utils$b;
  var settle2 = requireSettle();
  var cookies2 = requireCookies();
  var buildURL3 = buildURL$1;
  var buildFullPath3 = buildFullPath$1;
  var parseHeaders2 = requireParseHeaders();
  var isURLSameOrigin2 = requireIsURLSameOrigin();
  var transitionalDefaults2 = transitional;
  var AxiosError2 = AxiosError_1;
  var CanceledError2 = requireCanceledError();
  var parseProtocol2 = requireParseProtocol();
  xhr = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve2, reject) {
      var requestData = config.data;
      var requestHeaders = config.headers;
      var responseType = config.responseType;
      var onCanceled;
      function done() {
        if (config.cancelToken) {
          config.cancelToken.unsubscribe(onCanceled);
        }
        if (config.signal) {
          config.signal.removeEventListener("abort", onCanceled);
        }
      }
      if (utils2.isFormData(requestData) && utils2.isStandardBrowserEnv()) {
        delete requestHeaders["Content-Type"];
      }
      var request3 = new XMLHttpRequest();
      if (config.auth) {
        var username = config.auth.username || "";
        var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
        requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
      }
      var fullPath = buildFullPath3(config.baseURL, config.url);
      request3.open(config.method.toUpperCase(), buildURL3(fullPath, config.params, config.paramsSerializer), true);
      request3.timeout = config.timeout;
      function onloadend() {
        if (!request3) {
          return;
        }
        var responseHeaders = "getAllResponseHeaders" in request3 ? parseHeaders2(request3.getAllResponseHeaders()) : null;
        var responseData = !responseType || responseType === "text" || responseType === "json" ? request3.responseText : request3.response;
        var response = {
          data: responseData,
          status: request3.status,
          statusText: request3.statusText,
          headers: responseHeaders,
          config,
          request: request3
        };
        settle2(function _resolve(value) {
          resolve2(value);
          done();
        }, function _reject(err) {
          reject(err);
          done();
        }, response);
        request3 = null;
      }
      if ("onloadend" in request3) {
        request3.onloadend = onloadend;
      } else {
        request3.onreadystatechange = function handleLoad() {
          if (!request3 || request3.readyState !== 4) {
            return;
          }
          if (request3.status === 0 && !(request3.responseURL && request3.responseURL.indexOf("file:") === 0)) {
            return;
          }
          setTimeout(onloadend);
        };
      }
      request3.onabort = function handleAbort() {
        if (!request3) {
          return;
        }
        reject(new AxiosError2("Request aborted", AxiosError2.ECONNABORTED, config, request3));
        request3 = null;
      };
      request3.onerror = function handleError() {
        reject(new AxiosError2("Network Error", AxiosError2.ERR_NETWORK, config, request3, request3));
        request3 = null;
      };
      request3.ontimeout = function handleTimeout() {
        var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
        var transitional3 = config.transitional || transitionalDefaults2;
        if (config.timeoutErrorMessage) {
          timeoutErrorMessage = config.timeoutErrorMessage;
        }
        reject(new AxiosError2(
          timeoutErrorMessage,
          transitional3.clarifyTimeoutError ? AxiosError2.ETIMEDOUT : AxiosError2.ECONNABORTED,
          config,
          request3
        ));
        request3 = null;
      };
      if (utils2.isStandardBrowserEnv()) {
        var xsrfValue = (config.withCredentials || isURLSameOrigin2(fullPath)) && config.xsrfCookieName ? cookies2.read(config.xsrfCookieName) : void 0;
        if (xsrfValue) {
          requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
      }
      if ("setRequestHeader" in request3) {
        utils2.forEach(requestHeaders, function setRequestHeader(val, key) {
          if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
            delete requestHeaders[key];
          } else {
            request3.setRequestHeader(key, val);
          }
        });
      }
      if (!utils2.isUndefined(config.withCredentials)) {
        request3.withCredentials = !!config.withCredentials;
      }
      if (responseType && responseType !== "json") {
        request3.responseType = config.responseType;
      }
      if (typeof config.onDownloadProgress === "function") {
        request3.addEventListener("progress", config.onDownloadProgress);
      }
      if (typeof config.onUploadProgress === "function" && request3.upload) {
        request3.upload.addEventListener("progress", config.onUploadProgress);
      }
      if (config.cancelToken || config.signal) {
        onCanceled = function(cancel) {
          if (!request3) {
            return;
          }
          reject(!cancel || cancel && cancel.type ? new CanceledError2() : cancel);
          request3.abort();
          request3 = null;
        };
        config.cancelToken && config.cancelToken.subscribe(onCanceled);
        if (config.signal) {
          config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
      }
      if (!requestData) {
        requestData = null;
      }
      var protocol = parseProtocol2(fullPath);
      if (protocol && ["http", "https", "file"].indexOf(protocol) === -1) {
        reject(new AxiosError2("Unsupported protocol " + protocol + ":", AxiosError2.ERR_BAD_REQUEST, config));
        return;
      }
      request3.send(requestData);
    });
  };
  return xhr;
}
var _null;
var hasRequired_null;
function require_null() {
  if (hasRequired_null)
    return _null;
  hasRequired_null = 1;
  _null = null;
  return _null;
}
var utils$5 = utils$b;
var normalizeHeaderName2 = normalizeHeaderName$1;
var AxiosError$1 = AxiosError_1;
var transitionalDefaults = transitional;
var toFormData = toFormData_1;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = requireXhr();
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = requireXhr();
  }
  return adapter;
}
function stringifySafely(rawValue, parser, encoder2) {
  if (utils$5.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$5.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder2 || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: transitionalDefaults,
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");
    if (utils$5.isFormData(data2) || utils$5.isArrayBuffer(data2) || utils$5.isBuffer(data2) || utils$5.isStream(data2) || utils$5.isFile(data2) || utils$5.isBlob(data2)) {
      return data2;
    }
    if (utils$5.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$5.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    var isObjectPayload = utils$5.isObject(data2);
    var contentType = headers && headers["Content-Type"];
    var isFileList2;
    if ((isFileList2 = utils$5.isFileList(data2)) || isObjectPayload && contentType === "multipart/form-data") {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList2 ? { "files[]": data2 } : data2, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional3 = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional3 && transitional3.silentJSONParsing;
    var forcedJSONParsing = transitional3 && transitional3.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: require_null()
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$5.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});
utils$5.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$4 = utils$b;
var defaults$2 = defaults_1;
var transformData$1 = function transformData(data2, headers, fns) {
  var context = this || defaults$2;
  utils$4.forEach(fns, function transform(fn) {
    data2 = fn.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1;
var hasRequiredIsCancel;
function requireIsCancel() {
  if (hasRequiredIsCancel)
    return isCancel$1;
  hasRequiredIsCancel = 1;
  isCancel$1 = function isCancel2(value) {
    return !!(value && value.__CANCEL__);
  };
  return isCancel$1;
}
var utils$3 = utils$b;
var transformData2 = transformData$1;
var isCancel = requireIsCancel();
var defaults$1 = defaults_1;
var CanceledError = requireCanceledError();
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData2.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );
  config.headers = utils$3.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );
  utils$3.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );
  var adapter = config.adapter || defaults$1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData2.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData2.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }
    return Promise.reject(reason);
  });
};
var utils$2 = utils$b;
var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "beforeRedirect": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$2.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data;
var hasRequiredData;
function requireData() {
  if (hasRequiredData)
    return data;
  hasRequiredData = 1;
  data = {
    "version": "0.27.2"
  };
  return data;
}
var VERSION = requireData().version;
var AxiosError = AxiosError_1;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional2(validator2, version, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new AxiosError(
        formatMessage(opt, " has been removed" + (version ? " in " + version : "")),
        AxiosError.ERR_DEPRECATED
      );
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new AxiosError("option " + opt + " must be " + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$1 = utils$b;
var buildURL2 = buildURL$1;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var buildFullPath2 = buildFullPath$1;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request(configOrUrl, config) {
  if (typeof configOrUrl === "string") {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }
  config = mergeConfig$1(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional3 = config.transitional;
  if (transitional3 !== void 0) {
    validator.assertOptions(transitional3, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  var fullPath = buildFullPath2(config.baseURL, config.url);
  return buildURL2(fullPath, config.params, config.paramsSerializer);
};
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data2, config) {
      return this.request(mergeConfig$1(config || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url,
        data: data2
      }));
    };
  }
  Axios$1.prototype[method] = generateHTTPMethod();
  Axios$1.prototype[method + "Form"] = generateHTTPMethod(true);
});
var Axios_1 = Axios$1;
var CancelToken_1;
var hasRequiredCancelToken;
function requireCancelToken() {
  if (hasRequiredCancelToken)
    return CancelToken_1;
  hasRequiredCancelToken = 1;
  var CanceledError2 = requireCanceledError();
  function CancelToken(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve2) {
      resolvePromise = resolve2;
    });
    var token = this;
    this.promise.then(function(cancel) {
      if (!token._listeners)
        return;
      var i;
      var l = token._listeners.length;
      for (i = 0; i < l; i++) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });
    this.promise.then = function(onfulfilled) {
      var _resolve;
      var promise = new Promise(function(resolve2) {
        token.subscribe(resolve2);
        _resolve = resolve2;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message) {
      if (token.reason) {
        return;
      }
      token.reason = new CanceledError2(message);
      resolvePromise(token.reason);
    });
  }
  CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  };
  CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  };
  CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    var index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  };
  CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  };
  CancelToken_1 = CancelToken;
  return CancelToken_1;
}
var spread;
var hasRequiredSpread;
function requireSpread() {
  if (hasRequiredSpread)
    return spread;
  hasRequiredSpread = 1;
  spread = function spread2(callback) {
    return function wrap(arr) {
      return callback.apply(null, arr);
    };
  };
  return spread;
}
var isAxiosError;
var hasRequiredIsAxiosError;
function requireIsAxiosError() {
  if (hasRequiredIsAxiosError)
    return isAxiosError;
  hasRequiredIsAxiosError = 1;
  var utils2 = utils$b;
  isAxiosError = function isAxiosError2(payload) {
    return utils2.isObject(payload) && payload.isAxiosError === true;
  };
  return isAxiosError;
}
var utils = utils$b;
var bind2 = bind$2;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind2(Axios.prototype.request, context);
  utils.extend(instance, Axios.prototype, context);
  utils.extend(instance, context);
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig2(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.CanceledError = requireCanceledError();
axios$1.CancelToken = requireCancelToken();
axios$1.isCancel = requireIsCancel();
axios$1.VERSION = requireData().version;
axios$1.toFormData = toFormData_1;
axios$1.AxiosError = AxiosError_1;
axios$1.Cancel = axios$1.CanceledError;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = requireSpread();
axios$1.isAxiosError = requireIsAxiosError();
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
(function(module) {
  module.exports = axios$2.exports;
})(axios$3);
const axios = /* @__PURE__ */ getDefaultExportFromCjs(axios$3.exports);
var browser = typeof self == "object" ? self.FormData : window.FormData;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __export = (target, all2) => {
  for (var name in all2)
    __defProp(target, name, { get: all2[name], enumerable: true });
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var pathRegex = /^m(\/[0-9]+')+$/;
var replaceDerive = (val) => val.replace("'", "");
var HMAC_KEY = "ed25519 seed";
var HARDENED_OFFSET = 2147483648;
var getMasterKeyFromSeed = (seed) => {
  const h = hmac.create(sha512, HMAC_KEY);
  const I = h.update(hexToBytes(seed)).digest();
  const IL = I.slice(0, 32);
  const IR = I.slice(32);
  return {
    key: IL,
    chainCode: IR
  };
};
var CKDPriv = ({ key, chainCode }, index) => {
  const buffer = new ArrayBuffer(4);
  new DataView(buffer).setUint32(0, index);
  const indexBytes = new Uint8Array(buffer);
  const zero = new Uint8Array([0]);
  const data2 = new Uint8Array([...zero, ...key, ...indexBytes]);
  const I = hmac.create(sha512, chainCode).update(data2).digest();
  const IL = I.slice(0, 32);
  const IR = I.slice(32);
  return {
    key: IL,
    chainCode: IR
  };
};
var isValidPath = (path) => {
  if (!pathRegex.test(path)) {
    return false;
  }
  return !path.split("/").slice(1).map(replaceDerive).some(Number.isNaN);
};
var derivePath = (path, seed, offset = HARDENED_OFFSET) => {
  if (!isValidPath(path)) {
    throw new Error("Invalid derivation path");
  }
  const { key, chainCode } = getMasterKeyFromSeed(seed);
  const segments = path.split("/").slice(1).map(replaceDerive).map((el) => parseInt(el, 10));
  return segments.reduce((parentKeys, segment) => CKDPriv(parentKeys, segment + offset), { key, chainCode });
};
var HexString = class {
  static fromBuffer(buffer) {
    return HexString.fromUint8Array(buffer);
  }
  static fromUint8Array(arr) {
    return new HexString(bytesToHex(arr));
  }
  static ensure(hexString) {
    if (typeof hexString === "string") {
      return new HexString(hexString);
    }
    return hexString;
  }
  constructor(hexString) {
    if (hexString.startsWith("0x")) {
      this.hexString = hexString;
    } else {
      this.hexString = `0x${hexString}`;
    }
  }
  hex() {
    return this.hexString;
  }
  noPrefix() {
    return this.hexString.slice(2);
  }
  toString() {
    return this.hex();
  }
  toShortString() {
    const trimmed = this.hexString.replace(/^0x0*/, "");
    return `0x${trimmed}`;
  }
  toUint8Array() {
    return Uint8Array.from(hexToBytes(this.noPrefix()));
  }
};
async function sleep(timeMs) {
  return new Promise((resolve2) => {
    setTimeout(resolve2, timeMs);
  });
}
var DEFAULT_VERSION_PATH_BASE = "/v1";
function fixNodeUrl(nodeUrl) {
  let out = `${nodeUrl}`;
  if (out.endsWith("/")) {
    out = out.substring(0, out.length - 1);
  }
  if (!out.endsWith(DEFAULT_VERSION_PATH_BASE)) {
    out = `${out}${DEFAULT_VERSION_PATH_BASE}`;
  }
  return out;
}
var DEFAULT_MAX_GAS_AMOUNT = 2e5;
var DEFAULT_TXN_EXP_SEC_FROM_NOW = 20;
var DEFAULT_TXN_TIMEOUT_SEC = 20;
var APTOS_COIN = "0x1::aptos_coin::AptosCoin";
function Memoize(args) {
  let hashFunction;
  let ttlMs;
  let tags;
  if (typeof args === "object") {
    hashFunction = args.hashFunction;
    ttlMs = args.ttlMs;
    tags = args.tags;
  } else {
    hashFunction = args;
  }
  return (target, propertyKey, descriptor) => {
    if (descriptor.value != null) {
      descriptor.value = getNewFunction(descriptor.value, hashFunction, ttlMs, tags);
    } else if (descriptor.get != null) {
      descriptor.get = getNewFunction(descriptor.get, hashFunction, ttlMs, tags);
    } else {
      throw new Error("Only put a Memoize() decorator on a method or get accessor.");
    }
  };
}
function MemoizeExpiring(ttlMs, hashFunction) {
  return Memoize({
    ttlMs,
    hashFunction
  });
}
var clearCacheTagsMap = /* @__PURE__ */ new Map();
function clear(tags) {
  const cleared = /* @__PURE__ */ new Set();
  for (const tag of tags) {
    const maps = clearCacheTagsMap.get(tag);
    if (maps) {
      for (const mp of maps) {
        if (!cleared.has(mp)) {
          mp.clear();
          cleared.add(mp);
        }
      }
    }
  }
  return cleared.size;
}
function getNewFunction(originalMethod, hashFunction, ttlMs = 0, tags) {
  const propMapName = Symbol("__memoized_map__");
  return function(...args) {
    let returnedValue;
    const that = this;
    if (!that.hasOwnProperty(propMapName)) {
      Object.defineProperty(that, propMapName, {
        configurable: false,
        enumerable: false,
        writable: false,
        value: /* @__PURE__ */ new Map()
      });
    }
    const myMap = that[propMapName];
    if (Array.isArray(tags)) {
      for (const tag of tags) {
        if (clearCacheTagsMap.has(tag)) {
          clearCacheTagsMap.get(tag).push(myMap);
        } else {
          clearCacheTagsMap.set(tag, [myMap]);
        }
      }
    }
    if (hashFunction || args.length > 0 || ttlMs > 0) {
      let hashKey;
      if (hashFunction === true) {
        hashKey = args.map((a) => a.toString()).join("!");
      } else if (hashFunction) {
        hashKey = hashFunction.apply(that, args);
      } else {
        hashKey = args[0];
      }
      const timestampKey = `${hashKey}__timestamp`;
      let isExpired = false;
      if (ttlMs > 0) {
        if (!myMap.has(timestampKey)) {
          isExpired = true;
        } else {
          const timestamp = myMap.get(timestampKey);
          isExpired = Date.now() - timestamp > ttlMs;
        }
      }
      if (myMap.has(hashKey) && !isExpired) {
        returnedValue = myMap.get(hashKey);
      } else {
        returnedValue = originalMethod.apply(that, args);
        myMap.set(hashKey, returnedValue);
        if (ttlMs > 0) {
          myMap.set(timestampKey, Date.now());
        }
      }
    } else {
      const hashKey = that;
      if (myMap.has(hashKey)) {
        returnedValue = myMap.get(hashKey);
      } else {
        returnedValue = originalMethod.apply(that, args);
        myMap.set(hashKey, returnedValue);
      }
    }
    return returnedValue;
  };
}
async function paginateWithCursor(apiFunction, accountAddress, limitPerRequest, query) {
  var _a;
  const out = [];
  let cursor;
  while (true) {
    const response = await apiFunction(
      HexString.ensure(accountAddress).hex(),
      (_a = query == null ? void 0 : query.ledgerVersion) == null ? void 0 : _a.toString(),
      cursor,
      limitPerRequest
    );
    cursor = response.__headers["x-aptos-cursor"];
    delete response.__headers;
    out.push(...response);
    if (cursor === null || cursor === void 0) {
      break;
    }
  }
  return out;
}
var aptos_types_exports = {};
__export(aptos_types_exports, {
  AccountAddress: () => AccountAddress,
  AccountAuthenticator: () => AccountAuthenticator,
  AccountAuthenticatorEd25519: () => AccountAuthenticatorEd25519,
  AccountAuthenticatorMultiEd25519: () => AccountAuthenticatorMultiEd25519,
  ArgumentABI: () => ArgumentABI,
  AuthenticationKey: () => AuthenticationKey,
  ChainId: () => ChainId,
  ChangeSet: () => ChangeSet,
  Ed25519PublicKey: () => Ed25519PublicKey,
  Ed25519Signature: () => Ed25519Signature,
  EntryFunction: () => EntryFunction,
  EntryFunctionABI: () => EntryFunctionABI,
  Identifier: () => Identifier,
  Module: () => Module,
  ModuleId: () => ModuleId,
  MultiAgentRawTransaction: () => MultiAgentRawTransaction,
  MultiEd25519PublicKey: () => MultiEd25519PublicKey,
  MultiEd25519Signature: () => MultiEd25519Signature,
  RawTransaction: () => RawTransaction,
  RawTransactionWithData: () => RawTransactionWithData,
  RotationProofChallenge: () => RotationProofChallenge,
  Script: () => Script,
  ScriptABI: () => ScriptABI,
  SignedTransaction: () => SignedTransaction,
  StructTag: () => StructTag,
  Transaction: () => Transaction,
  TransactionArgument: () => TransactionArgument,
  TransactionArgumentAddress: () => TransactionArgumentAddress,
  TransactionArgumentBool: () => TransactionArgumentBool,
  TransactionArgumentU128: () => TransactionArgumentU128,
  TransactionArgumentU64: () => TransactionArgumentU64,
  TransactionArgumentU8: () => TransactionArgumentU8,
  TransactionArgumentU8Vector: () => TransactionArgumentU8Vector,
  TransactionAuthenticator: () => TransactionAuthenticator,
  TransactionAuthenticatorEd25519: () => TransactionAuthenticatorEd25519,
  TransactionAuthenticatorMultiAgent: () => TransactionAuthenticatorMultiAgent,
  TransactionAuthenticatorMultiEd25519: () => TransactionAuthenticatorMultiEd25519,
  TransactionPayload: () => TransactionPayload,
  TransactionPayloadEntryFunction: () => TransactionPayloadEntryFunction,
  TransactionPayloadScript: () => TransactionPayloadScript,
  TransactionScriptABI: () => TransactionScriptABI,
  TypeArgumentABI: () => TypeArgumentABI,
  TypeTag: () => TypeTag,
  TypeTagAddress: () => TypeTagAddress,
  TypeTagBool: () => TypeTagBool,
  TypeTagSigner: () => TypeTagSigner,
  TypeTagStruct: () => TypeTagStruct,
  TypeTagU128: () => TypeTagU128,
  TypeTagU64: () => TypeTagU64,
  TypeTagU8: () => TypeTagU8,
  TypeTagVector: () => TypeTagVector,
  UserTransaction: () => UserTransaction,
  WriteSet: () => WriteSet
});
var bcs_exports = {};
__export(bcs_exports, {
  Deserializer: () => Deserializer,
  Serializer: () => Serializer,
  bcsSerializeBool: () => bcsSerializeBool,
  bcsSerializeBytes: () => bcsSerializeBytes,
  bcsSerializeFixedBytes: () => bcsSerializeFixedBytes,
  bcsSerializeStr: () => bcsSerializeStr,
  bcsSerializeU128: () => bcsSerializeU128,
  bcsSerializeU16: () => bcsSerializeU16,
  bcsSerializeU32: () => bcsSerializeU32,
  bcsSerializeU8: () => bcsSerializeU8,
  bcsSerializeUint64: () => bcsSerializeUint64,
  bcsToBytes: () => bcsToBytes,
  deserializeVector: () => deserializeVector,
  serializeVector: () => serializeVector,
  serializeVectorWithFunc: () => serializeVectorWithFunc
});
var MAX_U8_NUMBER = 2 ** 8 - 1;
var MAX_U16_NUMBER = 2 ** 16 - 1;
var MAX_U32_NUMBER = 2 ** 32 - 1;
var MAX_U64_BIG_INT = BigInt(2 ** 64) - BigInt(1);
var MAX_U128_BIG_INT = BigInt(2 ** 128) - BigInt(1);
var Serializer = class {
  constructor() {
    this.buffer = new ArrayBuffer(64);
    this.offset = 0;
  }
  ensureBufferWillHandleSize(bytes2) {
    while (this.buffer.byteLength < this.offset + bytes2) {
      const newBuffer = new ArrayBuffer(this.buffer.byteLength * 2);
      new Uint8Array(newBuffer).set(new Uint8Array(this.buffer));
      this.buffer = newBuffer;
    }
  }
  serialize(values) {
    this.ensureBufferWillHandleSize(values.length);
    new Uint8Array(this.buffer, this.offset).set(values);
    this.offset += values.length;
  }
  serializeWithFunction(fn, bytesLength, value) {
    this.ensureBufferWillHandleSize(bytesLength);
    const dv = new DataView(this.buffer, this.offset);
    fn.apply(dv, [0, value, true]);
    this.offset += bytesLength;
  }
  serializeStr(value) {
    const textEncoder = new TextEncoder();
    this.serializeBytes(textEncoder.encode(value));
  }
  serializeBytes(value) {
    this.serializeU32AsUleb128(value.length);
    this.serialize(value);
  }
  serializeFixedBytes(value) {
    this.serialize(value);
  }
  serializeBool(value) {
    if (typeof value !== "boolean") {
      throw new Error("Value needs to be a boolean");
    }
    const byteValue = value ? 1 : 0;
    this.serialize(new Uint8Array([byteValue]));
  }
  serializeU8(value) {
    this.serialize(new Uint8Array([value]));
  }
  serializeU16(value) {
    this.serializeWithFunction(DataView.prototype.setUint16, 2, value);
  }
  serializeU32(value) {
    this.serializeWithFunction(DataView.prototype.setUint32, 4, value);
  }
  serializeU64(value) {
    const low = BigInt(value.toString()) & BigInt(MAX_U32_NUMBER);
    const high = BigInt(value.toString()) >> BigInt(32);
    this.serializeU32(Number(low));
    this.serializeU32(Number(high));
  }
  serializeU128(value) {
    const low = BigInt(value.toString()) & MAX_U64_BIG_INT;
    const high = BigInt(value.toString()) >> BigInt(64);
    this.serializeU64(low);
    this.serializeU64(high);
  }
  serializeU32AsUleb128(val) {
    let value = val;
    const valueArray = [];
    while (value >>> 7 !== 0) {
      valueArray.push(value & 127 | 128);
      value >>>= 7;
    }
    valueArray.push(value);
    this.serialize(new Uint8Array(valueArray));
  }
  getBytes() {
    return new Uint8Array(this.buffer).slice(0, this.offset);
  }
};
__decorateClass([
  checkNumberRange(0, MAX_U8_NUMBER)
], Serializer.prototype, "serializeU8", 1);
__decorateClass([
  checkNumberRange(0, MAX_U16_NUMBER)
], Serializer.prototype, "serializeU16", 1);
__decorateClass([
  checkNumberRange(0, MAX_U32_NUMBER)
], Serializer.prototype, "serializeU32", 1);
__decorateClass([
  checkNumberRange(BigInt(0), MAX_U64_BIG_INT)
], Serializer.prototype, "serializeU64", 1);
__decorateClass([
  checkNumberRange(BigInt(0), MAX_U128_BIG_INT)
], Serializer.prototype, "serializeU128", 1);
__decorateClass([
  checkNumberRange(0, MAX_U32_NUMBER)
], Serializer.prototype, "serializeU32AsUleb128", 1);
function checkNumberRange(minValue, maxValue, message) {
  return (target, propertyKey, descriptor) => {
    const childFunction = descriptor.value;
    descriptor.value = function deco(value) {
      const valueBigInt = BigInt(value.toString());
      if (valueBigInt > BigInt(maxValue.toString()) || valueBigInt < BigInt(minValue.toString())) {
        throw new Error(message || "Value is out of range");
      }
      childFunction.apply(this, [value]);
    };
    return descriptor;
  };
}
var Deserializer = class {
  constructor(data2) {
    this.buffer = new ArrayBuffer(data2.length);
    new Uint8Array(this.buffer).set(data2, 0);
    this.offset = 0;
  }
  read(length) {
    if (this.offset + length > this.buffer.byteLength) {
      throw new Error("Reached to the end of buffer");
    }
    const bytes2 = this.buffer.slice(this.offset, this.offset + length);
    this.offset += length;
    return bytes2;
  }
  deserializeStr() {
    const value = this.deserializeBytes();
    const textDecoder = new TextDecoder();
    return textDecoder.decode(value);
  }
  deserializeBytes() {
    const len = this.deserializeUleb128AsU32();
    return new Uint8Array(this.read(len));
  }
  deserializeFixedBytes(len) {
    return new Uint8Array(this.read(len));
  }
  deserializeBool() {
    const bool2 = new Uint8Array(this.read(1))[0];
    if (bool2 !== 1 && bool2 !== 0) {
      throw new Error("Invalid boolean value");
    }
    return bool2 === 1;
  }
  deserializeU8() {
    return new DataView(this.read(1)).getUint8(0);
  }
  deserializeU16() {
    return new DataView(this.read(2)).getUint16(0, true);
  }
  deserializeU32() {
    return new DataView(this.read(4)).getUint32(0, true);
  }
  deserializeU64() {
    const low = this.deserializeU32();
    const high = this.deserializeU32();
    return BigInt(BigInt(high) << BigInt(32) | BigInt(low));
  }
  deserializeU128() {
    const low = this.deserializeU64();
    const high = this.deserializeU64();
    return BigInt(high << BigInt(64) | low);
  }
  deserializeUleb128AsU32() {
    let value = BigInt(0);
    let shift = 0;
    while (value < MAX_U32_NUMBER) {
      const byte = this.deserializeU8();
      value |= BigInt(byte & 127) << BigInt(shift);
      if ((byte & 128) === 0) {
        break;
      }
      shift += 7;
    }
    if (value > MAX_U32_NUMBER) {
      throw new Error("Overflow while parsing uleb128-encoded uint32 value");
    }
    return Number(value);
  }
};
function serializeVector(value, serializer) {
  serializer.serializeU32AsUleb128(value.length);
  value.forEach((item) => {
    item.serialize(serializer);
  });
}
function serializeVectorWithFunc(value, func) {
  const serializer = new Serializer();
  serializer.serializeU32AsUleb128(value.length);
  const f = serializer[func];
  value.forEach((item) => {
    f.call(serializer, item);
  });
  return serializer.getBytes();
}
function deserializeVector(deserializer, cls) {
  const length = deserializer.deserializeUleb128AsU32();
  const list = [];
  for (let i = 0; i < length; i += 1) {
    list.push(cls.deserialize(deserializer));
  }
  return list;
}
function bcsToBytes(value) {
  const serializer = new Serializer();
  value.serialize(serializer);
  return serializer.getBytes();
}
function bcsSerializeUint64(value) {
  const serializer = new Serializer();
  serializer.serializeU64(value);
  return serializer.getBytes();
}
function bcsSerializeU8(value) {
  const serializer = new Serializer();
  serializer.serializeU8(value);
  return serializer.getBytes();
}
function bcsSerializeU16(value) {
  const serializer = new Serializer();
  serializer.serializeU16(value);
  return serializer.getBytes();
}
function bcsSerializeU32(value) {
  const serializer = new Serializer();
  serializer.serializeU32(value);
  return serializer.getBytes();
}
function bcsSerializeU128(value) {
  const serializer = new Serializer();
  serializer.serializeU128(value);
  return serializer.getBytes();
}
function bcsSerializeBool(value) {
  const serializer = new Serializer();
  serializer.serializeBool(value);
  return serializer.getBytes();
}
function bcsSerializeStr(value) {
  const serializer = new Serializer();
  serializer.serializeStr(value);
  return serializer.getBytes();
}
function bcsSerializeBytes(value) {
  const serializer = new Serializer();
  serializer.serializeBytes(value);
  return serializer.getBytes();
}
function bcsSerializeFixedBytes(value) {
  const serializer = new Serializer();
  serializer.serializeFixedBytes(value);
  return serializer.getBytes();
}
var _AccountAddress = class {
  constructor(address) {
    if (address.length !== _AccountAddress.LENGTH) {
      throw new Error("Expected address of length 32");
    }
    this.address = address;
  }
  static fromHex(addr) {
    let address = HexString.ensure(addr);
    if (address.noPrefix().length % 2 !== 0) {
      address = new HexString(`0${address.noPrefix()}`);
    }
    const addressBytes = address.toUint8Array();
    if (addressBytes.length > _AccountAddress.LENGTH) {
      throw new Error("Hex string is too long. Address's length is 32 bytes.");
    } else if (addressBytes.length === _AccountAddress.LENGTH) {
      return new _AccountAddress(addressBytes);
    }
    const res = new Uint8Array(_AccountAddress.LENGTH);
    res.set(addressBytes, _AccountAddress.LENGTH - addressBytes.length);
    return new _AccountAddress(res);
  }
  serialize(serializer) {
    serializer.serializeFixedBytes(this.address);
  }
  static deserialize(deserializer) {
    return new _AccountAddress(deserializer.deserializeFixedBytes(_AccountAddress.LENGTH));
  }
};
var AccountAddress = _AccountAddress;
AccountAddress.LENGTH = 32;
AccountAddress.CORE_CODE_ADDRESS = _AccountAddress.fromHex("0x1");
var _Ed25519PublicKey = class {
  constructor(value) {
    if (value.length !== _Ed25519PublicKey.LENGTH) {
      throw new Error(`Ed25519PublicKey length should be ${_Ed25519PublicKey.LENGTH}`);
    }
    this.value = value;
  }
  toBytes() {
    return this.value;
  }
  serialize(serializer) {
    serializer.serializeBytes(this.value);
  }
  static deserialize(deserializer) {
    const value = deserializer.deserializeBytes();
    return new _Ed25519PublicKey(value);
  }
};
var Ed25519PublicKey = _Ed25519PublicKey;
Ed25519PublicKey.LENGTH = 32;
var _Ed25519Signature = class {
  constructor(value) {
    this.value = value;
    if (value.length !== _Ed25519Signature.LENGTH) {
      throw new Error(`Ed25519Signature length should be ${_Ed25519Signature.LENGTH}`);
    }
  }
  serialize(serializer) {
    serializer.serializeBytes(this.value);
  }
  static deserialize(deserializer) {
    const value = deserializer.deserializeBytes();
    return new _Ed25519Signature(value);
  }
};
var Ed25519Signature = _Ed25519Signature;
Ed25519Signature.LENGTH = 64;
var MAX_SIGNATURES_SUPPORTED = 32;
var MultiEd25519PublicKey = class {
  constructor(public_keys, threshold) {
    this.public_keys = public_keys;
    this.threshold = threshold;
    if (threshold > MAX_SIGNATURES_SUPPORTED) {
      throw new Error(`"threshold" cannot be larger than ${MAX_SIGNATURES_SUPPORTED}`);
    }
  }
  toBytes() {
    const bytes2 = new Uint8Array(this.public_keys.length * Ed25519PublicKey.LENGTH + 1);
    this.public_keys.forEach((k, i) => {
      bytes2.set(k.value, i * Ed25519PublicKey.LENGTH);
    });
    bytes2[this.public_keys.length * Ed25519PublicKey.LENGTH] = this.threshold;
    return bytes2;
  }
  serialize(serializer) {
    serializer.serializeBytes(this.toBytes());
  }
  static deserialize(deserializer) {
    const bytes2 = deserializer.deserializeBytes();
    const threshold = bytes2[bytes2.length - 1];
    const keys = [];
    for (let i = 0; i < bytes2.length - 1; i += Ed25519PublicKey.LENGTH) {
      const begin = i;
      keys.push(new Ed25519PublicKey(bytes2.subarray(begin, begin + Ed25519PublicKey.LENGTH)));
    }
    return new MultiEd25519PublicKey(keys, threshold);
  }
};
var _MultiEd25519Signature = class {
  constructor(signatures, bitmap) {
    this.signatures = signatures;
    this.bitmap = bitmap;
    if (bitmap.length !== _MultiEd25519Signature.BITMAP_LEN) {
      throw new Error(`"bitmap" length should be ${_MultiEd25519Signature.BITMAP_LEN}`);
    }
  }
  toBytes() {
    const bytes2 = new Uint8Array(this.signatures.length * Ed25519Signature.LENGTH + _MultiEd25519Signature.BITMAP_LEN);
    this.signatures.forEach((k, i) => {
      bytes2.set(k.value, i * Ed25519Signature.LENGTH);
    });
    bytes2.set(this.bitmap, this.signatures.length * Ed25519Signature.LENGTH);
    return bytes2;
  }
  static createBitmap(bits) {
    const firstBitInByte = 128;
    const bitmap = new Uint8Array([0, 0, 0, 0]);
    const dupCheckSet = /* @__PURE__ */ new Set();
    bits.forEach((bit) => {
      if (bit >= MAX_SIGNATURES_SUPPORTED) {
        throw new Error(`Invalid bit value ${bit}.`);
      }
      if (dupCheckSet.has(bit)) {
        throw new Error("Duplicated bits detected.");
      }
      dupCheckSet.add(bit);
      const byteOffset = Math.floor(bit / 8);
      let byte = bitmap[byteOffset];
      byte |= firstBitInByte >> bit % 8;
      bitmap[byteOffset] = byte;
    });
    return bitmap;
  }
  serialize(serializer) {
    serializer.serializeBytes(this.toBytes());
  }
  static deserialize(deserializer) {
    const bytes2 = deserializer.deserializeBytes();
    const bitmap = bytes2.subarray(bytes2.length - 4);
    const sigs = [];
    for (let i = 0; i < bytes2.length - bitmap.length; i += Ed25519Signature.LENGTH) {
      const begin = i;
      sigs.push(new Ed25519Signature(bytes2.subarray(begin, begin + Ed25519Signature.LENGTH)));
    }
    return new _MultiEd25519Signature(sigs, bitmap);
  }
};
var MultiEd25519Signature = _MultiEd25519Signature;
MultiEd25519Signature.BITMAP_LEN = 4;
var TransactionAuthenticator = class {
  static deserialize(deserializer) {
    const index = deserializer.deserializeUleb128AsU32();
    switch (index) {
      case 0:
        return TransactionAuthenticatorEd25519.load(deserializer);
      case 1:
        return TransactionAuthenticatorMultiEd25519.load(deserializer);
      case 2:
        return TransactionAuthenticatorMultiAgent.load(deserializer);
      default:
        throw new Error(`Unknown variant index for TransactionAuthenticator: ${index}`);
    }
  }
};
var TransactionAuthenticatorEd25519 = class extends TransactionAuthenticator {
  constructor(public_key, signature) {
    super();
    this.public_key = public_key;
    this.signature = signature;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(0);
    this.public_key.serialize(serializer);
    this.signature.serialize(serializer);
  }
  static load(deserializer) {
    const public_key = Ed25519PublicKey.deserialize(deserializer);
    const signature = Ed25519Signature.deserialize(deserializer);
    return new TransactionAuthenticatorEd25519(public_key, signature);
  }
};
var TransactionAuthenticatorMultiEd25519 = class extends TransactionAuthenticator {
  constructor(public_key, signature) {
    super();
    this.public_key = public_key;
    this.signature = signature;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(1);
    this.public_key.serialize(serializer);
    this.signature.serialize(serializer);
  }
  static load(deserializer) {
    const public_key = MultiEd25519PublicKey.deserialize(deserializer);
    const signature = MultiEd25519Signature.deserialize(deserializer);
    return new TransactionAuthenticatorMultiEd25519(public_key, signature);
  }
};
var TransactionAuthenticatorMultiAgent = class extends TransactionAuthenticator {
  constructor(sender, secondary_signer_addresses, secondary_signers) {
    super();
    this.sender = sender;
    this.secondary_signer_addresses = secondary_signer_addresses;
    this.secondary_signers = secondary_signers;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(2);
    this.sender.serialize(serializer);
    serializeVector(this.secondary_signer_addresses, serializer);
    serializeVector(this.secondary_signers, serializer);
  }
  static load(deserializer) {
    const sender = AccountAuthenticator.deserialize(deserializer);
    const secondary_signer_addresses = deserializeVector(deserializer, AccountAddress);
    const secondary_signers = deserializeVector(deserializer, AccountAuthenticator);
    return new TransactionAuthenticatorMultiAgent(sender, secondary_signer_addresses, secondary_signers);
  }
};
var AccountAuthenticator = class {
  static deserialize(deserializer) {
    const index = deserializer.deserializeUleb128AsU32();
    switch (index) {
      case 0:
        return AccountAuthenticatorEd25519.load(deserializer);
      case 1:
        return AccountAuthenticatorMultiEd25519.load(deserializer);
      default:
        throw new Error(`Unknown variant index for AccountAuthenticator: ${index}`);
    }
  }
};
var AccountAuthenticatorEd25519 = class extends AccountAuthenticator {
  constructor(public_key, signature) {
    super();
    this.public_key = public_key;
    this.signature = signature;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(0);
    this.public_key.serialize(serializer);
    this.signature.serialize(serializer);
  }
  static load(deserializer) {
    const public_key = Ed25519PublicKey.deserialize(deserializer);
    const signature = Ed25519Signature.deserialize(deserializer);
    return new AccountAuthenticatorEd25519(public_key, signature);
  }
};
var AccountAuthenticatorMultiEd25519 = class extends AccountAuthenticator {
  constructor(public_key, signature) {
    super();
    this.public_key = public_key;
    this.signature = signature;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(1);
    this.public_key.serialize(serializer);
    this.signature.serialize(serializer);
  }
  static load(deserializer) {
    const public_key = MultiEd25519PublicKey.deserialize(deserializer);
    const signature = MultiEd25519Signature.deserialize(deserializer);
    return new AccountAuthenticatorMultiEd25519(public_key, signature);
  }
};
var Identifier = class {
  constructor(value) {
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeStr(this.value);
  }
  static deserialize(deserializer) {
    const value = deserializer.deserializeStr();
    return new Identifier(value);
  }
};
var TypeTag = class {
  static deserialize(deserializer) {
    const index = deserializer.deserializeUleb128AsU32();
    switch (index) {
      case 0:
        return TypeTagBool.load(deserializer);
      case 1:
        return TypeTagU8.load(deserializer);
      case 2:
        return TypeTagU64.load(deserializer);
      case 3:
        return TypeTagU128.load(deserializer);
      case 4:
        return TypeTagAddress.load(deserializer);
      case 5:
        return TypeTagSigner.load(deserializer);
      case 6:
        return TypeTagVector.load(deserializer);
      case 7:
        return TypeTagStruct.load(deserializer);
      default:
        throw new Error(`Unknown variant index for TypeTag: ${index}`);
    }
  }
};
var TypeTagBool = class extends TypeTag {
  serialize(serializer) {
    serializer.serializeU32AsUleb128(0);
  }
  static load(deserializer) {
    return new TypeTagBool();
  }
};
var TypeTagU8 = class extends TypeTag {
  serialize(serializer) {
    serializer.serializeU32AsUleb128(1);
  }
  static load(_deserializer) {
    return new TypeTagU8();
  }
};
var TypeTagU64 = class extends TypeTag {
  serialize(serializer) {
    serializer.serializeU32AsUleb128(2);
  }
  static load(_deserializer) {
    return new TypeTagU64();
  }
};
var TypeTagU128 = class extends TypeTag {
  serialize(serializer) {
    serializer.serializeU32AsUleb128(3);
  }
  static load(_deserializer) {
    return new TypeTagU128();
  }
};
var TypeTagAddress = class extends TypeTag {
  serialize(serializer) {
    serializer.serializeU32AsUleb128(4);
  }
  static load(_deserializer) {
    return new TypeTagAddress();
  }
};
var TypeTagSigner = class extends TypeTag {
  serialize(serializer) {
    serializer.serializeU32AsUleb128(5);
  }
  static load(_deserializer) {
    return new TypeTagSigner();
  }
};
var TypeTagVector = class extends TypeTag {
  constructor(value) {
    super();
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(6);
    this.value.serialize(serializer);
  }
  static load(deserializer) {
    const value = TypeTag.deserialize(deserializer);
    return new TypeTagVector(value);
  }
};
var TypeTagStruct = class extends TypeTag {
  constructor(value) {
    super();
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(7);
    this.value.serialize(serializer);
  }
  static load(deserializer) {
    const value = StructTag.deserialize(deserializer);
    return new TypeTagStruct(value);
  }
  isStringTypeTag() {
    if (this.value.module_name.value === "string" && this.value.name.value === "String" && this.value.address === AccountAddress.fromHex("0x1")) {
      return true;
    }
    return false;
  }
};
var StructTag = class {
  constructor(address, module_name, name, type_args) {
    this.address = address;
    this.module_name = module_name;
    this.name = name;
    this.type_args = type_args;
  }
  static fromString(structTag) {
    if (structTag.includes("<")) {
      throw new Error("Not implemented");
    }
    const parts = structTag.split("::");
    if (parts.length !== 3) {
      throw new Error("Invalid struct tag string literal.");
    }
    return new StructTag(AccountAddress.fromHex(parts[0]), new Identifier(parts[1]), new Identifier(parts[2]), []);
  }
  serialize(serializer) {
    this.address.serialize(serializer);
    this.module_name.serialize(serializer);
    this.name.serialize(serializer);
    serializeVector(this.type_args, serializer);
  }
  static deserialize(deserializer) {
    const address = AccountAddress.deserialize(deserializer);
    const moduleName = Identifier.deserialize(deserializer);
    const name = Identifier.deserialize(deserializer);
    const typeArgs = deserializeVector(deserializer, TypeTag);
    return new StructTag(address, moduleName, name, typeArgs);
  }
};
var RawTransaction = class {
  constructor(sender, sequence_number, payload, max_gas_amount, gas_unit_price, expiration_timestamp_secs, chain_id) {
    this.sender = sender;
    this.sequence_number = sequence_number;
    this.payload = payload;
    this.max_gas_amount = max_gas_amount;
    this.gas_unit_price = gas_unit_price;
    this.expiration_timestamp_secs = expiration_timestamp_secs;
    this.chain_id = chain_id;
  }
  serialize(serializer) {
    this.sender.serialize(serializer);
    serializer.serializeU64(this.sequence_number);
    this.payload.serialize(serializer);
    serializer.serializeU64(this.max_gas_amount);
    serializer.serializeU64(this.gas_unit_price);
    serializer.serializeU64(this.expiration_timestamp_secs);
    this.chain_id.serialize(serializer);
  }
  static deserialize(deserializer) {
    const sender = AccountAddress.deserialize(deserializer);
    const sequence_number = deserializer.deserializeU64();
    const payload = TransactionPayload.deserialize(deserializer);
    const max_gas_amount = deserializer.deserializeU64();
    const gas_unit_price = deserializer.deserializeU64();
    const expiration_timestamp_secs = deserializer.deserializeU64();
    const chain_id = ChainId.deserialize(deserializer);
    return new RawTransaction(
      sender,
      sequence_number,
      payload,
      max_gas_amount,
      gas_unit_price,
      expiration_timestamp_secs,
      chain_id
    );
  }
};
var Script = class {
  constructor(code, ty_args, args) {
    this.code = code;
    this.ty_args = ty_args;
    this.args = args;
  }
  serialize(serializer) {
    serializer.serializeBytes(this.code);
    serializeVector(this.ty_args, serializer);
    serializeVector(this.args, serializer);
  }
  static deserialize(deserializer) {
    const code = deserializer.deserializeBytes();
    const ty_args = deserializeVector(deserializer, TypeTag);
    const args = deserializeVector(deserializer, TransactionArgument);
    return new Script(code, ty_args, args);
  }
};
var EntryFunction = class {
  constructor(module_name, function_name, ty_args, args) {
    this.module_name = module_name;
    this.function_name = function_name;
    this.ty_args = ty_args;
    this.args = args;
  }
  static natural(module, func, ty_args, args) {
    return new EntryFunction(ModuleId.fromStr(module), new Identifier(func), ty_args, args);
  }
  static natual(module, func, ty_args, args) {
    return EntryFunction.natural(module, func, ty_args, args);
  }
  serialize(serializer) {
    this.module_name.serialize(serializer);
    this.function_name.serialize(serializer);
    serializeVector(this.ty_args, serializer);
    serializer.serializeU32AsUleb128(this.args.length);
    this.args.forEach((item) => {
      serializer.serializeBytes(item);
    });
  }
  static deserialize(deserializer) {
    const module_name = ModuleId.deserialize(deserializer);
    const function_name = Identifier.deserialize(deserializer);
    const ty_args = deserializeVector(deserializer, TypeTag);
    const length = deserializer.deserializeUleb128AsU32();
    const list = [];
    for (let i = 0; i < length; i += 1) {
      list.push(deserializer.deserializeBytes());
    }
    const args = list;
    return new EntryFunction(module_name, function_name, ty_args, args);
  }
};
var Module = class {
  constructor(code) {
    this.code = code;
  }
  serialize(serializer) {
    serializer.serializeBytes(this.code);
  }
  static deserialize(deserializer) {
    const code = deserializer.deserializeBytes();
    return new Module(code);
  }
};
var ModuleId = class {
  constructor(address, name) {
    this.address = address;
    this.name = name;
  }
  static fromStr(moduleId) {
    const parts = moduleId.split("::");
    if (parts.length !== 2) {
      throw new Error("Invalid module id.");
    }
    return new ModuleId(AccountAddress.fromHex(new HexString(parts[0])), new Identifier(parts[1]));
  }
  serialize(serializer) {
    this.address.serialize(serializer);
    this.name.serialize(serializer);
  }
  static deserialize(deserializer) {
    const address = AccountAddress.deserialize(deserializer);
    const name = Identifier.deserialize(deserializer);
    return new ModuleId(address, name);
  }
};
var ChangeSet = class {
  serialize(serializer) {
    throw new Error("Not implemented.");
  }
  static deserialize(deserializer) {
    throw new Error("Not implemented.");
  }
};
var WriteSet = class {
  serialize(serializer) {
    throw new Error("Not implmented.");
  }
  static deserialize(deserializer) {
    throw new Error("Not implmented.");
  }
};
var SignedTransaction = class {
  constructor(raw_txn, authenticator) {
    this.raw_txn = raw_txn;
    this.authenticator = authenticator;
  }
  serialize(serializer) {
    this.raw_txn.serialize(serializer);
    this.authenticator.serialize(serializer);
  }
  static deserialize(deserializer) {
    const raw_txn = RawTransaction.deserialize(deserializer);
    const authenticator = TransactionAuthenticator.deserialize(deserializer);
    return new SignedTransaction(raw_txn, authenticator);
  }
};
var RawTransactionWithData = class {
  static deserialize(deserializer) {
    const index = deserializer.deserializeUleb128AsU32();
    switch (index) {
      case 0:
        return MultiAgentRawTransaction.load(deserializer);
      default:
        throw new Error(`Unknown variant index for RawTransactionWithData: ${index}`);
    }
  }
};
var MultiAgentRawTransaction = class extends RawTransactionWithData {
  constructor(raw_txn, secondary_signer_addresses) {
    super();
    this.raw_txn = raw_txn;
    this.secondary_signer_addresses = secondary_signer_addresses;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(0);
    this.raw_txn.serialize(serializer);
    serializeVector(this.secondary_signer_addresses, serializer);
  }
  static load(deserializer) {
    const rawTxn = RawTransaction.deserialize(deserializer);
    const secondarySignerAddresses = deserializeVector(deserializer, AccountAddress);
    return new MultiAgentRawTransaction(rawTxn, secondarySignerAddresses);
  }
};
var TransactionPayload = class {
  static deserialize(deserializer) {
    const index = deserializer.deserializeUleb128AsU32();
    switch (index) {
      case 0:
        return TransactionPayloadScript.load(deserializer);
      case 2:
        return TransactionPayloadEntryFunction.load(deserializer);
      default:
        throw new Error(`Unknown variant index for TransactionPayload: ${index}`);
    }
  }
};
var TransactionPayloadScript = class extends TransactionPayload {
  constructor(value) {
    super();
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(0);
    this.value.serialize(serializer);
  }
  static load(deserializer) {
    const value = Script.deserialize(deserializer);
    return new TransactionPayloadScript(value);
  }
};
var TransactionPayloadEntryFunction = class extends TransactionPayload {
  constructor(value) {
    super();
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(2);
    this.value.serialize(serializer);
  }
  static load(deserializer) {
    const value = EntryFunction.deserialize(deserializer);
    return new TransactionPayloadEntryFunction(value);
  }
};
var ChainId = class {
  constructor(value) {
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeU8(this.value);
  }
  static deserialize(deserializer) {
    const value = deserializer.deserializeU8();
    return new ChainId(value);
  }
};
var TransactionArgument = class {
  static deserialize(deserializer) {
    const index = deserializer.deserializeUleb128AsU32();
    switch (index) {
      case 0:
        return TransactionArgumentU8.load(deserializer);
      case 1:
        return TransactionArgumentU64.load(deserializer);
      case 2:
        return TransactionArgumentU128.load(deserializer);
      case 3:
        return TransactionArgumentAddress.load(deserializer);
      case 4:
        return TransactionArgumentU8Vector.load(deserializer);
      case 5:
        return TransactionArgumentBool.load(deserializer);
      default:
        throw new Error(`Unknown variant index for TransactionArgument: ${index}`);
    }
  }
};
var TransactionArgumentU8 = class extends TransactionArgument {
  constructor(value) {
    super();
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(0);
    serializer.serializeU8(this.value);
  }
  static load(deserializer) {
    const value = deserializer.deserializeU8();
    return new TransactionArgumentU8(value);
  }
};
var TransactionArgumentU64 = class extends TransactionArgument {
  constructor(value) {
    super();
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(1);
    serializer.serializeU64(this.value);
  }
  static load(deserializer) {
    const value = deserializer.deserializeU64();
    return new TransactionArgumentU64(value);
  }
};
var TransactionArgumentU128 = class extends TransactionArgument {
  constructor(value) {
    super();
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(2);
    serializer.serializeU128(this.value);
  }
  static load(deserializer) {
    const value = deserializer.deserializeU128();
    return new TransactionArgumentU128(value);
  }
};
var TransactionArgumentAddress = class extends TransactionArgument {
  constructor(value) {
    super();
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(3);
    this.value.serialize(serializer);
  }
  static load(deserializer) {
    const value = AccountAddress.deserialize(deserializer);
    return new TransactionArgumentAddress(value);
  }
};
var TransactionArgumentU8Vector = class extends TransactionArgument {
  constructor(value) {
    super();
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(4);
    serializer.serializeBytes(this.value);
  }
  static load(deserializer) {
    const value = deserializer.deserializeBytes();
    return new TransactionArgumentU8Vector(value);
  }
};
var TransactionArgumentBool = class extends TransactionArgument {
  constructor(value) {
    super();
    this.value = value;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(5);
    serializer.serializeBool(this.value);
  }
  static load(deserializer) {
    const value = deserializer.deserializeBool();
    return new TransactionArgumentBool(value);
  }
};
var Transaction = class {
  getHashSalt() {
    const hash2 = sha3_256.create();
    hash2.update("APTOS::Transaction");
    return hash2.digest();
  }
  static deserialize(deserializer) {
    const index = deserializer.deserializeUleb128AsU32();
    switch (index) {
      case 0:
        return UserTransaction.load(deserializer);
      default:
        throw new Error(`Unknown variant index for Transaction: ${index}`);
    }
  }
};
var UserTransaction = class extends Transaction {
  constructor(value) {
    super();
    this.value = value;
  }
  hash() {
    const hash2 = sha3_256.create();
    hash2.update(this.getHashSalt());
    hash2.update(bcsToBytes(this));
    return hash2.digest();
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(0);
    this.value.serialize(serializer);
  }
  static load(deserializer) {
    return new UserTransaction(SignedTransaction.deserialize(deserializer));
  }
};
var TypeArgumentABI = class {
  constructor(name) {
    this.name = name;
  }
  serialize(serializer) {
    serializer.serializeStr(this.name);
  }
  static deserialize(deserializer) {
    const name = deserializer.deserializeStr();
    return new TypeArgumentABI(name);
  }
};
var ArgumentABI = class {
  constructor(name, type_tag) {
    this.name = name;
    this.type_tag = type_tag;
  }
  serialize(serializer) {
    serializer.serializeStr(this.name);
    this.type_tag.serialize(serializer);
  }
  static deserialize(deserializer) {
    const name = deserializer.deserializeStr();
    const typeTag = TypeTag.deserialize(deserializer);
    return new ArgumentABI(name, typeTag);
  }
};
var ScriptABI = class {
  static deserialize(deserializer) {
    const index = deserializer.deserializeUleb128AsU32();
    switch (index) {
      case 0:
        return TransactionScriptABI.load(deserializer);
      case 1:
        return EntryFunctionABI.load(deserializer);
      default:
        throw new Error(`Unknown variant index for TransactionPayload: ${index}`);
    }
  }
};
var TransactionScriptABI = class extends ScriptABI {
  constructor(name, doc, code, ty_args, args) {
    super();
    this.name = name;
    this.doc = doc;
    this.code = code;
    this.ty_args = ty_args;
    this.args = args;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(0);
    serializer.serializeStr(this.name);
    serializer.serializeStr(this.doc);
    serializer.serializeBytes(this.code);
    serializeVector(this.ty_args, serializer);
    serializeVector(this.args, serializer);
  }
  static load(deserializer) {
    const name = deserializer.deserializeStr();
    const doc = deserializer.deserializeStr();
    const code = deserializer.deserializeBytes();
    const tyArgs = deserializeVector(deserializer, TypeArgumentABI);
    const args = deserializeVector(deserializer, ArgumentABI);
    return new TransactionScriptABI(name, doc, code, tyArgs, args);
  }
};
var EntryFunctionABI = class extends ScriptABI {
  constructor(name, module_name, doc, ty_args, args) {
    super();
    this.name = name;
    this.module_name = module_name;
    this.doc = doc;
    this.ty_args = ty_args;
    this.args = args;
  }
  serialize(serializer) {
    serializer.serializeU32AsUleb128(1);
    serializer.serializeStr(this.name);
    this.module_name.serialize(serializer);
    serializer.serializeStr(this.doc);
    serializeVector(this.ty_args, serializer);
    serializeVector(this.args, serializer);
  }
  static load(deserializer) {
    const name = deserializer.deserializeStr();
    const moduleName = ModuleId.deserialize(deserializer);
    const doc = deserializer.deserializeStr();
    const tyArgs = deserializeVector(deserializer, TypeArgumentABI);
    const args = deserializeVector(deserializer, ArgumentABI);
    return new EntryFunctionABI(name, moduleName, doc, tyArgs, args);
  }
};
var _AuthenticationKey = class {
  constructor(bytes2) {
    if (bytes2.length !== _AuthenticationKey.LENGTH) {
      throw new Error("Expected a byte array of length 32");
    }
    this.bytes = bytes2;
  }
  static fromMultiEd25519PublicKey(publicKey) {
    const pubKeyBytes = publicKey.toBytes();
    const bytes2 = new Uint8Array(pubKeyBytes.length + 1);
    bytes2.set(pubKeyBytes);
    bytes2.set([_AuthenticationKey.MULTI_ED25519_SCHEME], pubKeyBytes.length);
    const hash2 = sha3_256.create();
    hash2.update(bytes2);
    return new _AuthenticationKey(hash2.digest());
  }
  static fromEd25519PublicKey(publicKey) {
    const pubKeyBytes = publicKey.value;
    const bytes2 = new Uint8Array(pubKeyBytes.length + 1);
    bytes2.set(pubKeyBytes);
    bytes2.set([_AuthenticationKey.ED25519_SCHEME], pubKeyBytes.length);
    const hash2 = sha3_256.create();
    hash2.update(bytes2);
    return new _AuthenticationKey(hash2.digest());
  }
  derivedAddress() {
    return HexString.fromUint8Array(this.bytes);
  }
};
var AuthenticationKey = _AuthenticationKey;
AuthenticationKey.LENGTH = 32;
AuthenticationKey.MULTI_ED25519_SCHEME = 1;
AuthenticationKey.ED25519_SCHEME = 0;
var RotationProofChallenge = class {
  constructor(accountAddress, moduleName, structName, sequenceNumber, originator, currentAuthKey, newPublicKey) {
    this.accountAddress = accountAddress;
    this.moduleName = moduleName;
    this.structName = structName;
    this.sequenceNumber = sequenceNumber;
    this.originator = originator;
    this.currentAuthKey = currentAuthKey;
    this.newPublicKey = newPublicKey;
  }
  serialize(serializer) {
    this.accountAddress.serialize(serializer);
    serializer.serializeStr(this.moduleName);
    serializer.serializeStr(this.structName);
    serializer.serializeU64(this.sequenceNumber);
    this.originator.serialize(serializer);
    this.currentAuthKey.serialize(serializer);
    serializer.serializeBytes(this.newPublicKey);
  }
};
var _AptosAccount = class {
  static fromAptosAccountObject(obj) {
    return new _AptosAccount(HexString.ensure(obj.privateKeyHex).toUint8Array(), obj.address);
  }
  static fromDerivePath(path, mnemonics) {
    if (!_AptosAccount.isValidPath(path)) {
      throw new Error("Invalid derivation path");
    }
    const normalizeMnemonics = mnemonics.trim().split(/\s+/).map((part) => part.toLowerCase()).join(" ");
    const { key } = derivePath(path, bytesToHex(mnemonicToSeedSync_1(normalizeMnemonics)));
    return new _AptosAccount(key);
  }
  constructor(privateKeyBytes, address) {
    if (privateKeyBytes) {
      this.signingKey = nacl2.sign.keyPair.fromSeed(privateKeyBytes.slice(0, 32));
    } else {
      this.signingKey = nacl2.sign.keyPair();
    }
    this.accountAddress = HexString.ensure(address || this.authKey().hex());
  }
  address() {
    return this.accountAddress;
  }
  authKey() {
    const pubKey = new Ed25519PublicKey(this.signingKey.publicKey);
    const authKey = AuthenticationKey.fromEd25519PublicKey(pubKey);
    return authKey.derivedAddress();
  }
  pubKey() {
    return HexString.fromUint8Array(this.signingKey.publicKey);
  }
  signBuffer(buffer) {
    const signature = nacl2.sign(buffer, this.signingKey.secretKey);
    return HexString.fromUint8Array(signature.slice(0, 64));
  }
  signHexString(hexString) {
    const toSign = HexString.ensure(hexString).toUint8Array();
    return this.signBuffer(toSign);
  }
  toPrivateKeyObject() {
    return {
      address: this.address().hex(),
      publicKeyHex: this.pubKey().hex(),
      privateKeyHex: HexString.fromUint8Array(this.signingKey.secretKey.slice(0, 32)).hex()
    };
  }
};
var AptosAccount = _AptosAccount;
AptosAccount.isValidPath = (path) => {
  if (!/^m\/44'\/637'\/[0-9]+'\/[0-9]+'\/[0-9]+'+$/.test(path)) {
    return false;
  }
  return true;
};
__decorateClass([
  Memoize()
], AptosAccount.prototype, "authKey", 1);
var generated_exports = {};
__export(generated_exports, {
  $AccountData: () => $AccountData,
  $AccountSignature: () => $AccountSignature,
  $AccountSignature_Ed25519Signature: () => $AccountSignature_Ed25519Signature,
  $AccountSignature_MultiEd25519Signature: () => $AccountSignature_MultiEd25519Signature,
  $Address: () => $Address,
  $AptosError: () => $AptosError,
  $AptosErrorCode: () => $AptosErrorCode,
  $Block: () => $Block,
  $BlockMetadataTransaction: () => $BlockMetadataTransaction,
  $DecodedTableData: () => $DecodedTableData,
  $DeleteModule: () => $DeleteModule,
  $DeleteResource: () => $DeleteResource,
  $DeleteTableItem: () => $DeleteTableItem,
  $DeletedTableData: () => $DeletedTableData,
  $DirectWriteSet: () => $DirectWriteSet,
  $Ed25519Signature: () => $Ed25519Signature,
  $EncodeSubmissionRequest: () => $EncodeSubmissionRequest,
  $EntryFunctionId: () => $EntryFunctionId,
  $EntryFunctionPayload: () => $EntryFunctionPayload,
  $Event: () => $Event,
  $EventGuid: () => $EventGuid,
  $GasEstimation: () => $GasEstimation,
  $GenesisPayload: () => $GenesisPayload,
  $GenesisPayload_WriteSetPayload: () => $GenesisPayload_WriteSetPayload,
  $GenesisTransaction: () => $GenesisTransaction,
  $HashValue: () => $HashValue,
  $HealthCheckSuccess: () => $HealthCheckSuccess,
  $HexEncodedBytes: () => $HexEncodedBytes,
  $IdentifierWrapper: () => $IdentifierWrapper,
  $IndexResponse: () => $IndexResponse,
  $ModuleBundlePayload: () => $ModuleBundlePayload,
  $MoveAbility: () => $MoveAbility,
  $MoveFunction: () => $MoveFunction,
  $MoveFunctionGenericTypeParam: () => $MoveFunctionGenericTypeParam,
  $MoveFunctionVisibility: () => $MoveFunctionVisibility,
  $MoveModule: () => $MoveModule,
  $MoveModuleBytecode: () => $MoveModuleBytecode,
  $MoveModuleId: () => $MoveModuleId,
  $MoveResource: () => $MoveResource,
  $MoveScriptBytecode: () => $MoveScriptBytecode,
  $MoveStruct: () => $MoveStruct,
  $MoveStructField: () => $MoveStructField,
  $MoveStructGenericTypeParam: () => $MoveStructGenericTypeParam,
  $MoveStructTag: () => $MoveStructTag,
  $MoveStructValue: () => $MoveStructValue,
  $MoveType: () => $MoveType,
  $MoveValue: () => $MoveValue,
  $MultiAgentSignature: () => $MultiAgentSignature,
  $MultiEd25519Signature: () => $MultiEd25519Signature,
  $PendingTransaction: () => $PendingTransaction,
  $RawTableItemRequest: () => $RawTableItemRequest,
  $RoleType: () => $RoleType,
  $ScriptPayload: () => $ScriptPayload,
  $ScriptWriteSet: () => $ScriptWriteSet,
  $StateCheckpointTransaction: () => $StateCheckpointTransaction,
  $StateKeyWrapper: () => $StateKeyWrapper,
  $SubmitTransactionRequest: () => $SubmitTransactionRequest,
  $TableItemRequest: () => $TableItemRequest,
  $Transaction: () => $Transaction,
  $TransactionPayload: () => $TransactionPayload,
  $TransactionPayload_EntryFunctionPayload: () => $TransactionPayload_EntryFunctionPayload,
  $TransactionPayload_ModuleBundlePayload: () => $TransactionPayload_ModuleBundlePayload,
  $TransactionPayload_ScriptPayload: () => $TransactionPayload_ScriptPayload,
  $TransactionSignature: () => $TransactionSignature,
  $TransactionSignature_Ed25519Signature: () => $TransactionSignature_Ed25519Signature,
  $TransactionSignature_MultiAgentSignature: () => $TransactionSignature_MultiAgentSignature,
  $TransactionSignature_MultiEd25519Signature: () => $TransactionSignature_MultiEd25519Signature,
  $Transaction_BlockMetadataTransaction: () => $Transaction_BlockMetadataTransaction,
  $Transaction_GenesisTransaction: () => $Transaction_GenesisTransaction,
  $Transaction_PendingTransaction: () => $Transaction_PendingTransaction,
  $Transaction_StateCheckpointTransaction: () => $Transaction_StateCheckpointTransaction,
  $Transaction_UserTransaction: () => $Transaction_UserTransaction,
  $TransactionsBatchSingleSubmissionFailure: () => $TransactionsBatchSingleSubmissionFailure,
  $TransactionsBatchSubmissionResult: () => $TransactionsBatchSubmissionResult,
  $U128: () => $U128,
  $U64: () => $U64,
  $UserTransaction: () => $UserTransaction,
  $VersionedEvent: () => $VersionedEvent,
  $WriteModule: () => $WriteModule,
  $WriteResource: () => $WriteResource,
  $WriteSet: () => $WriteSet,
  $WriteSetChange: () => $WriteSetChange,
  $WriteSetChange_DeleteModule: () => $WriteSetChange_DeleteModule,
  $WriteSetChange_DeleteResource: () => $WriteSetChange_DeleteResource,
  $WriteSetChange_DeleteTableItem: () => $WriteSetChange_DeleteTableItem,
  $WriteSetChange_WriteModule: () => $WriteSetChange_WriteModule,
  $WriteSetChange_WriteResource: () => $WriteSetChange_WriteResource,
  $WriteSetChange_WriteTableItem: () => $WriteSetChange_WriteTableItem,
  $WriteSetPayload: () => $WriteSetPayload,
  $WriteSet_DirectWriteSet: () => $WriteSet_DirectWriteSet,
  $WriteSet_ScriptWriteSet: () => $WriteSet_ScriptWriteSet,
  $WriteTableItem: () => $WriteTableItem,
  AccountsService: () => AccountsService,
  ApiError: () => ApiError,
  AptosErrorCode: () => AptosErrorCode,
  AptosGeneratedClient: () => AptosGeneratedClient,
  BaseHttpRequest: () => BaseHttpRequest,
  BlocksService: () => BlocksService,
  CancelError: () => CancelError,
  CancelablePromise: () => CancelablePromise,
  EventsService: () => EventsService,
  GeneralService: () => GeneralService,
  MoveFunctionVisibility: () => MoveFunctionVisibility,
  OpenAPI: () => OpenAPI,
  RoleType: () => RoleType,
  TablesService: () => TablesService,
  TransactionsService: () => TransactionsService
});
var BaseHttpRequest = class {
  constructor(config) {
    this.config = config;
  }
};
var ApiError = class extends Error {
  constructor(request22, response, message) {
    super(message);
    this.name = "ApiError";
    this.url = response.url;
    this.status = response.status;
    this.statusText = response.statusText;
    this.body = response.body;
    this.request = request22;
  }
};
var CancelError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "CancelError";
  }
  get isCancelled() {
    return true;
  }
};
var CancelablePromise = class {
  constructor(executor) {
    this._isResolved = false;
    this._isRejected = false;
    this._isCancelled = false;
    this._cancelHandlers = [];
    this._promise = new Promise((resolve2, reject) => {
      this._resolve = resolve2;
      this._reject = reject;
      const onResolve = (value) => {
        var _a;
        if (this._isResolved || this._isRejected || this._isCancelled) {
          return;
        }
        this._isResolved = true;
        (_a = this._resolve) == null ? void 0 : _a.call(this, value);
      };
      const onReject = (reason) => {
        var _a;
        if (this._isResolved || this._isRejected || this._isCancelled) {
          return;
        }
        this._isRejected = true;
        (_a = this._reject) == null ? void 0 : _a.call(this, reason);
      };
      const onCancel = (cancelHandler) => {
        if (this._isResolved || this._isRejected || this._isCancelled) {
          return;
        }
        this._cancelHandlers.push(cancelHandler);
      };
      Object.defineProperty(onCancel, "isResolved", {
        get: () => this._isResolved
      });
      Object.defineProperty(onCancel, "isRejected", {
        get: () => this._isRejected
      });
      Object.defineProperty(onCancel, "isCancelled", {
        get: () => this._isCancelled
      });
      return executor(onResolve, onReject, onCancel);
    });
  }
  then(onFulfilled, onRejected) {
    return this._promise.then(onFulfilled, onRejected);
  }
  catch(onRejected) {
    return this._promise.catch(onRejected);
  }
  finally(onFinally) {
    return this._promise.finally(onFinally);
  }
  cancel() {
    var _a;
    if (this._isResolved || this._isRejected || this._isCancelled) {
      return;
    }
    this._isCancelled = true;
    if (this._cancelHandlers.length) {
      try {
        for (const cancelHandler of this._cancelHandlers) {
          cancelHandler();
        }
      } catch (error) {
        console.warn("Cancellation threw an error", error);
        return;
      }
    }
    this._cancelHandlers.length = 0;
    (_a = this._reject) == null ? void 0 : _a.call(this, new CancelError("Request aborted"));
  }
  get isCancelled() {
    return this._isCancelled;
  }
};
var CookieJar = class {
  constructor(jar2 = /* @__PURE__ */ new Map()) {
    this.jar = jar2;
  }
  setCookie(url, cookieStr) {
    var _a;
    const key = url.origin.toLowerCase();
    if (!this.jar.has(key)) {
      this.jar.set(key, []);
    }
    const cookie = CookieJar.parse(cookieStr);
    this.jar.set(key, [...((_a = this.jar.get(key)) == null ? void 0 : _a.filter((c) => c.name !== cookie.name)) || [], cookie]);
  }
  getCookies(url) {
    var _a;
    const key = url.origin.toLowerCase();
    if (!this.jar.get(key)) {
      return [];
    }
    return ((_a = this.jar.get(key)) == null ? void 0 : _a.filter((cookie) => !cookie.expires || cookie.expires > new Date())) || [];
  }
  static parse(str) {
    if (typeof str !== "string") {
      throw new Error("argument str must be a string");
    }
    const parts = str.split(";").map((part) => part.trim());
    let cookie;
    if (parts.length > 0) {
      const [name, value] = parts[0].split("=");
      if (!name || !value) {
        throw new Error("Invalid cookie");
      }
      cookie = {
        name,
        value
      };
    } else {
      throw new Error("Invalid cookie");
    }
    parts.slice(1).forEach((part) => {
      const [name, value] = part.split("=");
      if (!name.trim()) {
        throw new Error("Invalid cookie");
      }
      const nameLow = name.toLowerCase();
      const val = (value == null ? void 0 : value.charAt(0)) === "'" || (value == null ? void 0 : value.charAt(0)) === '"' ? value == null ? void 0 : value.slice(1, -1) : value;
      if (nameLow === "expires") {
        cookie.expires = new Date(val);
      }
      if (nameLow === "path") {
        cookie.path = val;
      }
      if (nameLow === "samesite") {
        if (val !== "Lax" && val !== "None" && val !== "Strict") {
          throw new Error("Invalid cookie SameSite value");
        }
        cookie.sameSite = val;
      }
      if (nameLow === "secure") {
        cookie.secure = true;
      }
    });
    return cookie;
  }
};
var jar = new CookieJar();
axios.interceptors.response.use((response) => {
  if (Array.isArray(response.headers["set-cookie"])) {
    response.headers["set-cookie"].forEach((c) => {
      jar.setCookie(new URL(response.config.url), c);
    });
  }
  return response;
});
axios.interceptors.request.use(function(config) {
  const cookies2 = jar.getCookies(new URL(config.url));
  if ((cookies2 == null ? void 0 : cookies2.length) > 0 && config.headers) {
    config.headers.cookie = cookies2.map((cookie) => `${cookie.name}=${cookie.value}`).join("; ");
  }
  return config;
});
var isDefined = (value) => {
  return value !== void 0 && value !== null;
};
var isString = (value) => {
  return typeof value === "string";
};
var isStringWithValue = (value) => {
  return isString(value) && value !== "";
};
var isBlob = (value) => {
  return typeof value === "object" && typeof value.type === "string" && typeof value.stream === "function" && typeof value.arrayBuffer === "function" && typeof value.constructor === "function" && typeof value.constructor.name === "string" && /^(Blob|File)$/.test(value.constructor.name) && /^(Blob|File)$/.test(value[Symbol.toStringTag]);
};
var isFormData = (value) => {
  return value instanceof browser;
};
var isSuccess = (status) => {
  return status >= 200 && status < 300;
};
var base64 = (str) => {
  return btoa(str);
};
var getQueryString = (params) => {
  const qs = [];
  const append = (key, value) => {
    qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  };
  const process2 = (key, value) => {
    if (isDefined(value)) {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          process2(key, v);
        });
      } else if (typeof value === "object") {
        Object.entries(value).forEach(([k, v]) => {
          process2(`${key}[${k}]`, v);
        });
      } else {
        append(key, value);
      }
    }
  };
  Object.entries(params).forEach(([key, value]) => {
    process2(key, value);
  });
  if (qs.length > 0) {
    return `?${qs.join("&")}`;
  }
  return "";
};
var getUrl = (config, options) => {
  const encoder2 = config.ENCODE_PATH || encodeURI;
  const path = options.url.replace("{api-version}", config.VERSION).replace(/{(.*?)}/g, (substring, group) => {
    var _a;
    if ((_a = options.path) == null ? void 0 : _a.hasOwnProperty(group)) {
      return encoder2(String(options.path[group]));
    }
    return substring;
  });
  const url = `${config.BASE}${path}`;
  if (options.query) {
    return `${url}${getQueryString(options.query)}`;
  }
  return url;
};
var getFormData = (options) => {
  if (options.formData) {
    const formData = new browser();
    const process2 = (key, value) => {
      if (isString(value) || isBlob(value)) {
        formData.append(key, value);
      } else {
        formData.append(key, JSON.stringify(value));
      }
    };
    Object.entries(options.formData).filter(([_, value]) => isDefined(value)).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => process2(key, v));
      } else {
        process2(key, value);
      }
    });
    return formData;
  }
  return void 0;
};
var resolve = async (options, resolver) => {
  if (typeof resolver === "function") {
    return resolver(options);
  }
  return resolver;
};
var getHeaders = async (config, options, formData) => {
  const token = await resolve(options, config.TOKEN);
  const username = await resolve(options, config.USERNAME);
  const password = await resolve(options, config.PASSWORD);
  const additionalHeaders = await resolve(options, config.HEADERS);
  const formHeaders = typeof (formData == null ? void 0 : formData.getHeaders) === "function" && (formData == null ? void 0 : formData.getHeaders()) || {};
  const headers = Object.entries({
    Accept: "application/json",
    ...additionalHeaders,
    ...options.headers,
    ...formHeaders
  }).filter(([_, value]) => isDefined(value)).reduce((headers2, [key, value]) => ({
    ...headers2,
    [key]: String(value)
  }), {});
  if (isStringWithValue(token)) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  if (isStringWithValue(username) && isStringWithValue(password)) {
    const credentials = base64(`${username}:${password}`);
    headers["Authorization"] = `Basic ${credentials}`;
  }
  if (options.body) {
    if (options.mediaType) {
      headers["Content-Type"] = options.mediaType;
    } else if (isBlob(options.body)) {
      headers["Content-Type"] = options.body.type || "application/octet-stream";
    } else if (isString(options.body)) {
      headers["Content-Type"] = "text/plain";
    } else if (!isFormData(options.body)) {
      headers["Content-Type"] = "application/json";
    }
  }
  return headers;
};
var getRequestBody = (options) => {
  if (options.body) {
    return options.body;
  }
  return void 0;
};
var sendRequest = async (config, options, url, body, formData, headers, onCancel) => {
  const source = axios.CancelToken.source();
  const requestConfig = {
    url,
    headers,
    data: body != null ? body : formData,
    method: options.method,
    withCredentials: config.WITH_CREDENTIALS,
    cancelToken: source.token
  };
  const isBCS = Object.keys(config.HEADERS || {}).filter((k) => k.toLowerCase() === "accept").map((k) => config.HEADERS[k]).includes("application/x-bcs");
  if (isBCS) {
    requestConfig.responseType = "arraybuffer";
  }
  onCancel(() => source.cancel("The user aborted a request."));
  try {
    return await axios.request(requestConfig);
  } catch (error) {
    const axiosError = error;
    if (axiosError.response) {
      return axiosError.response;
    }
    throw error;
  }
};
var getResponseHeader = (response, responseHeader) => {
  if (responseHeader) {
    const content = response.headers[responseHeader];
    if (isString(content)) {
      return content;
    }
  }
  return void 0;
};
var getResponseBody = (response) => {
  if (response.status !== 204) {
    return response.data;
  }
  return void 0;
};
var catchErrorCodes = (options, result) => {
  const errors = {
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    500: "Internal Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable",
    ...options.errors
  };
  const error = errors[result.status];
  if (error) {
    throw new ApiError(options, result, error);
  }
  if (!result.ok) {
    throw new ApiError(options, result, "Generic Error");
  }
};
var request2 = (config, options) => {
  return new CancelablePromise(async (resolve2, reject, onCancel) => {
    try {
      const url = getUrl(config, options);
      const formData = getFormData(options);
      const body = getRequestBody(options);
      const headers = await getHeaders(config, options, formData);
      if (!onCancel.isCancelled) {
        const response = await sendRequest(config, options, url, body, formData, headers, onCancel);
        const responseBody = getResponseBody(response);
        const responseHeader = getResponseHeader(response, options.responseHeader);
        const result = {
          url,
          ok: isSuccess(response.status),
          status: response.status,
          statusText: response.statusText,
          body: responseHeader != null ? responseHeader : responseBody
        };
        catchErrorCodes(options, result);
        const out = result.body;
        try {
          out["__headers"] = response.headers;
        } catch (_) {
        }
        resolve2(out);
      }
    } catch (error) {
      reject(error);
    }
  });
};
var AxiosHttpRequest = class extends BaseHttpRequest {
  constructor(config) {
    super(config);
  }
  request(options) {
    return request2(this.config, options);
  }
};
var AccountsService = class {
  constructor(httpRequest) {
    this.httpRequest = httpRequest;
  }
  getAccount(address, ledgerVersion) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}",
      path: {
        "address": address
      },
      query: {
        "ledger_version": ledgerVersion
      }
    });
  }
  getAccountResources(address, ledgerVersion, start, limit) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/resources",
      path: {
        "address": address
      },
      query: {
        "ledger_version": ledgerVersion,
        "start": start,
        "limit": limit
      }
    });
  }
  getAccountModules(address, ledgerVersion, start, limit) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/modules",
      path: {
        "address": address
      },
      query: {
        "ledger_version": ledgerVersion,
        "start": start,
        "limit": limit
      }
    });
  }
  getAccountResource(address, resourceType, ledgerVersion) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/resource/{resource_type}",
      path: {
        "address": address,
        "resource_type": resourceType
      },
      query: {
        "ledger_version": ledgerVersion
      }
    });
  }
  getAccountModule(address, moduleName, ledgerVersion) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/module/{module_name}",
      path: {
        "address": address,
        "module_name": moduleName
      },
      query: {
        "ledger_version": ledgerVersion
      }
    });
  }
};
var BlocksService = class {
  constructor(httpRequest) {
    this.httpRequest = httpRequest;
  }
  getBlockByHeight(blockHeight, withTransactions) {
    return this.httpRequest.request({
      method: "GET",
      url: "/blocks/by_height/{block_height}",
      path: {
        "block_height": blockHeight
      },
      query: {
        "with_transactions": withTransactions
      }
    });
  }
  getBlockByVersion(version, withTransactions) {
    return this.httpRequest.request({
      method: "GET",
      url: "/blocks/by_version/{version}",
      path: {
        "version": version
      },
      query: {
        "with_transactions": withTransactions
      }
    });
  }
};
var EventsService = class {
  constructor(httpRequest) {
    this.httpRequest = httpRequest;
  }
  getEventsByCreationNumber(address, creationNumber, start, limit) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/events/{creation_number}",
      path: {
        "address": address,
        "creation_number": creationNumber
      },
      query: {
        "start": start,
        "limit": limit
      }
    });
  }
  getEventsByEventHandle(address, eventHandle, fieldName, start, limit) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/events/{event_handle}/{field_name}",
      path: {
        "address": address,
        "event_handle": eventHandle,
        "field_name": fieldName
      },
      query: {
        "start": start,
        "limit": limit
      }
    });
  }
};
var GeneralService = class {
  constructor(httpRequest) {
    this.httpRequest = httpRequest;
  }
  spec() {
    return this.httpRequest.request({
      method: "GET",
      url: "/spec"
    });
  }
  healthy(durationSecs) {
    return this.httpRequest.request({
      method: "GET",
      url: "/-/healthy",
      query: {
        "duration_secs": durationSecs
      }
    });
  }
  getLedgerInfo() {
    return this.httpRequest.request({
      method: "GET",
      url: "/"
    });
  }
};
var TablesService = class {
  constructor(httpRequest) {
    this.httpRequest = httpRequest;
  }
  getTableItem(tableHandle, requestBody, ledgerVersion) {
    return this.httpRequest.request({
      method: "POST",
      url: "/tables/{table_handle}/item",
      path: {
        "table_handle": tableHandle
      },
      query: {
        "ledger_version": ledgerVersion
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  getRawTableItem(tableHandle, requestBody, ledgerVersion) {
    return this.httpRequest.request({
      method: "POST",
      url: "/tables/{table_handle}/raw_item",
      path: {
        "table_handle": tableHandle
      },
      query: {
        "ledger_version": ledgerVersion
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
};
var TransactionsService = class {
  constructor(httpRequest) {
    this.httpRequest = httpRequest;
  }
  getTransactions(start, limit) {
    return this.httpRequest.request({
      method: "GET",
      url: "/transactions",
      query: {
        "start": start,
        "limit": limit
      }
    });
  }
  submitTransaction(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/transactions",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  getTransactionByHash(txnHash) {
    return this.httpRequest.request({
      method: "GET",
      url: "/transactions/by_hash/{txn_hash}",
      path: {
        "txn_hash": txnHash
      }
    });
  }
  getTransactionByVersion(txnVersion) {
    return this.httpRequest.request({
      method: "GET",
      url: "/transactions/by_version/{txn_version}",
      path: {
        "txn_version": txnVersion
      }
    });
  }
  getAccountTransactions(address, start, limit) {
    return this.httpRequest.request({
      method: "GET",
      url: "/accounts/{address}/transactions",
      path: {
        "address": address
      },
      query: {
        "start": start,
        "limit": limit
      }
    });
  }
  submitBatchTransactions(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/transactions/batch",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  simulateTransaction(requestBody, estimateMaxGasAmount, estimateGasUnitPrice, estimatePrioritizedGasUnitPrice) {
    return this.httpRequest.request({
      method: "POST",
      url: "/transactions/simulate",
      query: {
        "estimate_max_gas_amount": estimateMaxGasAmount,
        "estimate_gas_unit_price": estimateGasUnitPrice,
        "estimate_prioritized_gas_unit_price": estimatePrioritizedGasUnitPrice
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  encodeSubmission(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/transactions/encode_submission",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  estimateGasPrice() {
    return this.httpRequest.request({
      method: "GET",
      url: "/estimate_gas_price"
    });
  }
};
var AptosGeneratedClient = class {
  constructor(config, HttpRequest = AxiosHttpRequest) {
    var _a, _b, _c, _d;
    this.request = new HttpRequest({
      BASE: (_a = config == null ? void 0 : config.BASE) != null ? _a : "/v1",
      VERSION: (_b = config == null ? void 0 : config.VERSION) != null ? _b : "1.2.0",
      WITH_CREDENTIALS: (_c = config == null ? void 0 : config.WITH_CREDENTIALS) != null ? _c : false,
      CREDENTIALS: (_d = config == null ? void 0 : config.CREDENTIALS) != null ? _d : "include",
      TOKEN: config == null ? void 0 : config.TOKEN,
      USERNAME: config == null ? void 0 : config.USERNAME,
      PASSWORD: config == null ? void 0 : config.PASSWORD,
      HEADERS: config == null ? void 0 : config.HEADERS,
      ENCODE_PATH: config == null ? void 0 : config.ENCODE_PATH
    });
    this.accounts = new AccountsService(this.request);
    this.blocks = new BlocksService(this.request);
    this.events = new EventsService(this.request);
    this.general = new GeneralService(this.request);
    this.tables = new TablesService(this.request);
    this.transactions = new TransactionsService(this.request);
  }
};
var OpenAPI = {
  BASE: "/v1",
  VERSION: "1.2.0",
  WITH_CREDENTIALS: false,
  CREDENTIALS: "include",
  TOKEN: void 0,
  USERNAME: void 0,
  PASSWORD: void 0,
  HEADERS: void 0,
  ENCODE_PATH: void 0
};
var AptosErrorCode = /* @__PURE__ */ ((AptosErrorCode2) => {
  AptosErrorCode2["ACCOUNT_NOT_FOUND"] = "account_not_found";
  AptosErrorCode2["RESOURCE_NOT_FOUND"] = "resource_not_found";
  AptosErrorCode2["MODULE_NOT_FOUND"] = "module_not_found";
  AptosErrorCode2["STRUCT_FIELD_NOT_FOUND"] = "struct_field_not_found";
  AptosErrorCode2["VERSION_NOT_FOUND"] = "version_not_found";
  AptosErrorCode2["TRANSACTION_NOT_FOUND"] = "transaction_not_found";
  AptosErrorCode2["TABLE_ITEM_NOT_FOUND"] = "table_item_not_found";
  AptosErrorCode2["BLOCK_NOT_FOUND"] = "block_not_found";
  AptosErrorCode2["VERSION_PRUNED"] = "version_pruned";
  AptosErrorCode2["BLOCK_PRUNED"] = "block_pruned";
  AptosErrorCode2["INVALID_INPUT"] = "invalid_input";
  AptosErrorCode2["INVALID_TRANSACTION_UPDATE"] = "invalid_transaction_update";
  AptosErrorCode2["SEQUENCE_NUMBER_TOO_OLD"] = "sequence_number_too_old";
  AptosErrorCode2["VM_ERROR"] = "vm_error";
  AptosErrorCode2["HEALTH_CHECK_FAILED"] = "health_check_failed";
  AptosErrorCode2["MEMPOOL_IS_FULL"] = "mempool_is_full";
  AptosErrorCode2["INTERNAL_ERROR"] = "internal_error";
  AptosErrorCode2["WEB_FRAMEWORK_ERROR"] = "web_framework_error";
  AptosErrorCode2["BCS_NOT_SUPPORTED"] = "bcs_not_supported";
  AptosErrorCode2["API_DISABLED"] = "api_disabled";
  return AptosErrorCode2;
})(AptosErrorCode || {});
var MoveFunctionVisibility = /* @__PURE__ */ ((MoveFunctionVisibility2) => {
  MoveFunctionVisibility2["PRIVATE"] = "private";
  MoveFunctionVisibility2["PUBLIC"] = "public";
  MoveFunctionVisibility2["FRIEND"] = "friend";
  return MoveFunctionVisibility2;
})(MoveFunctionVisibility || {});
var RoleType = /* @__PURE__ */ ((RoleType2) => {
  RoleType2["VALIDATOR"] = "validator";
  RoleType2["FULL_NODE"] = "full_node";
  return RoleType2;
})(RoleType || {});
var $AccountData = {
  description: `Account data

    A simplified version of the onchain Account resource`,
  properties: {
    sequence_number: {
      type: "U64",
      isRequired: true
    },
    authentication_key: {
      type: "HexEncodedBytes",
      isRequired: true
    }
  }
};
var $AccountSignature = {
  type: "one-of",
  description: `Account signature scheme

    The account signature scheme allows you to have two types of accounts:

    1. A single Ed25519 key account, one private key
    2. A k-of-n multi-Ed25519 key account, multiple private keys, such that k-of-n must sign a transaction.`,
  contains: [{
    type: "AccountSignature_Ed25519Signature"
  }, {
    type: "AccountSignature_MultiEd25519Signature"
  }]
};
var $AccountSignature_Ed25519Signature = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "Ed25519Signature"
  }]
};
var $AccountSignature_MultiEd25519Signature = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "MultiEd25519Signature"
  }]
};
var $Address = {
  type: "string",
  description: `A hex encoded 32 byte Aptos account address.

    This is represented in a string as a 64 character hex string, sometimes
    shortened by stripping leading 0s, and adding a 0x.

    For example, address 0x0000000000000000000000000000000000000000000000000000000000000001 is represented as 0x1.
    `,
  format: "hex"
};
var $AptosError = {
  description: `This is the generic struct we use for all API errors, it contains a string
    message and an Aptos API specific error code.`,
  properties: {
    message: {
      type: "string",
      description: `A message describing the error`,
      isRequired: true
    },
    error_code: {
      type: "AptosErrorCode",
      isRequired: true
    },
    vm_error_code: {
      type: "number",
      description: `A code providing VM error details when submitting transactions to the VM`,
      format: "uint64"
    }
  }
};
var $AptosErrorCode = {
  type: "Enum"
};
var $Block = {
  description: `A Block with or without transactions

    This contains the information about a transactions along with
    associated transactions if requested`,
  properties: {
    block_height: {
      type: "U64",
      isRequired: true
    },
    block_hash: {
      type: "HashValue",
      isRequired: true
    },
    block_timestamp: {
      type: "U64",
      isRequired: true
    },
    first_version: {
      type: "U64",
      isRequired: true
    },
    last_version: {
      type: "U64",
      isRequired: true
    },
    transactions: {
      type: "array",
      contains: {
        type: "Transaction"
      }
    }
  }
};
var $BlockMetadataTransaction = {
  description: `A block metadata transaction

    This signifies the beginning of a block, and contains information
    about the specific block`,
  properties: {
    version: {
      type: "U64",
      isRequired: true
    },
    hash: {
      type: "HashValue",
      isRequired: true
    },
    state_change_hash: {
      type: "HashValue",
      isRequired: true
    },
    event_root_hash: {
      type: "HashValue",
      isRequired: true
    },
    state_checkpoint_hash: {
      type: "HashValue"
    },
    gas_used: {
      type: "U64",
      isRequired: true
    },
    success: {
      type: "boolean",
      description: `Whether the transaction was successful`,
      isRequired: true
    },
    vm_status: {
      type: "string",
      description: `The VM status of the transaction, can tell useful information in a failure`,
      isRequired: true
    },
    accumulator_root_hash: {
      type: "HashValue",
      isRequired: true
    },
    changes: {
      type: "array",
      contains: {
        type: "WriteSetChange"
      },
      isRequired: true
    },
    id: {
      type: "HashValue",
      isRequired: true
    },
    epoch: {
      type: "U64",
      isRequired: true
    },
    round: {
      type: "U64",
      isRequired: true
    },
    events: {
      type: "array",
      contains: {
        type: "Event"
      },
      isRequired: true
    },
    previous_block_votes_bitvec: {
      type: "array",
      contains: {
        type: "number",
        format: "uint8"
      },
      isRequired: true
    },
    proposer: {
      type: "Address",
      isRequired: true
    },
    failed_proposer_indices: {
      type: "array",
      contains: {
        type: "number",
        format: "uint32"
      },
      isRequired: true
    },
    timestamp: {
      type: "U64",
      isRequired: true
    }
  }
};
var $DecodedTableData = {
  description: `Decoded table data`,
  properties: {
    key: {
      description: `Key of table in JSON`,
      properties: {},
      isRequired: true
    },
    key_type: {
      type: "string",
      description: `Type of key`,
      isRequired: true
    },
    value: {
      description: `Value of table in JSON`,
      properties: {},
      isRequired: true
    },
    value_type: {
      type: "string",
      description: `Type of value`,
      isRequired: true
    }
  }
};
var $DeletedTableData = {
  description: `Deleted table data`,
  properties: {
    key: {
      description: `Deleted key`,
      properties: {},
      isRequired: true
    },
    key_type: {
      type: "string",
      description: `Deleted key type`,
      isRequired: true
    }
  }
};
var $DeleteModule = {
  description: `Delete a module`,
  properties: {
    address: {
      type: "Address",
      isRequired: true
    },
    state_key_hash: {
      type: "string",
      description: `State key hash`,
      isRequired: true
    },
    module: {
      type: "MoveModuleId",
      isRequired: true
    }
  }
};
var $DeleteResource = {
  description: `Delete a resource`,
  properties: {
    address: {
      type: "Address",
      isRequired: true
    },
    state_key_hash: {
      type: "string",
      description: `State key hash`,
      isRequired: true
    },
    resource: {
      type: "MoveStructTag",
      isRequired: true
    }
  }
};
var $DeleteTableItem = {
  description: `Delete a table item`,
  properties: {
    state_key_hash: {
      type: "string",
      isRequired: true
    },
    handle: {
      type: "HexEncodedBytes",
      isRequired: true
    },
    key: {
      type: "HexEncodedBytes",
      isRequired: true
    },
    data: {
      type: "DeletedTableData"
    }
  }
};
var $DirectWriteSet = {
  properties: {
    changes: {
      type: "array",
      contains: {
        type: "WriteSetChange"
      },
      isRequired: true
    },
    events: {
      type: "array",
      contains: {
        type: "Event"
      },
      isRequired: true
    }
  }
};
var $Ed25519Signature = {
  description: `A single Ed25519 signature`,
  properties: {
    public_key: {
      type: "HexEncodedBytes",
      isRequired: true
    },
    signature: {
      type: "HexEncodedBytes",
      isRequired: true
    }
  }
};
var $EncodeSubmissionRequest = {
  description: `Request to encode a submission`,
  properties: {
    sender: {
      type: "Address",
      isRequired: true
    },
    sequence_number: {
      type: "U64",
      isRequired: true
    },
    max_gas_amount: {
      type: "U64",
      isRequired: true
    },
    gas_unit_price: {
      type: "U64",
      isRequired: true
    },
    expiration_timestamp_secs: {
      type: "U64",
      isRequired: true
    },
    payload: {
      type: "TransactionPayload",
      isRequired: true
    },
    secondary_signers: {
      type: "array",
      contains: {
        type: "Address"
      }
    }
  }
};
var $EntryFunctionId = {
  type: "string",
  description: `Entry function id is string representation of a entry function defined on-chain.

    Format: \`{address}::{module name}::{function name}\`

    Both \`module name\` and \`function name\` are case-sensitive.
    `
};
var $EntryFunctionPayload = {
  description: `Payload which runs a single entry function`,
  properties: {
    function: {
      type: "EntryFunctionId",
      isRequired: true
    },
    type_arguments: {
      type: "array",
      contains: {
        type: "MoveType"
      },
      isRequired: true
    },
    arguments: {
      type: "array",
      contains: {
        properties: {}
      },
      isRequired: true
    }
  }
};
var $Event = {
  description: `An event from a transaction`,
  properties: {
    guid: {
      type: "EventGuid",
      isRequired: true
    },
    sequence_number: {
      type: "U64",
      isRequired: true
    },
    type: {
      type: "MoveType",
      isRequired: true
    },
    data: {
      description: `The JSON representation of the event`,
      properties: {},
      isRequired: true
    }
  }
};
var $EventGuid = {
  properties: {
    creation_number: {
      type: "U64",
      isRequired: true
    },
    account_address: {
      type: "Address",
      isRequired: true
    }
  }
};
var $GasEstimation = {
  description: `Struct holding the outputs of the estimate gas API`,
  properties: {
    deprioritized_gas_estimate: {
      type: "number",
      description: `The deprioritized estimate for the gas unit price`,
      format: "uint64"
    },
    gas_estimate: {
      type: "number",
      description: `The current estimate for the gas unit price`,
      isRequired: true,
      format: "uint64"
    },
    prioritized_gas_estimate: {
      type: "number",
      description: `The prioritized estimate for the gas unit price`,
      format: "uint64"
    }
  }
};
var $GenesisPayload = {
  type: "one-of",
  description: `The writeset payload of the Genesis transaction`,
  contains: [{
    type: "GenesisPayload_WriteSetPayload"
  }]
};
var $GenesisPayload_WriteSetPayload = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "WriteSetPayload"
  }]
};
var $GenesisTransaction = {
  description: `The genesis transaction

    This only occurs at the genesis transaction (version 0)`,
  properties: {
    version: {
      type: "U64",
      isRequired: true
    },
    hash: {
      type: "HashValue",
      isRequired: true
    },
    state_change_hash: {
      type: "HashValue",
      isRequired: true
    },
    event_root_hash: {
      type: "HashValue",
      isRequired: true
    },
    state_checkpoint_hash: {
      type: "HashValue"
    },
    gas_used: {
      type: "U64",
      isRequired: true
    },
    success: {
      type: "boolean",
      description: `Whether the transaction was successful`,
      isRequired: true
    },
    vm_status: {
      type: "string",
      description: `The VM status of the transaction, can tell useful information in a failure`,
      isRequired: true
    },
    accumulator_root_hash: {
      type: "HashValue",
      isRequired: true
    },
    changes: {
      type: "array",
      contains: {
        type: "WriteSetChange"
      },
      isRequired: true
    },
    payload: {
      type: "GenesisPayload",
      isRequired: true
    },
    events: {
      type: "array",
      contains: {
        type: "Event"
      },
      isRequired: true
    }
  }
};
var $HashValue = {
  type: "string"
};
var $HealthCheckSuccess = {
  description: `Representation of a successful healthcheck`,
  properties: {
    message: {
      type: "string",
      isRequired: true
    }
  }
};
var $HexEncodedBytes = {
  type: "string",
  description: `All bytes (Vec<u8>) data is represented as hex-encoded string prefixed with \`0x\` and fulfilled with
    two hex digits per byte.

    Unlike the \`Address\` type, HexEncodedBytes will not trim any zeros.
    `,
  format: "hex"
};
var $IdentifierWrapper = {
  type: "string"
};
var $IndexResponse = {
  description: `The struct holding all data returned to the client by the
    index endpoint (i.e., GET "/").  Only for responding in JSON`,
  properties: {
    chain_id: {
      type: "number",
      description: `Chain ID of the current chain`,
      isRequired: true,
      format: "uint8"
    },
    epoch: {
      type: "U64",
      isRequired: true
    },
    ledger_version: {
      type: "U64",
      isRequired: true
    },
    oldest_ledger_version: {
      type: "U64",
      isRequired: true
    },
    ledger_timestamp: {
      type: "U64",
      isRequired: true
    },
    node_role: {
      type: "RoleType",
      isRequired: true
    },
    oldest_block_height: {
      type: "U64",
      isRequired: true
    },
    block_height: {
      type: "U64",
      isRequired: true
    },
    git_hash: {
      type: "string"
    }
  }
};
var $ModuleBundlePayload = {
  properties: {
    modules: {
      type: "array",
      contains: {
        type: "MoveModuleBytecode"
      },
      isRequired: true
    }
  }
};
var $MoveAbility = {
  type: "string"
};
var $MoveFunction = {
  description: `Move function`,
  properties: {
    name: {
      type: "IdentifierWrapper",
      isRequired: true
    },
    visibility: {
      type: "MoveFunctionVisibility",
      isRequired: true
    },
    is_entry: {
      type: "boolean",
      description: `Whether the function can be called as an entry function directly in a transaction`,
      isRequired: true
    },
    generic_type_params: {
      type: "array",
      contains: {
        type: "MoveFunctionGenericTypeParam"
      },
      isRequired: true
    },
    params: {
      type: "array",
      contains: {
        type: "MoveType"
      },
      isRequired: true
    },
    return: {
      type: "array",
      contains: {
        type: "MoveType"
      },
      isRequired: true
    }
  }
};
var $MoveFunctionGenericTypeParam = {
  description: `Move function generic type param`,
  properties: {
    constraints: {
      type: "array",
      contains: {
        type: "MoveAbility"
      },
      isRequired: true
    }
  }
};
var $MoveFunctionVisibility = {
  type: "Enum"
};
var $MoveModule = {
  description: `A Move module`,
  properties: {
    address: {
      type: "Address",
      isRequired: true
    },
    name: {
      type: "IdentifierWrapper",
      isRequired: true
    },
    friends: {
      type: "array",
      contains: {
        type: "MoveModuleId"
      },
      isRequired: true
    },
    exposed_functions: {
      type: "array",
      contains: {
        type: "MoveFunction"
      },
      isRequired: true
    },
    structs: {
      type: "array",
      contains: {
        type: "MoveStruct"
      },
      isRequired: true
    }
  }
};
var $MoveModuleBytecode = {
  description: `Move module bytecode along with it's ABI`,
  properties: {
    bytecode: {
      type: "HexEncodedBytes",
      isRequired: true
    },
    abi: {
      type: "MoveModule"
    }
  }
};
var $MoveModuleId = {
  type: "string",
  description: `Move module id is a string representation of Move module.

    Format: \`{address}::{module name}\`

    \`address\` should be hex-encoded 32 byte account address that is prefixed with \`0x\`.

    Module name is case-sensitive.
    `
};
var $MoveResource = {
  description: `A parsed Move resource`,
  properties: {
    type: {
      type: "MoveStructTag",
      isRequired: true
    },
    data: {
      type: "MoveStructValue",
      isRequired: true
    }
  }
};
var $MoveScriptBytecode = {
  description: `Move script bytecode`,
  properties: {
    bytecode: {
      type: "HexEncodedBytes",
      isRequired: true
    },
    abi: {
      type: "MoveFunction"
    }
  }
};
var $MoveStruct = {
  description: `A move struct`,
  properties: {
    name: {
      type: "IdentifierWrapper",
      isRequired: true
    },
    is_native: {
      type: "boolean",
      description: `Whether the struct is a native struct of Move`,
      isRequired: true
    },
    abilities: {
      type: "array",
      contains: {
        type: "MoveAbility"
      },
      isRequired: true
    },
    generic_type_params: {
      type: "array",
      contains: {
        type: "MoveStructGenericTypeParam"
      },
      isRequired: true
    },
    fields: {
      type: "array",
      contains: {
        type: "MoveStructField"
      },
      isRequired: true
    }
  }
};
var $MoveStructField = {
  description: `Move struct field`,
  properties: {
    name: {
      type: "IdentifierWrapper",
      isRequired: true
    },
    type: {
      type: "MoveType",
      isRequired: true
    }
  }
};
var $MoveStructGenericTypeParam = {
  description: `Move generic type param`,
  properties: {
    constraints: {
      type: "array",
      contains: {
        type: "MoveAbility"
      },
      isRequired: true
    }
  }
};
var $MoveStructTag = {
  type: "string",
  description: `String representation of a MoveStructTag (on-chain Move struct type). This exists so you
    can specify MoveStructTags as path / query parameters, e.g. for get_events_by_event_handle.

    It is a combination of:
    1. \`move_module_address\`, \`module_name\` and \`struct_name\`, all joined by \`::\`
    2. \`struct generic type parameters\` joined by \`, \`

    Examples:
     * \`0x1::coin::CoinStore<0x1::aptos_coin::AptosCoin>\`
     * \`0x1::account::Account\`

    Note:
    1. Empty chars should be ignored when comparing 2 struct tag ids.
    2. When used in an URL path, should be encoded by url-encoding (AKA percent-encoding).

    See [doc](https://aptos.dev/concepts/basics-accounts) for more details.
    `,
  pattern: "^0x[0-9a-zA-Z:_<>]+$"
};
var $MoveStructValue = {
  description: `This is a JSON representation of some data within an account resource. More specifically,
    it is a map of strings to arbitrary JSON values / objects, where the keys are top level
    fields within the given resource.

    To clarify, you might query for 0x1::account::Account and see the example data.

    Move \`bool\` type value is serialized into \`boolean\`.

    Move \`u8\` type value is serialized into \`integer\`.

    Move \`u64\` and \`u128\` type value is serialized into \`string\`.

    Move \`address\` type value (32 byte Aptos account address) is serialized into a HexEncodedBytes string.
    For example:
    - \`0x1\`
    - \`0x1668f6be25668c1a17cd8caf6b8d2f25\`

    Move \`vector\` type value is serialized into \`array\`, except \`vector<u8>\` which is serialized into a
    HexEncodedBytes string with \`0x\` prefix.
    For example:
    - \`vector<u64>{255, 255}\` => \`["255", "255"]\`
    - \`vector<u8>{255, 255}\` => \`0xffff\`

    Move \`struct\` type value is serialized into \`object\` that looks like this (except some Move stdlib types, see the following section):
    \`\`\`json
    {
        field1_name: field1_value,
        field2_name: field2_value,
        ......
    }
    \`\`\`

    For example:
    \`{ "created": "0xa550c18", "role_id": "0" }\`

     **Special serialization for Move stdlib types**:
    - [0x1::string::String](https://github.com/aptos-labs/aptos-core/blob/main/language/move-stdlib/docs/ascii.md)
    is serialized into \`string\`. For example, struct value \`0x1::string::String{bytes: b"Hello World!"}\`
    is serialized as \`"Hello World!"\` in JSON.
    `,
  properties: {}
};
var $MoveType = {
  type: "string",
  description: `String representation of an on-chain Move type tag that is exposed in transaction payload.
    Values:
    - bool
    - u8
    - u64
    - u128
    - address
    - signer
    - vector: \`vector<{non-reference MoveTypeId}>\`
    - struct: \`{address}::{module_name}::{struct_name}::<{generic types}>\`

    Vector type value examples:
    - \`vector<u8>\`
    - \`vector<vector<u64>>\`
    - \`vector<0x1::coin::CoinStore<0x1::aptos_coin::AptosCoin>>\`

    Struct type value examples:
    - \`0x1::coin::CoinStore<0x1::aptos_coin::AptosCoin>
    - \`0x1::account::Account\`

    Note:
    1. Empty chars should be ignored when comparing 2 struct tag ids.
    2. When used in an URL path, should be encoded by url-encoding (AKA percent-encoding).
    `,
  pattern: "^(bool|u8|u64|u128|address|signer|vector<.+>|0x[0-9a-zA-Z:_<, >]+)$"
};
var $MoveValue = {
  type: "any-of",
  description: `An enum of the possible Move value types`,
  contains: [{
    type: "number",
    format: "uint8"
  }, {
    type: "U64"
  }, {
    type: "U128"
  }, {
    type: "boolean"
  }, {
    type: "Address"
  }, {
    type: "array",
    contains: {
      type: "MoveValue"
    }
  }, {
    type: "HexEncodedBytes"
  }, {
    type: "MoveStructValue"
  }, {
    type: "string"
  }]
};
var $MultiAgentSignature = {
  description: `Multi agent signature for multi agent transactions

    This allows you to have transactions across multiple accounts`,
  properties: {
    sender: {
      type: "AccountSignature",
      isRequired: true
    },
    secondary_signer_addresses: {
      type: "array",
      contains: {
        type: "Address"
      },
      isRequired: true
    },
    secondary_signers: {
      type: "array",
      contains: {
        type: "AccountSignature"
      },
      isRequired: true
    }
  }
};
var $MultiEd25519Signature = {
  description: `A Ed25519 multi-sig signature

    This allows k-of-n signing for a transaction`,
  properties: {
    public_keys: {
      type: "array",
      contains: {
        type: "HexEncodedBytes"
      },
      isRequired: true
    },
    signatures: {
      type: "array",
      contains: {
        type: "HexEncodedBytes"
      },
      isRequired: true
    },
    threshold: {
      type: "number",
      description: `The number of signatures required for a successful transaction`,
      isRequired: true,
      format: "uint8"
    },
    bitmap: {
      type: "HexEncodedBytes",
      isRequired: true
    }
  }
};
var $PendingTransaction = {
  description: `A transaction waiting in mempool`,
  properties: {
    hash: {
      type: "HashValue",
      isRequired: true
    },
    sender: {
      type: "Address",
      isRequired: true
    },
    sequence_number: {
      type: "U64",
      isRequired: true
    },
    max_gas_amount: {
      type: "U64",
      isRequired: true
    },
    gas_unit_price: {
      type: "U64",
      isRequired: true
    },
    expiration_timestamp_secs: {
      type: "U64",
      isRequired: true
    },
    payload: {
      type: "TransactionPayload",
      isRequired: true
    },
    signature: {
      type: "TransactionSignature"
    }
  }
};
var $RawTableItemRequest = {
  description: `Table Item request for the GetTableItemRaw API`,
  properties: {
    key: {
      type: "HexEncodedBytes",
      isRequired: true
    }
  }
};
var $RoleType = {
  type: "Enum"
};
var $ScriptPayload = {
  description: `Payload which runs a script that can run multiple functions`,
  properties: {
    code: {
      type: "MoveScriptBytecode",
      isRequired: true
    },
    type_arguments: {
      type: "array",
      contains: {
        type: "MoveType"
      },
      isRequired: true
    },
    arguments: {
      type: "array",
      contains: {
        properties: {}
      },
      isRequired: true
    }
  }
};
var $ScriptWriteSet = {
  properties: {
    execute_as: {
      type: "Address",
      isRequired: true
    },
    script: {
      type: "ScriptPayload",
      isRequired: true
    }
  }
};
var $StateCheckpointTransaction = {
  description: `A state checkpoint transaction`,
  properties: {
    version: {
      type: "U64",
      isRequired: true
    },
    hash: {
      type: "HashValue",
      isRequired: true
    },
    state_change_hash: {
      type: "HashValue",
      isRequired: true
    },
    event_root_hash: {
      type: "HashValue",
      isRequired: true
    },
    state_checkpoint_hash: {
      type: "HashValue"
    },
    gas_used: {
      type: "U64",
      isRequired: true
    },
    success: {
      type: "boolean",
      description: `Whether the transaction was successful`,
      isRequired: true
    },
    vm_status: {
      type: "string",
      description: `The VM status of the transaction, can tell useful information in a failure`,
      isRequired: true
    },
    accumulator_root_hash: {
      type: "HashValue",
      isRequired: true
    },
    changes: {
      type: "array",
      contains: {
        type: "WriteSetChange"
      },
      isRequired: true
    },
    timestamp: {
      type: "U64",
      isRequired: true
    }
  }
};
var $StateKeyWrapper = {
  type: "string",
  description: `Representation of a StateKey as a hex string. This is used for cursor based pagination.
    `
};
var $SubmitTransactionRequest = {
  description: `A request to submit a transaction

    This requires a transaction and a signature of it`,
  properties: {
    sender: {
      type: "Address",
      isRequired: true
    },
    sequence_number: {
      type: "U64",
      isRequired: true
    },
    max_gas_amount: {
      type: "U64",
      isRequired: true
    },
    gas_unit_price: {
      type: "U64",
      isRequired: true
    },
    expiration_timestamp_secs: {
      type: "U64",
      isRequired: true
    },
    payload: {
      type: "TransactionPayload",
      isRequired: true
    },
    signature: {
      type: "TransactionSignature",
      isRequired: true
    }
  }
};
var $TableItemRequest = {
  description: `Table Item request for the GetTableItem API`,
  properties: {
    key_type: {
      type: "MoveType",
      isRequired: true
    },
    value_type: {
      type: "MoveType",
      isRequired: true
    },
    key: {
      description: `The value of the table item's key`,
      properties: {},
      isRequired: true
    }
  }
};
var $Transaction = {
  type: "one-of",
  description: `Enum of the different types of transactions in Aptos`,
  contains: [{
    type: "Transaction_PendingTransaction"
  }, {
    type: "Transaction_UserTransaction"
  }, {
    type: "Transaction_GenesisTransaction"
  }, {
    type: "Transaction_BlockMetadataTransaction"
  }, {
    type: "Transaction_StateCheckpointTransaction"
  }]
};
var $Transaction_BlockMetadataTransaction = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "BlockMetadataTransaction"
  }]
};
var $Transaction_GenesisTransaction = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "GenesisTransaction"
  }]
};
var $Transaction_PendingTransaction = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "PendingTransaction"
  }]
};
var $Transaction_StateCheckpointTransaction = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "StateCheckpointTransaction"
  }]
};
var $Transaction_UserTransaction = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "UserTransaction"
  }]
};
var $TransactionPayload = {
  type: "one-of",
  description: `An enum of the possible transaction payloads`,
  contains: [{
    type: "TransactionPayload_EntryFunctionPayload"
  }, {
    type: "TransactionPayload_ScriptPayload"
  }, {
    type: "TransactionPayload_ModuleBundlePayload"
  }]
};
var $TransactionPayload_EntryFunctionPayload = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "EntryFunctionPayload"
  }]
};
var $TransactionPayload_ModuleBundlePayload = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "ModuleBundlePayload"
  }]
};
var $TransactionPayload_ScriptPayload = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "ScriptPayload"
  }]
};
var $TransactionsBatchSingleSubmissionFailure = {
  description: `Information telling which batch submission transactions failed`,
  properties: {
    error: {
      type: "AptosError",
      isRequired: true
    },
    transaction_index: {
      type: "number",
      description: `The index of which transaction failed, same as submission order`,
      isRequired: true,
      format: "uint64"
    }
  }
};
var $TransactionsBatchSubmissionResult = {
  description: `Batch transaction submission result

    Tells which transactions failed`,
  properties: {
    transaction_failures: {
      type: "array",
      contains: {
        type: "TransactionsBatchSingleSubmissionFailure"
      },
      isRequired: true
    }
  }
};
var $TransactionSignature = {
  type: "one-of",
  description: `An enum representing the different transaction signatures available`,
  contains: [{
    type: "TransactionSignature_Ed25519Signature"
  }, {
    type: "TransactionSignature_MultiEd25519Signature"
  }, {
    type: "TransactionSignature_MultiAgentSignature"
  }]
};
var $TransactionSignature_Ed25519Signature = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "Ed25519Signature"
  }]
};
var $TransactionSignature_MultiAgentSignature = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "MultiAgentSignature"
  }]
};
var $TransactionSignature_MultiEd25519Signature = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "MultiEd25519Signature"
  }]
};
var $U128 = {
  type: "string",
  description: `A string containing a 128-bit unsigned integer.

    We represent u128 values as a string to ensure compatibility with languages such
    as JavaScript that do not parse u64s in JSON natively.
    `,
  format: "uint64"
};
var $U64 = {
  type: "string",
  description: `A string containing a 64-bit unsigned integer.

    We represent u64 values as a string to ensure compatibility with languages such
    as JavaScript that do not parse u64s in JSON natively.
    `,
  format: "uint64"
};
var $UserTransaction = {
  description: `A transaction submitted by a user to change the state of the blockchain`,
  properties: {
    version: {
      type: "U64",
      isRequired: true
    },
    hash: {
      type: "HashValue",
      isRequired: true
    },
    state_change_hash: {
      type: "HashValue",
      isRequired: true
    },
    event_root_hash: {
      type: "HashValue",
      isRequired: true
    },
    state_checkpoint_hash: {
      type: "HashValue"
    },
    gas_used: {
      type: "U64",
      isRequired: true
    },
    success: {
      type: "boolean",
      description: `Whether the transaction was successful`,
      isRequired: true
    },
    vm_status: {
      type: "string",
      description: `The VM status of the transaction, can tell useful information in a failure`,
      isRequired: true
    },
    accumulator_root_hash: {
      type: "HashValue",
      isRequired: true
    },
    changes: {
      type: "array",
      contains: {
        type: "WriteSetChange"
      },
      isRequired: true
    },
    sender: {
      type: "Address",
      isRequired: true
    },
    sequence_number: {
      type: "U64",
      isRequired: true
    },
    max_gas_amount: {
      type: "U64",
      isRequired: true
    },
    gas_unit_price: {
      type: "U64",
      isRequired: true
    },
    expiration_timestamp_secs: {
      type: "U64",
      isRequired: true
    },
    payload: {
      type: "TransactionPayload",
      isRequired: true
    },
    signature: {
      type: "TransactionSignature"
    },
    events: {
      type: "array",
      contains: {
        type: "Event"
      },
      isRequired: true
    },
    timestamp: {
      type: "U64",
      isRequired: true
    }
  }
};
var $VersionedEvent = {
  description: `An event from a transaction with a version`,
  properties: {
    version: {
      type: "U64",
      isRequired: true
    },
    guid: {
      type: "EventGuid",
      isRequired: true
    },
    sequence_number: {
      type: "U64",
      isRequired: true
    },
    type: {
      type: "MoveType",
      isRequired: true
    },
    data: {
      description: `The JSON representation of the event`,
      properties: {},
      isRequired: true
    }
  }
};
var $WriteModule = {
  description: `Write a new module or update an existing one`,
  properties: {
    address: {
      type: "Address",
      isRequired: true
    },
    state_key_hash: {
      type: "string",
      description: `State key hash`,
      isRequired: true
    },
    data: {
      type: "MoveModuleBytecode",
      isRequired: true
    }
  }
};
var $WriteResource = {
  description: `Write a resource or update an existing one`,
  properties: {
    address: {
      type: "Address",
      isRequired: true
    },
    state_key_hash: {
      type: "string",
      description: `State key hash`,
      isRequired: true
    },
    data: {
      type: "MoveResource",
      isRequired: true
    }
  }
};
var $WriteSet = {
  type: "one-of",
  description: `The associated writeset with a payload`,
  contains: [{
    type: "WriteSet_ScriptWriteSet"
  }, {
    type: "WriteSet_DirectWriteSet"
  }]
};
var $WriteSet_DirectWriteSet = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "DirectWriteSet"
  }]
};
var $WriteSet_ScriptWriteSet = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "ScriptWriteSet"
  }]
};
var $WriteSetChange = {
  type: "one-of",
  description: `A final state change of a transaction on a resource or module`,
  contains: [{
    type: "WriteSetChange_DeleteModule"
  }, {
    type: "WriteSetChange_DeleteResource"
  }, {
    type: "WriteSetChange_DeleteTableItem"
  }, {
    type: "WriteSetChange_WriteModule"
  }, {
    type: "WriteSetChange_WriteResource"
  }, {
    type: "WriteSetChange_WriteTableItem"
  }]
};
var $WriteSetChange_DeleteModule = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "DeleteModule"
  }]
};
var $WriteSetChange_DeleteResource = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "DeleteResource"
  }]
};
var $WriteSetChange_DeleteTableItem = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "DeleteTableItem"
  }]
};
var $WriteSetChange_WriteModule = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "WriteModule"
  }]
};
var $WriteSetChange_WriteResource = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "WriteResource"
  }]
};
var $WriteSetChange_WriteTableItem = {
  type: "all-of",
  contains: [{
    properties: {
      type: {
        type: "string",
        isRequired: true
      }
    }
  }, {
    type: "WriteTableItem"
  }]
};
var $WriteSetPayload = {
  description: `A writeset payload, used only for genesis`,
  properties: {
    write_set: {
      type: "WriteSet",
      isRequired: true
    }
  }
};
var $WriteTableItem = {
  description: `Change set to write a table item`,
  properties: {
    state_key_hash: {
      type: "string",
      isRequired: true
    },
    handle: {
      type: "HexEncodedBytes",
      isRequired: true
    },
    key: {
      type: "HexEncodedBytes",
      isRequired: true
    },
    value: {
      type: "HexEncodedBytes",
      isRequired: true
    },
    data: {
      type: "DecodedTableData"
    }
  }
};
function assertType(val, types, message) {
  if (!(types == null ? void 0 : types.includes(typeof val))) {
    throw new Error(
      message || `Invalid arg: ${val} type should be ${types instanceof Array ? types.join(" or ") : types}`
    );
  }
}
function bail(message) {
  throw new Error(message);
}
function isWhiteSpace(c) {
  if (c.match(/\s/)) {
    return true;
  }
  return false;
}
function isValidAlphabetic(c) {
  if (c.match(/[_A-Za-z0-9]/g)) {
    return true;
  }
  return false;
}
function nextToken(tagStr, pos) {
  const c = tagStr[pos];
  if (c === ":") {
    if (tagStr.slice(pos, pos + 2) === "::") {
      return [["COLON", "::"], 2];
    }
    bail("Unrecognized token.");
  } else if (c === "<") {
    return [["LT", "<"], 1];
  } else if (c === ">") {
    return [["GT", ">"], 1];
  } else if (c === ",") {
    return [["COMMA", ","], 1];
  } else if (isWhiteSpace(c)) {
    let res = "";
    for (let i = pos; i < tagStr.length; i += 1) {
      const char = tagStr[i];
      if (isWhiteSpace(char)) {
        res = `${res}${char}`;
      } else {
        break;
      }
    }
    return [["SPACE", res], res.length];
  } else if (isValidAlphabetic(c)) {
    let res = "";
    for (let i = pos; i < tagStr.length; i += 1) {
      const char = tagStr[i];
      if (isValidAlphabetic(char)) {
        res = `${res}${char}`;
      } else {
        break;
      }
    }
    return [["IDENT", res], res.length];
  }
  throw new Error("Unrecognized token.");
}
function tokenize(tagStr) {
  let pos = 0;
  const tokens = [];
  while (pos < tagStr.length) {
    const [token, size] = nextToken(tagStr, pos);
    if (token[0] !== "SPACE") {
      tokens.push(token);
    }
    pos += size;
  }
  return tokens;
}
var TypeTagParser = class {
  constructor(tagStr) {
    this.tokens = tokenize(tagStr);
  }
  consume(targetToken) {
    const token = this.tokens.shift();
    if (!token || token[1] !== targetToken) {
      bail("Invalid type tag.");
    }
  }
  parseCommaList(endToken, allowTraillingComma) {
    const res = [];
    if (this.tokens.length <= 0) {
      bail("Invalid type tag.");
    }
    while (this.tokens[0][1] !== endToken) {
      res.push(this.parseTypeTag());
      if (this.tokens.length > 0 && this.tokens[0][1] === endToken) {
        break;
      }
      this.consume(",");
      if (this.tokens.length > 0 && this.tokens[0][1] === endToken && allowTraillingComma) {
        break;
      }
      if (this.tokens.length <= 0) {
        bail("Invalid type tag.");
      }
    }
    return res;
  }
  parseTypeTag() {
    if (this.tokens.length === 0) {
      bail("Invalid type tag.");
    }
    const [tokenTy, tokenVal] = this.tokens.shift();
    if (tokenVal === "u8") {
      return new TypeTagU8();
    }
    if (tokenVal === "u64") {
      return new TypeTagU64();
    }
    if (tokenVal === "u128") {
      return new TypeTagU128();
    }
    if (tokenVal === "bool") {
      return new TypeTagBool();
    }
    if (tokenVal === "address") {
      return new TypeTagAddress();
    }
    if (tokenVal === "vector") {
      this.consume("<");
      const res = this.parseTypeTag();
      this.consume(">");
      return new TypeTagVector(res);
    }
    if (tokenTy === "IDENT" && (tokenVal.startsWith("0x") || tokenVal.startsWith("0X"))) {
      const address = tokenVal;
      this.consume("::");
      const [moduleTokenTy, module] = this.tokens.shift();
      if (moduleTokenTy !== "IDENT") {
        bail("Invalid type tag.");
      }
      this.consume("::");
      const [nameTokenTy, name] = this.tokens.shift();
      if (nameTokenTy !== "IDENT") {
        bail("Invalid type tag.");
      }
      let tyTags = [];
      if (this.tokens.length > 0 && this.tokens[0][1] === "<") {
        this.consume("<");
        tyTags = this.parseCommaList(">", true);
        this.consume(">");
      }
      const structTag = new StructTag(
        AccountAddress.fromHex(address),
        new Identifier(module),
        new Identifier(name),
        tyTags
      );
      return new TypeTagStruct(structTag);
    }
    throw new Error("Invalid type tag.");
  }
};
function ensureBoolean(val) {
  assertType(val, ["boolean", "string"]);
  if (typeof val === "boolean") {
    return val;
  }
  if (val === "true") {
    return true;
  }
  if (val === "false") {
    return false;
  }
  throw new Error("Invalid boolean string.");
}
function ensureNumber(val) {
  assertType(val, ["number", "string"]);
  if (typeof val === "number") {
    return val;
  }
  const res = Number.parseInt(val, 10);
  if (Number.isNaN(res)) {
    throw new Error("Invalid number string.");
  }
  return res;
}
function ensureBigInt(val) {
  assertType(val, ["number", "bigint", "string"]);
  return BigInt(val);
}
function serializeArg(argVal, argType, serializer) {
  if (argType instanceof TypeTagBool) {
    serializer.serializeBool(ensureBoolean(argVal));
    return;
  }
  if (argType instanceof TypeTagU8) {
    serializer.serializeU8(ensureNumber(argVal));
    return;
  }
  if (argType instanceof TypeTagU64) {
    serializer.serializeU64(ensureBigInt(argVal));
    return;
  }
  if (argType instanceof TypeTagU128) {
    serializer.serializeU128(ensureBigInt(argVal));
    return;
  }
  if (argType instanceof TypeTagAddress) {
    let addr;
    if (typeof argVal === "string" || argVal instanceof HexString) {
      addr = AccountAddress.fromHex(argVal);
    } else if (argVal instanceof AccountAddress) {
      addr = argVal;
    } else {
      throw new Error("Invalid account address.");
    }
    addr.serialize(serializer);
    return;
  }
  if (argType instanceof TypeTagVector) {
    if (argType.value instanceof TypeTagU8) {
      if (argVal instanceof Uint8Array) {
        serializer.serializeBytes(argVal);
        return;
      }
      if (typeof argVal === "string") {
        serializer.serializeStr(argVal);
        return;
      }
    }
    if (!(argVal instanceof Array)) {
      throw new Error("Invalid vector args.");
    }
    serializer.serializeU32AsUleb128(argVal.length);
    argVal.forEach((arg) => serializeArg(arg, argType.value, serializer));
    return;
  }
  if (argType instanceof TypeTagStruct) {
    const { address, module_name: moduleName, name } = argType.value;
    if (`${HexString.fromUint8Array(address.address).toShortString()}::${moduleName.value}::${name.value}` !== "0x1::string::String") {
      throw new Error("The only supported struct arg is of type 0x1::string::String");
    }
    assertType(argVal, ["string"]);
    serializer.serializeStr(argVal);
    return;
  }
  throw new Error("Unsupported arg type.");
}
function argToTransactionArgument(argVal, argType) {
  if (argType instanceof TypeTagBool) {
    return new TransactionArgumentBool(ensureBoolean(argVal));
  }
  if (argType instanceof TypeTagU8) {
    return new TransactionArgumentU8(ensureNumber(argVal));
  }
  if (argType instanceof TypeTagU64) {
    return new TransactionArgumentU64(ensureBigInt(argVal));
  }
  if (argType instanceof TypeTagU128) {
    return new TransactionArgumentU128(ensureBigInt(argVal));
  }
  if (argType instanceof TypeTagAddress) {
    let addr;
    if (typeof argVal === "string" || argVal instanceof HexString) {
      addr = AccountAddress.fromHex(argVal);
    } else if (argVal instanceof AccountAddress) {
      addr = argVal;
    } else {
      throw new Error("Invalid account address.");
    }
    return new TransactionArgumentAddress(addr);
  }
  if (argType instanceof TypeTagVector && argType.value instanceof TypeTagU8) {
    if (!(argVal instanceof Uint8Array)) {
      throw new Error(`${argVal} should be an instance of Uint8Array`);
    }
    return new TransactionArgumentU8Vector(argVal);
  }
  throw new Error("Unknown type for TransactionArgument.");
}
var RAW_TRANSACTION_SALT = "APTOS::RawTransaction";
var RAW_TRANSACTION_WITH_DATA_SALT = "APTOS::RawTransactionWithData";
var TransactionBuilder = class {
  constructor(signingFunction, rawTxnBuilder) {
    this.rawTxnBuilder = rawTxnBuilder;
    this.signingFunction = signingFunction;
  }
  build(func, ty_tags, args) {
    if (!this.rawTxnBuilder) {
      throw new Error("this.rawTxnBuilder doesn't exist.");
    }
    return this.rawTxnBuilder.build(func, ty_tags, args);
  }
  static getSigningMessage(rawTxn) {
    const hash2 = sha3_256.create();
    if (rawTxn instanceof RawTransaction) {
      hash2.update(RAW_TRANSACTION_SALT);
    } else if (rawTxn instanceof MultiAgentRawTransaction) {
      hash2.update(RAW_TRANSACTION_WITH_DATA_SALT);
    } else {
      throw new Error("Unknown transaction type.");
    }
    const prefix = hash2.digest();
    const body = bcsToBytes(rawTxn);
    const mergedArray = new Uint8Array(prefix.length + body.length);
    mergedArray.set(prefix);
    mergedArray.set(body, prefix.length);
    return mergedArray;
  }
};
var TransactionBuilderEd25519 = class extends TransactionBuilder {
  constructor(signingFunction, publicKey, rawTxnBuilder) {
    super(signingFunction, rawTxnBuilder);
    this.publicKey = publicKey;
  }
  rawToSigned(rawTxn) {
    const signingMessage = TransactionBuilder.getSigningMessage(rawTxn);
    const signature = this.signingFunction(signingMessage);
    const authenticator = new TransactionAuthenticatorEd25519(
      new Ed25519PublicKey(this.publicKey),
      signature
    );
    return new SignedTransaction(rawTxn, authenticator);
  }
  sign(rawTxn) {
    return bcsToBytes(this.rawToSigned(rawTxn));
  }
};
var TransactionBuilderMultiEd25519 = class extends TransactionBuilder {
  constructor(signingFunction, publicKey) {
    super(signingFunction);
    this.publicKey = publicKey;
  }
  rawToSigned(rawTxn) {
    const signingMessage = TransactionBuilder.getSigningMessage(rawTxn);
    const signature = this.signingFunction(signingMessage);
    const authenticator = new TransactionAuthenticatorMultiEd25519(this.publicKey, signature);
    return new SignedTransaction(rawTxn, authenticator);
  }
  sign(rawTxn) {
    return bcsToBytes(this.rawToSigned(rawTxn));
  }
};
var TransactionBuilderABI = class {
  constructor(abis, builderConfig) {
    this.abiMap = /* @__PURE__ */ new Map();
    abis.forEach((abi) => {
      const deserializer = new Deserializer(abi);
      const scriptABI = ScriptABI.deserialize(deserializer);
      let k;
      if (scriptABI instanceof EntryFunctionABI) {
        const funcABI = scriptABI;
        const { address: addr, name: moduleName } = funcABI.module_name;
        k = `${HexString.fromUint8Array(addr.address).toShortString()}::${moduleName.value}::${funcABI.name}`;
      } else {
        const funcABI = scriptABI;
        k = funcABI.name;
      }
      if (this.abiMap.has(k)) {
        throw new Error("Found conflicting ABI interfaces");
      }
      this.abiMap.set(k, scriptABI);
    });
    this.builderConfig = {
      maxGasAmount: BigInt(DEFAULT_MAX_GAS_AMOUNT),
      expSecFromNow: DEFAULT_TXN_EXP_SEC_FROM_NOW,
      ...builderConfig
    };
  }
  static toBCSArgs(abiArgs, args) {
    if (abiArgs.length !== args.length) {
      throw new Error("Wrong number of args provided.");
    }
    return args.map((arg, i) => {
      const serializer = new Serializer();
      serializeArg(arg, abiArgs[i].type_tag, serializer);
      return serializer.getBytes();
    });
  }
  static toTransactionArguments(abiArgs, args) {
    if (abiArgs.length !== args.length) {
      throw new Error("Wrong number of args provided.");
    }
    return args.map((arg, i) => argToTransactionArgument(arg, abiArgs[i].type_tag));
  }
  setSequenceNumber(seqNumber) {
    this.builderConfig.sequenceNumber = BigInt(seqNumber);
  }
  buildTransactionPayload(func, ty_tags, args) {
    const typeTags = ty_tags.map((ty_arg) => new TypeTagParser(ty_arg).parseTypeTag());
    let payload;
    if (!this.abiMap.has(func)) {
      throw new Error(`Cannot find function: ${func}`);
    }
    const scriptABI = this.abiMap.get(func);
    if (scriptABI instanceof EntryFunctionABI) {
      const funcABI = scriptABI;
      const bcsArgs = TransactionBuilderABI.toBCSArgs(funcABI.args, args);
      payload = new TransactionPayloadEntryFunction(
        new EntryFunction(funcABI.module_name, new Identifier(funcABI.name), typeTags, bcsArgs)
      );
    } else if (scriptABI instanceof TransactionScriptABI) {
      const funcABI = scriptABI;
      const scriptArgs = TransactionBuilderABI.toTransactionArguments(funcABI.args, args);
      payload = new TransactionPayloadScript(new Script(funcABI.code, typeTags, scriptArgs));
    } else {
      throw new Error("Unknown ABI format.");
    }
    return payload;
  }
  build(func, ty_tags, args) {
    const { sender, sequenceNumber, gasUnitPrice, maxGasAmount, expSecFromNow, chainId } = this.builderConfig;
    if (!gasUnitPrice) {
      throw new Error("No gasUnitPrice provided.");
    }
    const senderAccount = sender instanceof AccountAddress ? sender : AccountAddress.fromHex(sender);
    const expTimestampSec = BigInt(Math.floor(Date.now() / 1e3) + Number(expSecFromNow));
    const payload = this.buildTransactionPayload(func, ty_tags, args);
    if (payload) {
      return new RawTransaction(
        senderAccount,
        BigInt(sequenceNumber),
        payload,
        BigInt(maxGasAmount),
        BigInt(gasUnitPrice),
        expTimestampSec,
        new ChainId(Number(chainId))
      );
    }
    throw new Error("Invalid ABI.");
  }
};
var TransactionBuilderRemoteABI = class {
  constructor(aptosClient, builderConfig) {
    this.aptosClient = aptosClient;
    this.builderConfig = builderConfig;
  }
  async fetchABI(addr) {
    const modules = await this.aptosClient.getAccountModules(addr);
    const abis = modules.map((module) => module.abi).flatMap(
      (abi) => abi.exposed_functions.filter((ef) => ef.is_entry).map(
        (ef) => ({
          fullName: `${abi.address}::${abi.name}::${ef.name}`,
          ...ef
        })
      )
    );
    const abiMap = /* @__PURE__ */ new Map();
    abis.forEach((abi) => {
      abiMap.set(abi.fullName, abi);
    });
    return abiMap;
  }
  async build(func, ty_tags, args) {
    const normlize = (s) => s.replace(/^0[xX]0*/g, "0x");
    func = normlize(func);
    const funcNameParts = func.split("::");
    if (funcNameParts.length !== 3) {
      throw new Error(
        "'func' needs to be a fully qualified function name in format <address>::<module>::<function>, e.g. 0x1::coins::transfer"
      );
    }
    const [addr, module] = func.split("::");
    const abiMap = await this.fetchABI(addr);
    if (!abiMap.has(func)) {
      throw new Error(`${func} doesn't exist.`);
    }
    const funcAbi = abiMap.get(func);
    const originalArgs = funcAbi.params.filter((param) => param !== "signer" && param !== "&signer");
    const typeArgABIs = originalArgs.map((arg, i) => new ArgumentABI(`var${i}`, new TypeTagParser(arg).parseTypeTag()));
    const entryFunctionABI = new EntryFunctionABI(
      funcAbi.name,
      ModuleId.fromStr(`${addr}::${module}`),
      "",
      funcAbi.generic_type_params.map((_, i) => new TypeArgumentABI(`${i}`)),
      typeArgABIs
    );
    const { sender, ...rest } = this.builderConfig;
    const senderAddress = sender instanceof AccountAddress ? HexString.fromUint8Array(sender.address) : sender;
    const [{ sequence_number: sequenceNumber }, chainId, { gas_estimate: gasUnitPrice }] = await Promise.all([
      (rest == null ? void 0 : rest.sequenceNumber) ? Promise.resolve({ sequence_number: rest == null ? void 0 : rest.sequenceNumber }) : this.aptosClient.getAccount(senderAddress),
      (rest == null ? void 0 : rest.chainId) ? Promise.resolve(rest == null ? void 0 : rest.chainId) : this.aptosClient.getChainId(),
      (rest == null ? void 0 : rest.gasUnitPrice) ? Promise.resolve({ gas_estimate: rest == null ? void 0 : rest.gasUnitPrice }) : this.aptosClient.estimateGasPrice()
    ]);
    const builderABI = new TransactionBuilderABI([bcsToBytes(entryFunctionABI)], {
      sender,
      sequenceNumber,
      chainId,
      gasUnitPrice: BigInt(gasUnitPrice),
      ...rest
    });
    return builderABI.build(func, ty_tags, args);
  }
};
__decorateClass([
  MemoizeExpiring(10 * 60 * 1e3)
], TransactionBuilderRemoteABI.prototype, "fetchABI", 1);
var _AptosClient = class {
  constructor(nodeUrl, config, doNotFixNodeUrl = false) {
    if (!nodeUrl) {
      throw new Error("Node URL cannot be empty.");
    }
    const conf = config === void 0 || config === null ? {} : { ...config };
    if (doNotFixNodeUrl) {
      this.nodeUrl = nodeUrl;
    } else {
      this.nodeUrl = fixNodeUrl(nodeUrl);
    }
    conf.BASE = this.nodeUrl;
    if ((config == null ? void 0 : config.WITH_CREDENTIALS) === false) {
      conf.WITH_CREDENTIALS = false;
    } else {
      conf.WITH_CREDENTIALS = true;
    }
    this.client = new AptosGeneratedClient(conf);
  }
  async getAccount(accountAddress) {
    return this.client.accounts.getAccount(HexString.ensure(accountAddress).hex());
  }
  async getAccountTransactions(accountAddress, query) {
    var _a;
    return this.client.transactions.getAccountTransactions(
      HexString.ensure(accountAddress).hex(),
      (_a = query == null ? void 0 : query.start) == null ? void 0 : _a.toString(),
      query == null ? void 0 : query.limit
    );
  }
  async getAccountModules(accountAddress, query) {
    const f = this.client.accounts.getAccountModules.bind({ httpRequest: this.client.request });
    const out = await paginateWithCursor(f, accountAddress, 100, query);
    return out;
  }
  async getAccountModule(accountAddress, moduleName, query) {
    var _a;
    return this.client.accounts.getAccountModule(
      HexString.ensure(accountAddress).hex(),
      moduleName,
      (_a = query == null ? void 0 : query.ledgerVersion) == null ? void 0 : _a.toString()
    );
  }
  async getAccountResources(accountAddress, query) {
    const f = this.client.accounts.getAccountResources.bind({ httpRequest: this.client.request });
    const out = await paginateWithCursor(f, accountAddress, 1e3, query);
    return out;
  }
  async getAccountResource(accountAddress, resourceType, query) {
    var _a;
    return this.client.accounts.getAccountResource(
      HexString.ensure(accountAddress).hex(),
      resourceType,
      (_a = query == null ? void 0 : query.ledgerVersion) == null ? void 0 : _a.toString()
    );
  }
  static generateBCSTransaction(accountFrom, rawTxn) {
    const txnBuilder = new TransactionBuilderEd25519((signingMessage) => {
      const sigHexStr = accountFrom.signBuffer(signingMessage);
      return new aptos_types_exports.Ed25519Signature(sigHexStr.toUint8Array());
    }, accountFrom.pubKey().toUint8Array());
    return txnBuilder.sign(rawTxn);
  }
  static generateBCSSimulation(accountFrom, rawTxn) {
    const txnBuilder = new TransactionBuilderEd25519((_signingMessage) => {
      const invalidSigBytes = new Uint8Array(64);
      return new aptos_types_exports.Ed25519Signature(invalidSigBytes);
    }, accountFrom.pubKey().toUint8Array());
    return txnBuilder.sign(rawTxn);
  }
  async generateTransaction(sender, payload, options) {
    const config = { sender };
    if (options == null ? void 0 : options.sequence_number) {
      config.sequenceNumber = options.sequence_number;
    }
    if (options == null ? void 0 : options.gas_unit_price) {
      config.gasUnitPrice = options.gas_unit_price;
    }
    if (options == null ? void 0 : options.max_gas_amount) {
      config.maxGasAmount = options.max_gas_amount;
    }
    if (options == null ? void 0 : options.expiration_timestamp_secs) {
      const timestamp = Number.parseInt(options.expiration_timestamp_secs, 10);
      config.expSecFromNow = timestamp - Math.floor(Date.now() / 1e3);
    }
    const builder = new TransactionBuilderRemoteABI(this, config);
    return builder.build(payload.function, payload.type_arguments, payload.arguments);
  }
  async signTransaction(accountFrom, rawTransaction) {
    return Promise.resolve(_AptosClient.generateBCSTransaction(accountFrom, rawTransaction));
  }
  async getEventsByCreationNumber(address, creationNumber, query) {
    var _a;
    return this.client.events.getEventsByCreationNumber(
      HexString.ensure(address).hex(),
      creationNumber.toString(),
      (_a = query == null ? void 0 : query.start) == null ? void 0 : _a.toString(),
      query == null ? void 0 : query.limit
    );
  }
  async getEventsByEventHandle(address, eventHandleStruct, fieldName, query) {
    var _a;
    return this.client.events.getEventsByEventHandle(
      HexString.ensure(address).hex(),
      eventHandleStruct,
      fieldName,
      (_a = query == null ? void 0 : query.start) == null ? void 0 : _a.toString(),
      query == null ? void 0 : query.limit
    );
  }
  async submitTransaction(signedTxn) {
    return this.submitSignedBCSTransaction(signedTxn);
  }
  async simulateTransaction(accountOrPubkey, rawTransaction, query) {
    let signedTxn;
    if (accountOrPubkey instanceof AptosAccount) {
      signedTxn = _AptosClient.generateBCSSimulation(accountOrPubkey, rawTransaction);
    } else if (accountOrPubkey instanceof MultiEd25519PublicKey) {
      const txnBuilder = new TransactionBuilderMultiEd25519(() => {
        const { threshold } = accountOrPubkey;
        const bits = [];
        const signatures = [];
        for (let i = 0; i < threshold; i += 1) {
          bits.push(i);
          signatures.push(new aptos_types_exports.Ed25519Signature(new Uint8Array(64)));
        }
        const bitmap = aptos_types_exports.MultiEd25519Signature.createBitmap(bits);
        return new aptos_types_exports.MultiEd25519Signature(signatures, bitmap);
      }, accountOrPubkey);
      signedTxn = txnBuilder.sign(rawTransaction);
    } else {
      const txnBuilder = new TransactionBuilderEd25519(() => {
        const invalidSigBytes = new Uint8Array(64);
        return new aptos_types_exports.Ed25519Signature(invalidSigBytes);
      }, accountOrPubkey.toBytes());
      signedTxn = txnBuilder.sign(rawTransaction);
    }
    return this.submitBCSSimulation(signedTxn, query);
  }
  async submitSignedBCSTransaction(signedTxn) {
    return this.client.request.request({
      url: "/transactions",
      method: "POST",
      body: signedTxn,
      mediaType: "application/x.aptos.signed_transaction+bcs"
    });
  }
  async submitBCSSimulation(bcsBody, query) {
    var _a, _b, _c;
    const queryParams = {
      estimate_gas_unit_price: (_a = query == null ? void 0 : query.estimateGasUnitPrice) != null ? _a : false,
      estimate_max_gas_amount: (_b = query == null ? void 0 : query.estimateMaxGasAmount) != null ? _b : false,
      estimate_prioritized_gas_unit_price: (_c = query == null ? void 0 : query.estimatePrioritizedGasUnitPrice) != null ? _c : false
    };
    return this.client.request.request({
      url: "/transactions/simulate",
      query: queryParams,
      method: "POST",
      body: bcsBody,
      mediaType: "application/x.aptos.signed_transaction+bcs"
    });
  }
  async getTransactions(query) {
    var _a;
    return this.client.transactions.getTransactions((_a = query == null ? void 0 : query.start) == null ? void 0 : _a.toString(), query == null ? void 0 : query.limit);
  }
  async getTransactionByHash(txnHash) {
    return this.client.transactions.getTransactionByHash(txnHash);
  }
  async getTransactionByVersion(txnVersion) {
    return this.client.transactions.getTransactionByVersion(txnVersion.toString());
  }
  async transactionPending(txnHash) {
    try {
      const response = await this.client.transactions.getTransactionByHash(txnHash);
      return response.type === "pending_transaction";
    } catch (e) {
      if ((e == null ? void 0 : e.status) === 404) {
        return true;
      }
      throw e;
    }
  }
  async waitForTransactionWithResult(txnHash, extraArgs) {
    var _a, _b;
    const timeoutSecs = (_a = extraArgs == null ? void 0 : extraArgs.timeoutSecs) != null ? _a : DEFAULT_TXN_TIMEOUT_SEC;
    const checkSuccess = (_b = extraArgs == null ? void 0 : extraArgs.checkSuccess) != null ? _b : false;
    let isPending = true;
    let count = 0;
    let lastTxn;
    while (isPending) {
      if (count >= timeoutSecs) {
        break;
      }
      try {
        lastTxn = await this.client.transactions.getTransactionByHash(txnHash);
        isPending = lastTxn.type === "pending_transaction";
        if (!isPending) {
          break;
        }
      } catch (e) {
        const isApiError = e instanceof ApiError;
        const isRequestError = isApiError && e.status !== 404 && e.status >= 400 && e.status < 500;
        if (!isApiError || isRequestError) {
          throw e;
        }
      }
      await sleep(1e3);
      count += 1;
    }
    if (lastTxn === void 0) {
      throw new Error(`Waiting for transaction ${txnHash} failed`);
    }
    if (isPending) {
      throw new WaitForTransactionError(
        `Waiting for transaction ${txnHash} timed out after ${timeoutSecs} seconds`,
        lastTxn
      );
    }
    if (!checkSuccess) {
      return lastTxn;
    }
    if (!(lastTxn == null ? void 0 : lastTxn.success)) {
      throw new FailedTransactionError(
        `Transaction ${txnHash} committed to the blockchain but execution failed`,
        lastTxn
      );
    }
    return lastTxn;
  }
  async waitForTransaction(txnHash, extraArgs) {
    await this.waitForTransactionWithResult(txnHash, extraArgs);
  }
  async getLedgerInfo() {
    return this.client.general.getLedgerInfo();
  }
  async getChainId() {
    const result = await this.getLedgerInfo();
    return result.chain_id;
  }
  async getTableItem(handle, data2, query) {
    var _a;
    const tableItem = await this.client.tables.getTableItem(handle, data2, (_a = query == null ? void 0 : query.ledgerVersion) == null ? void 0 : _a.toString());
    return tableItem;
  }
  async generateRawTransaction(accountFrom, payload, extraArgs) {
    const [{ sequence_number: sequenceNumber }, chainId, { gas_estimate: gasEstimate }] = await Promise.all([
      this.getAccount(accountFrom),
      this.getChainId(),
      (extraArgs == null ? void 0 : extraArgs.gasUnitPrice) ? Promise.resolve({ gas_estimate: extraArgs.gasUnitPrice }) : this.estimateGasPrice()
    ]);
    const { maxGasAmount, gasUnitPrice, expireTimestamp } = {
      maxGasAmount: BigInt(DEFAULT_MAX_GAS_AMOUNT),
      gasUnitPrice: BigInt(gasEstimate),
      expireTimestamp: BigInt(Math.floor(Date.now() / 1e3) + DEFAULT_TXN_EXP_SEC_FROM_NOW),
      ...extraArgs
    };
    return new aptos_types_exports.RawTransaction(
      aptos_types_exports.AccountAddress.fromHex(accountFrom),
      BigInt(sequenceNumber),
      payload,
      maxGasAmount,
      gasUnitPrice,
      expireTimestamp,
      new aptos_types_exports.ChainId(chainId)
    );
  }
  async generateSignSubmitTransaction(sender, payload, extraArgs) {
    const rawTransaction = await this.generateRawTransaction(sender.address(), payload, extraArgs);
    const bcsTxn = _AptosClient.generateBCSTransaction(sender, rawTransaction);
    const pendingTransaction = await this.submitSignedBCSTransaction(bcsTxn);
    return pendingTransaction.hash;
  }
  async publishPackage(sender, packageMetadata, modules, extraArgs) {
    const codeSerializer = new Serializer();
    serializeVector(modules, codeSerializer);
    const payload = new aptos_types_exports.TransactionPayloadEntryFunction(
      aptos_types_exports.EntryFunction.natural(
        "0x1::code",
        "publish_package_txn",
        [],
        [bcsSerializeBytes(packageMetadata), codeSerializer.getBytes()]
      )
    );
    return this.generateSignSubmitTransaction(sender, payload, extraArgs);
  }
  async generateSignSubmitWaitForTransaction(sender, payload, extraArgs) {
    const txnHash = await this.generateSignSubmitTransaction(sender, payload, extraArgs);
    return this.waitForTransactionWithResult(txnHash, extraArgs);
  }
  async estimateGasPrice() {
    return this.client.transactions.estimateGasPrice();
  }
  async estimateMaxGasAmount(forAccount) {
    const typeTag = `0x1::coin::CoinStore<${APTOS_COIN}>`;
    const [{ gas_estimate: gasUnitPrice }, resources] = await Promise.all([
      this.estimateGasPrice(),
      this.getAccountResources(forAccount)
    ]);
    const accountResource = resources.find((r) => r.type === typeTag);
    const balance = BigInt(accountResource.data.coin.value);
    return balance / BigInt(gasUnitPrice);
  }
  async rotateAuthKeyEd25519(forAccount, toPrivateKeyBytes, extraArgs) {
    const { sequence_number: sequenceNumber, authentication_key: authKey } = await this.getAccount(
      forAccount.address()
    );
    const helperAccount = new AptosAccount(toPrivateKeyBytes);
    const challenge = new aptos_types_exports.RotationProofChallenge(
      aptos_types_exports.AccountAddress.CORE_CODE_ADDRESS,
      "account",
      "RotationProofChallenge",
      BigInt(sequenceNumber),
      aptos_types_exports.AccountAddress.fromHex(forAccount.address()),
      new aptos_types_exports.AccountAddress(new HexString(authKey).toUint8Array()),
      helperAccount.pubKey().toUint8Array()
    );
    const challengeHex = HexString.fromUint8Array(bcsToBytes(challenge));
    const proofSignedByCurrentPrivateKey = forAccount.signHexString(challengeHex);
    const proofSignedByNewPrivateKey = helperAccount.signHexString(challengeHex);
    const payload = new aptos_types_exports.TransactionPayloadEntryFunction(
      aptos_types_exports.EntryFunction.natural(
        "0x1::account",
        "rotate_authentication_key",
        [],
        [
          bcsSerializeU8(0),
          bcsSerializeBytes(forAccount.pubKey().toUint8Array()),
          bcsSerializeU8(0),
          bcsSerializeBytes(helperAccount.pubKey().toUint8Array()),
          bcsSerializeBytes(proofSignedByCurrentPrivateKey.toUint8Array()),
          bcsSerializeBytes(proofSignedByNewPrivateKey.toUint8Array())
        ]
      )
    );
    const rawTransaction = await this.generateRawTransaction(forAccount.address(), payload, extraArgs);
    const bcsTxn = _AptosClient.generateBCSTransaction(forAccount, rawTransaction);
    return this.submitSignedBCSTransaction(bcsTxn);
  }
  async lookupOriginalAddress(addressOrAuthKey) {
    const resource = await this.getAccountResource("0x1", "0x1::account::OriginatingAddress");
    const {
      address_map: { handle }
    } = resource.data;
    const origAddress = await this.getTableItem(handle, {
      key_type: "address",
      value_type: "address",
      key: HexString.ensure(addressOrAuthKey).hex()
    });
    return new HexString(origAddress);
  }
  async getBlockByHeight(blockHeight, withTransactions) {
    return this.client.blocks.getBlockByHeight(blockHeight, withTransactions);
  }
  async getBlockByVersion(version, withTransactions) {
    return this.client.blocks.getBlockByVersion(version, withTransactions);
  }
  clearCache(tags) {
    clear(tags);
  }
};
var AptosClient = _AptosClient;
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccount", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccountTransactions", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccountModules", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccountModule", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccountResources", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getAccountResource", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getEventsByCreationNumber", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getEventsByEventHandle", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "submitSignedBCSTransaction", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "submitBCSSimulation", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getTransactions", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getTransactionByHash", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getTransactionByVersion", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getLedgerInfo", 1);
__decorateClass([
  Memoize()
], AptosClient.prototype, "getChainId", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getTableItem", 1);
__decorateClass([
  parseApiError,
  Memoize({
    ttlMs: 5 * 60 * 1e3,
    tags: ["gas_estimates"]
  })
], AptosClient.prototype, "estimateGasPrice", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "estimateMaxGasAmount", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getBlockByHeight", 1);
__decorateClass([
  parseApiError
], AptosClient.prototype, "getBlockByVersion", 1);
var ApiError2 = class extends Error {
  constructor(status, message, errorCode, vmErrorCode) {
    super(message);
    this.status = status;
    this.message = message;
    this.errorCode = errorCode;
    this.vmErrorCode = vmErrorCode;
  }
};
var WaitForTransactionError = class extends Error {
  constructor(message, lastSubmittedTransaction) {
    super(message);
    this.lastSubmittedTransaction = lastSubmittedTransaction;
  }
};
var FailedTransactionError = class extends Error {
  constructor(message, transaction) {
    super(message);
    this.transaction = transaction;
  }
};
function parseApiError(target, propertyKey, descriptor) {
  const childFunction = descriptor.value;
  descriptor.value = async function wrapper(...args) {
    var _a, _b;
    try {
      const res = await childFunction.apply(this, [...args]);
      return res;
    } catch (e) {
      if (e instanceof ApiError) {
        throw new ApiError2(
          e.status,
          JSON.stringify({ message: e.message, ...e.body }),
          (_a = e.body) == null ? void 0 : _a.error_code,
          (_b = e.body) == null ? void 0 : _b.vm_error_code
        );
      }
      throw e;
    }
  };
  return descriptor;
}
function defineName$__$4(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$4 = Symbol.for("#__init__"), $__patch__$$4 = Symbol.for("#__patch__");
class AccountState {
  [$__patch__$$4]($$ = {}) {
    var $12;
    ($12 = $$.address) !== void 0 && (this.address = $12);
    ($12 = $$.resources) !== void 0 && (this.resources = $12);
  }
  [$__init__$$4]($$ = null, deep = true) {
    var $22;
    this.address = $$ ? $$.address : void 0;
    this.resources = $$ && ($22 = $$.resources) !== void 0 ? $22 : {};
  }
  constructor(address) {
    this[$__init__$$4]();
    this.address = address;
  }
  static {
    defineName$__$4(this, "AccountState");
  }
}
function defineName$__$3(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$3 = Symbol.for("#__init__"), $__patch__$$3 = Symbol.for("#__patch__");
class VaultConfig {
  [$__patch__$$3]($$ = {}) {
    var $12;
    ($12 = $$.decimals) !== void 0 && (this.decimals = $12);
    ($12 = $$.max_apr) !== void 0 && (this.max_apr = $12);
    ($12 = $$.min_apr) !== void 0 && (this.min_apr = $12);
    ($12 = $$.target_apr) !== void 0 && (this.target_apr = $12);
    ($12 = $$.target_utilization) !== void 0 && (this.target_utilization = $12);
    ($12 = $$.system_fee) !== void 0 && (this.system_fee = $12);
  }
  [$__init__$$3]($$ = null, deep = true) {
    this.decimals = $$ ? $$.decimals : void 0;
    this.max_apr = $$ ? $$.max_apr : void 0;
    this.min_apr = $$ ? $$.min_apr : void 0;
    this.target_apr = $$ ? $$.target_apr : void 0;
    this.target_utilization = $$ ? $$.target_utilization : void 0;
    this.system_fee = $$ ? $$.system_fee : void 0;
  }
  constructor(data2) {
    this[$__init__$$3]();
    this.decimals = Number(data2.decimals);
    this.max_apr = BigInt(data2.max_apr);
    this.min_apr = BigInt(data2.min_apr);
    this.target_apr = BigInt(data2.target_apr);
    this.target_utilization = BigInt(data2.target_utilization);
    this.system_fee = BigInt(data2.system_fee);
  }
  calc_apr(utilization) {
    if (utilization >= ONE) {
      return this.max_apr;
    } else if (utilization < this.target_utilization) {
      return utilization * (this.target_apr - this.min_apr) / this.target_utilization + this.min_apr;
    } else {
      return (utilization - this.target_utilization) * (this.max_apr - this.target_apr) / (ONE - this.target_utilization) + this.target_apr;
    }
  }
  static {
    defineName$__$3(this, "VaultConfig");
  }
}
function defineName$__$2(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$2 = Symbol.for("#__init__"), $__patch__$$2 = Symbol.for("#__patch__");
class VaultState {
  [$__patch__$$2]($$ = {}) {
    var $12;
    ($12 = $$.config) !== void 0 && (this.config = $12);
    ($12 = $$.coins) !== void 0 && (this.coins = $12);
    ($12 = $$.reserved_coins) !== void 0 && (this.reserved_coins = $12);
    ($12 = $$.total_wcoins) !== void 0 && (this.total_wcoins = $12);
    ($12 = $$.accrued_at) !== void 0 && (this.accrued_at = $12);
    ($12 = $$.scaled_borrowed) !== void 0 && (this.scaled_borrowed = $12);
    ($12 = $$.interest_index) !== void 0 && (this.interest_index = $12);
  }
  [$__init__$$2]($$ = null, deep = true) {
    this.config = $$ ? $$.config : void 0;
    this.coins = $$ ? $$.coins : void 0;
    this.reserved_coins = $$ ? $$.reserved_coins : void 0;
    this.total_wcoins = $$ ? $$.total_wcoins : void 0;
    this.accrued_at = $$ ? $$.accrued_at : void 0;
    this.scaled_borrowed = $$ ? $$.scaled_borrowed : void 0;
    this.interest_index = $$ ? $$.interest_index : void 0;
  }
  constructor(data2) {
    this[$__init__$$2]();
    this.config = new VaultConfig(data2.config);
    this.accrued_at = BigInt(data2.accrued_at);
    this.coins = BigInt(data2.coins);
    this.reserved_coins = BigInt(data2.reserved_coins);
    this.interest_index = BigInt(data2.interest_index);
    this.scaled_borrowed = BigInt(data2.scaled_borrowed);
    this.total_wcoins = BigInt(data2.total_wcoins);
  }
  static {
    defineName$__$2(this, "VaultState");
  }
}
function iter$__(a) {
  let v;
  return a ? (v = a.toIterable) ? v.call(a) : a : a;
}
function defineName$__$1(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$$1 = Symbol.for("#__init__"), $__patch__$$1 = Symbol.for("#__patch__");
class DataLoader {
  [$__patch__$$1]($$ = {}) {
    var $12;
    ($12 = $$.node_url) !== void 0 && (this.node_url = $12);
    ($12 = $$.client) !== void 0 && (this.client = $12);
    ($12 = $$.accounts) !== void 0 && (this.accounts = $12);
    ($12 = $$.jobs) !== void 0 && (this.jobs = $12);
  }
  [$__init__$$1]($$ = null, deep = true) {
    var $22;
    this.node_url = $$ ? $$.node_url : void 0;
    this.client = $$ ? $$.client : void 0;
    this.accounts = $$ && ($22 = $$.accounts) !== void 0 ? $22 : {};
    this.jobs = $$ && ($22 = $$.jobs) !== void 0 ? $22 : {};
  }
  constructor(node_url) {
    this[$__init__$$1]();
    this.node_url = node_url;
    this.client = new AptosClient(node_url);
  }
  async reload_account_state(address) {
    console.debug("Loading account state:", address);
    let resources = await this.client.getAccountResources(address);
    let account_state = new AccountState(address);
    for (let $32 = 0, $4 = iter$__(resources), $5 = $4.length; $32 < $5; $32++) {
      let resource = $4[$32];
      account_state.resources[resource.type] = resource.data;
    }
    return this.accounts[address] = account_state;
  }
  async reload_account_resource(address, res_type) {
    let resource;
    if (resource = await this.client.getAccountResource(address, res_type)) {
      let account_state = this.accounts[address];
      if (!account_state) {
        this.accounts[address] = {
          address,
          resources: {}
        };
      }
      account_state.resources[resource.type] = resource.data;
      return resource;
    } else {
      console.error("Not found", address, res_type);
      return null;
    }
  }
  get_account_state(addr) {
    let account_state;
    let address = addr.toLocaleLowerCase();
    if (account_state = this.accounts[address]) {
      return account_state;
    } else {
      return this.reload_account_state(address);
    }
  }
  async init_oracle(state, oracle_addr) {
    var $6;
    let oracle_state = await this.get_account_state(oracle_addr);
    $6 = [];
    for (let $9 = oracle_state.resources, $7 = 0, $8 = Object.keys($9), $10 = $8.length, type, data2, oracle_store; $7 < $10; $7++) {
      type = $8[$7];
      data2 = $9[type];
      let res = { type, data: data2 };
      $6.push((oracle_store = OracleStore.from_resource(res)) && (state.oracle_store = oracle_store));
    }
    return $6;
  }
  async init_bank(state, bank_addr) {
    var $15;
    let bank_state = await this.get_account_state(bank_addr);
    state.vaults = {};
    for (let $13 = bank_state.resources, $11 = 0, $12 = Object.keys($13), $14 = $12.length, type, data2, coin_info, vault, state_store, _1; $11 < $14; $11++) {
      type = $12[$11];
      data2 = $13[type];
      let res = { type, data: data2 };
      if (coin_info = CoinInfo.from_resource(res)) {
        state.coins[coin_info.coin_type] = coin_info;
      } else if (vault = Vault.from_resource(res)) {
        state.vaults[vault.coin_type] = vault;
      } else if (state_store = StateStore.from_resource(res)) {
        state.vault_state_store = state_store;
      } else if (_1 = CoinStore.from_resource(res))
        ;
      else {
        console.debug("bank other resources", res);
      }
    }
    $15 = [];
    for (let $18 = state.vaults, $16 = 0, $17 = Object.keys($18), $19 = $17.length, coin_type, vault; $16 < $19; $16++) {
      coin_type = $17[$16];
      vault = $18[coin_type];
      $15.push(this.prepare_vault(state, vault));
    }
    let loadings = $15;
    return Promise.allSettled(loadings);
  }
  async prepare_vault(state, vault) {
    let coin_info, oracle;
    let coin_type = vault.coin_type;
    if (coin_info = await this.get_coin_info(state, coin_type)) {
      vault.coin_info = coin_info;
    } else {
      console.error("Fetch CoinInfo failed", coin_type);
    }
    if (state.vault_state_store) {
      this.load_vault_state(state, vault);
    } else {
      console.error("vault::StateStore not found");
    }
    if (state.oracle_store) {
      if (oracle = await this.update_coin_oracle(state, coin_type)) {
        return vault.oracle = oracle;
      }
    } else {
      return console.error("vault::OracleStore not found");
    }
  }
  async load_vault_state(state, vault) {
    let vault_state;
    let type_info = TypeInfo.parse(vault.coin_type);
    if (vault_state = await this.get_table_item(state.vault_state_store.states, type_info)) {
      return vault.vault_state = new VaultState(vault_state);
    }
  }
  async reload_vault_state(state, coin_type) {
    let vault, vault_state;
    if (vault = state.vaults[coin_type]) {
      let type_info = TypeInfo.parse(coin_type);
      if (vault_state = await this.update_table_item(state.vault_state_store.states, type_info)) {
        return vault.vault_state = new VaultState(vault_state);
      }
    }
  }
  async reload_lending_pool(state, coin_type) {
    let pool, res, new_pool;
    if (pool = state.lending_pools[coin_type]) {
      if (res = await this.reload_account_resource(LendingPool.address, LendingPool.type_name(coin_type))) {
        if (new_pool = LendingPool.from_resource(res)) {
          pool.borrow_cap = new_pool.borrow_cap;
          pool.locked_coins = new_pool.locked_coins;
          return pool.total_borrowed = new_pool.total_borrowed;
        }
      }
    }
  }
  async init_lending(state, lending_addr) {
    var $28;
    let lending_state = await this.get_account_state(lending_addr);
    for (let $22 = lending_state.resources, $20 = 0, $21 = Object.keys($22), $23 = $21.length, type, data2, lending_store, lending_pool, lending_config_store; $20 < $23; $20++) {
      type = $21[$20];
      data2 = $22[type];
      let res = { type, data: data2 };
      if (lending_store = LendingStore.from_resource(res)) {
        state.lending_store = lending_store;
      } else if (lending_pool = LendingPool.from_resource(res)) {
        state.lending_pools[lending_pool.coin_type] = lending_pool;
        lending_pool.coin_info = await this.get_coin_info(state, lending_pool.coin_type);
      } else if (lending_config_store = ConfigStore.from_resource(res)) {
        state.lending_config_store = lending_config_store;
      } else {
        console.debug("lending other resources", res);
      }
    }
    for (let $26 = state.lending_pools, $24 = 0, $25 = Object.keys($26), $27 = $25.length, coin_type, pool, vault; $24 < $27; $24++) {
      coin_type = $25[$24];
      pool = $26[coin_type];
      if (vault = state.vaults[coin_type]) {
        pool.vault = vault;
      }
    }
    if (state.lending_config_store) {
      $28 = [];
      for (let $31 = state.lending_pools, $29 = 0, $30 = Object.keys($31), $32 = $30.length, coin_type, pool; $29 < $32; $29++) {
        coin_type = $30[$29];
        pool = $31[coin_type];
        $28.push(this.load_pool_config(state, pool));
      }
      let loadings = $28;
      return Promise.allSettled(loadings);
    }
  }
  async load_pool_config(state, pool) {
    let type_info, config_res;
    if (type_info = TypeInfo.parse(pool.coin_type)) {
      if (config_res = await this.get_table_item(state.lending_config_store.configs, type_info)) {
        return pool.config = new LendingConfig(config_res);
      }
    } else {
      return console.error("parse failed", pool.coin_type);
    }
  }
  async init_user(state, user) {
    var user_addr, user_state, $33;
    if (user_addr = user?.address) {
      state.user = user;
      if (user_state = await this.get_account_state(user_addr)) {
        state.user_coins = {};
        $33 = [];
        for (let $36 = user_state.resources, $34 = 0, $35 = Object.keys($36), $37 = $35.length, type, data2, coin_store, balance; $34 < $37; $34++) {
          type = $35[$34];
          data2 = $36[type];
          let res = { type, data: data2 };
          $33.push((coin_store = CoinStore.from_resource(res)) ? this.set_user_coins(state, coin_store.coin_type, coin_store) : (balance = Balance.from_resource(res)) ? this.set_user_balance(state, balance) : console.debug("others", res));
        }
        return $33;
      }
    } else {
      return console.error("Bad user");
    }
  }
  async reload_user_balance(state) {
    let user_addr, res, balance;
    if (user_addr = state?.user?.address) {
      if (res = await this.reload_account_resource(user_addr, Balance.type_name())) {
        if (balance = Balance.from_resource(res)) {
          return this.set_user_balance(state, balance);
        }
      }
    }
  }
  async reload_user_coin(state, coin_type) {
    let user_addr, res, coin_store;
    if (user_addr = state?.user?.address) {
      if (res = await this.reload_account_resource(user_addr, CoinStore.type_name(coin_type))) {
        if (coin_store = CoinStore.from_resource(res)) {
          return this.set_user_coins(state, coin_type, coin_store);
        }
      }
    }
  }
  async set_user_coins(state, coin_type, coin_store) {
    let old_coin_store, coin_info;
    if (old_coin_store = state.user_coins[coin_type]) {
      old_coin_store.value = coin_store.value;
      return old_coin_store.frozen = coin_store.frozen;
    } else {
      if (coin_info = await this.get_coin_info(state, coin_store.coin_type)) {
        coin_store.coin_info = coin_info;
      }
      return state.user_coins[coin_store.coin_type] = coin_store;
    }
  }
  set_user_balance(state, balance) {
    for (let $38 = 0, $39 = iter$__(balance.assets), $40 = $39.length; $38 < $40; $38++) {
      let asset = $39[$38];
      asset.vault = state.vaults[asset.coin_type];
      asset.pool = state.lending_pools[asset.coin_type];
    }
    for (let $41 = 0, $42 = iter$__(balance.debts), $43 = $42.length; $41 < $43; $41++) {
      let debt = $42[$41];
      debt.vault = state.vaults[debt.coin_type];
      debt.pool = state.lending_pools[debt.coin_type];
    }
    return state.user_balance = balance;
  }
  async update_coin_oracle(state, coin_type) {
    let oracle;
    if (oracle = await this.get_oracle(state, coin_type)) {
      let feed_state = await this.reload_account_state(oracle.feed);
      for (let $46 = feed_state.resources, $44 = 0, $45 = Object.keys($46), $47 = $45.length, type, data2; $44 < $47; $44++) {
        type = $45[$44];
        data2 = $46[type];
        let res = { type, data: data2 };
        if (oracle.load_data(res)) {
          return oracle;
        }
      }
      return oracle;
    }
  }
  async get_oracle(state, coin_type) {
    let oracle, type_info, oracle_res, coin_info;
    if (oracle = state.coin_prices[coin_type]) {
      return oracle;
    } else if (type_info = TypeInfo.parse(coin_type)) {
      if (oracle_res = await this.get_table_item(state.oracle_store.oracles, type_info)) {
        let oracle2 = new Oracle(coin_type, oracle_res);
        state.coin_prices[coin_type] = oracle2;
        if (coin_info = await this.get_coin_info(state, coin_type)) {
          coin_info.oracle = oracle2;
        }
        return oracle2;
      }
    }
  }
  async get_coin_info(state, coin_type) {
    var coin_info, job, t, coin_info1;
    if (coin_info = state.coins[coin_type]) {
      return coin_info;
    } else if (job = this.jobs[coin_type]) {
      return job;
    } else if (t = TypeInfo.parse(coin_type)) {
      let res_type = "0x1::coin::CoinInfo<" + coin_type + ">";
      let job2 = this.fetch_coin_info(t.account_address, res_type);
      this.jobs[coin_type] = job2;
      if (coin_info1 = await job2) {
        state.coins[coin_type] = coin_info1;
        this.jobs[coin_type], delete this.jobs[coin_type];
      }
      return coin_info1;
    } else {
      console.warn("parse", coin_type, "failed");
      return null;
    }
  }
  async fetch_coin_info(account_address, res_type) {
    let res;
    try {
      res = await this.client.getAccountResource(account_address, res_type);
    } catch (e) {
    }
    if (res) {
      return CoinInfo.from_resource(res);
    }
  }
  get_table_item(table, key) {
    let item;
    if (item = table.get_item(key)) {
      return item;
    } else {
      return this.update_table_item(table, key);
    }
  }
  async update_table_item(table, key) {
    var $49;
    try {
      let item = await this.client.getTableItem(table.handle, {
        key_type: table.key_type,
        value_type: table.value_type,
        key: key.encode_key()
      });
      if (item) {
        $49 = item.__headers, delete item.__headers, $49;
        table.data[key.toString()] = item;
        return item;
      }
      ;
    } catch (e) {
      console.debug(e);
      return null;
    }
  }
  async wait_txn(tx_hash) {
    try {
      let tx = await this.client.waitForTransactionWithResult(
        tx_hash,
        { checkSuccess: true }
      );
      console.debug("Tx done:", tx);
      return tx.success;
    } catch (e) {
      console.error(e);
      return false;
    }
  }
  static {
    defineName$__$1(this, "DataLoader");
  }
}
function defineName$__(cls, name) {
  Object.defineProperty(cls, "name", { value: name, configurable: true });
}
const $__init__$ = Symbol.for("#__init__"), $__patch__$ = Symbol.for("#__patch__");
class Actions {
  [$__patch__$]($$ = {}) {
    var $12;
    ($12 = $$.wallet) !== void 0 && (this.wallet = $12);
  }
  constructor($$ = null) {
    this[$__init__$]($$);
  }
  [$__init__$]($$ = null, deep = true) {
    this.wallet = $$ ? $$.wallet : void 0;
  }
  get adapter() {
    return this.wallet || window.aptos;
  }
  set adapter(wallet_adapter) {
    this.wallet = wallet_adapter;
  }
  async call_entry(func, type_args = [], args = []) {
    console.debug("calling", func, type_args, args);
    let pending_tx = await this.adapter.signAndSubmitTransaction({
      type: "entry_function_payload",
      function: func,
      type_arguments: type_args,
      arguments: args
    });
    console.debug("Tx sent:", pending_tx);
    return pending_tx;
  }
  vault_wrap_coin(coin_type, amount) {
    return this.call_entry(
      "" + cfg.BANK + "::periphery::wrap",
      [coin_type],
      [amount.toString()]
    );
  }
  vault_unwrap_coin(coin_type, amount) {
    return this.call_entry(
      "" + cfg.BANK + "::periphery::unwrap",
      [coin_type],
      [amount.toString()]
    );
  }
  lending_open_account() {
    return this.call_entry(
      "" + cfg.LENDING + "::periphery::open_account"
    );
  }
  lending_pledge(coin_type, amount) {
    return this.call_entry(
      "" + cfg.LENDING + "::periphery::pledge",
      [coin_type],
      [amount.toString()]
    );
  }
  async lending_borrow(coin_type, amount) {
    return await this.call_entry(
      "" + cfg.LENDING + "::periphery::borrow",
      [coin_type],
      [amount.toString()]
    );
  }
  lending_redeem(coin_type, amount) {
    return this.call_entry(
      "" + cfg.LENDING + "::periphery::redeem",
      [coin_type],
      [amount.toString()]
    );
  }
  lending_redeem_all(coin_type) {
    return this.call_entry(
      "" + cfg.LENDING + "::periphery::redeem_all",
      [coin_type],
      []
    );
  }
  lending_repay(coin_type, amount) {
    return this.call_entry(
      "" + cfg.LENDING + "::periphery::repay",
      [coin_type],
      [amount.toString()]
    );
  }
  lending_repay_all(coin_type) {
    return this.call_entry(
      "" + cfg.LENDING + "::periphery::repay_all",
      [coin_type],
      []
    );
  }
  static {
    defineName$__(this, "Actions");
  }
}
export {
  AccountState,
  Actions,
  AppState,
  Balance,
  BalanceDelta,
  BorrowCap,
  CoinInfo,
  CoinStore,
  ConfigStore,
  DataLoader,
  ENV,
  LedgerInfo,
  LendingConfig,
  LendingPool,
  LendingStore,
  Oracle,
  OracleStore,
  StateStore,
  Table,
  TypeInfo,
  Vault,
  VaultConfig,
  VaultState,
  cfg as config
};
